/*! For license information please see index.bundle.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.egmaps = t() : e.egmaps = t();
}("undefined" != typeof window ? window : global, function () {
  return function () {
    var e = {
        10: function (e, t, i) {
          "use strict";

          e.exports = n;
          var r = i(328);
          function n(e) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(e) ? e : new Uint8Array(e || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
          }
          n.Varint = 0, n.Fixed64 = 1, n.Bytes = 2, n.Fixed32 = 5;
          var s = 4294967296,
            o = 1 / s,
            a = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
          function l(e) {
            return e.type === n.Bytes ? e.readVarint() + e.pos : e.pos + 1;
          }
          function u(e, t, i) {
            return i ? 4294967296 * t + (e >>> 0) : 4294967296 * (t >>> 0) + (e >>> 0);
          }
          function h(e, t, i) {
            var r = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
            i.realloc(r);
            for (var n = i.pos - 1; n >= e; n--) i.buf[n + r] = i.buf[n];
          }
          function d(e, t) {
            for (var i = 0; i < e.length; i++) t.writeVarint(e[i]);
          }
          function c(e, t) {
            for (var i = 0; i < e.length; i++) t.writeSVarint(e[i]);
          }
          function p(e, t) {
            for (var i = 0; i < e.length; i++) t.writeFloat(e[i]);
          }
          function f(e, t) {
            for (var i = 0; i < e.length; i++) t.writeDouble(e[i]);
          }
          function g(e, t) {
            for (var i = 0; i < e.length; i++) t.writeBoolean(e[i]);
          }
          function m(e, t) {
            for (var i = 0; i < e.length; i++) t.writeFixed32(e[i]);
          }
          function y(e, t) {
            for (var i = 0; i < e.length; i++) t.writeSFixed32(e[i]);
          }
          function v(e, t) {
            for (var i = 0; i < e.length; i++) t.writeFixed64(e[i]);
          }
          function b(e, t) {
            for (var i = 0; i < e.length; i++) t.writeSFixed64(e[i]);
          }
          function k(e, t) {
            return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + 16777216 * e[t + 3];
          }
          function M(e, t, i) {
            e[i] = t, e[i + 1] = t >>> 8, e[i + 2] = t >>> 16, e[i + 3] = t >>> 24;
          }
          function C(e, t) {
            return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + (e[t + 3] << 24);
          }
          n.prototype = {
            destroy: function () {
              this.buf = null;
            },
            readFields: function (e, t, i) {
              for (i = i || this.length; this.pos < i;) {
                var r = this.readVarint(),
                  n = r >> 3,
                  s = this.pos;
                this.type = 7 & r, e(n, t, this), this.pos === s && this.skip(r);
              }
              return t;
            },
            readMessage: function (e, t) {
              return this.readFields(e, t, this.readVarint() + this.pos);
            },
            readFixed32: function () {
              var e = k(this.buf, this.pos);
              return this.pos += 4, e;
            },
            readSFixed32: function () {
              var e = C(this.buf, this.pos);
              return this.pos += 4, e;
            },
            readFixed64: function () {
              var e = k(this.buf, this.pos) + k(this.buf, this.pos + 4) * s;
              return this.pos += 8, e;
            },
            readSFixed64: function () {
              var e = k(this.buf, this.pos) + C(this.buf, this.pos + 4) * s;
              return this.pos += 8, e;
            },
            readFloat: function () {
              var e = r.read(this.buf, this.pos, !0, 23, 4);
              return this.pos += 4, e;
            },
            readDouble: function () {
              var e = r.read(this.buf, this.pos, !0, 52, 8);
              return this.pos += 8, e;
            },
            readVarint: function (e) {
              var t,
                i,
                r = this.buf;
              return t = 127 & (i = r[this.pos++]), i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 7, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 14, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 21, i < 128 ? t : function (e, t, i) {
                var r,
                  n,
                  s = i.buf;
                if (n = s[i.pos++], r = (112 & n) >> 4, n < 128) return u(e, r, t);
                if (n = s[i.pos++], r |= (127 & n) << 3, n < 128) return u(e, r, t);
                if (n = s[i.pos++], r |= (127 & n) << 10, n < 128) return u(e, r, t);
                if (n = s[i.pos++], r |= (127 & n) << 17, n < 128) return u(e, r, t);
                if (n = s[i.pos++], r |= (127 & n) << 24, n < 128) return u(e, r, t);
                if (n = s[i.pos++], r |= (1 & n) << 31, n < 128) return u(e, r, t);
                throw new Error("Expected varint not more than 10 bytes");
              }(t |= (15 & (i = r[this.pos])) << 28, e, this))));
            },
            readVarint64: function () {
              return this.readVarint(!0);
            },
            readSVarint: function () {
              var e = this.readVarint();
              return e % 2 == 1 ? (e + 1) / -2 : e / 2;
            },
            readBoolean: function () {
              return Boolean(this.readVarint());
            },
            readString: function () {
              var e = this.readVarint() + this.pos,
                t = this.pos;
              return this.pos = e, e - t >= 12 && a ? function (e, t, i) {
                return a.decode(e.subarray(t, i));
              }(this.buf, t, e) : function (e, t, i) {
                var r = "",
                  n = t;
                for (; n < i;) {
                  var s,
                    o,
                    a,
                    l = e[n],
                    u = null,
                    h = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                  if (n + h > i) break;
                  1 === h ? l < 128 && (u = l) : 2 === h ? 128 == (192 & (s = e[n + 1])) && (u = (31 & l) << 6 | 63 & s) <= 127 && (u = null) : 3 === h ? (s = e[n + 1], o = e[n + 2], 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 12 | (63 & s) << 6 | 63 & o) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === h && (s = e[n + 1], o = e[n + 2], a = e[n + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && ((u = (15 & l) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, r += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), r += String.fromCharCode(u), n += h;
                }
                return r;
              }(this.buf, t, e);
            },
            readBytes: function () {
              var e = this.readVarint() + this.pos,
                t = this.buf.subarray(this.pos, e);
              return this.pos = e, t;
            },
            readPackedVarint: function (e, t) {
              if (this.type !== n.Bytes) return e.push(this.readVarint(t));
              var i = l(this);
              for (e = e || []; this.pos < i;) e.push(this.readVarint(t));
              return e;
            },
            readPackedSVarint: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readSVarint());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readSVarint());
              return e;
            },
            readPackedBoolean: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readBoolean());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readBoolean());
              return e;
            },
            readPackedFloat: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readFloat());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readFloat());
              return e;
            },
            readPackedDouble: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readDouble());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readDouble());
              return e;
            },
            readPackedFixed32: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readFixed32());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readFixed32());
              return e;
            },
            readPackedSFixed32: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readSFixed32());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readSFixed32());
              return e;
            },
            readPackedFixed64: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readFixed64());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readFixed64());
              return e;
            },
            readPackedSFixed64: function (e) {
              if (this.type !== n.Bytes) return e.push(this.readSFixed64());
              var t = l(this);
              for (e = e || []; this.pos < t;) e.push(this.readSFixed64());
              return e;
            },
            skip: function (e) {
              var t = 7 & e;
              if (t === n.Varint) for (; this.buf[this.pos++] > 127;);else if (t === n.Bytes) this.pos = this.readVarint() + this.pos;else if (t === n.Fixed32) this.pos += 4;else {
                if (t !== n.Fixed64) throw new Error("Unimplemented type: " + t);
                this.pos += 8;
              }
            },
            writeTag: function (e, t) {
              this.writeVarint(e << 3 | t);
            },
            realloc: function (e) {
              for (var t = this.length || 16; t < this.pos + e;) t *= 2;
              if (t !== this.length) {
                var i = new Uint8Array(t);
                i.set(this.buf), this.buf = i, this.length = t;
              }
            },
            finish: function () {
              return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function (e) {
              this.realloc(4), M(this.buf, e, this.pos), this.pos += 4;
            },
            writeSFixed32: function (e) {
              this.realloc(4), M(this.buf, e, this.pos), this.pos += 4;
            },
            writeFixed64: function (e) {
              this.realloc(8), M(this.buf, -1 & e, this.pos), M(this.buf, Math.floor(e * o), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function (e) {
              this.realloc(8), M(this.buf, -1 & e, this.pos), M(this.buf, Math.floor(e * o), this.pos + 4), this.pos += 8;
            },
            writeVarint: function (e) {
              (e = +e || 0) > 268435455 || e < 0 ? function (e, t) {
                var i, r;
                e >= 0 ? (i = e % 4294967296 | 0, r = e / 4294967296 | 0) : (r = ~(-e / 4294967296), 4294967295 ^ (i = ~(-e % 4294967296)) ? i = i + 1 | 0 : (i = 0, r = r + 1 | 0));
                if (e >= 0x10000000000000000 || e < -0x10000000000000000) throw new Error("Given varint doesn't fit into 10 bytes");
                t.realloc(10), function (e, t, i) {
                  i.buf[i.pos++] = 127 & e | 128, e >>>= 7, i.buf[i.pos++] = 127 & e | 128, e >>>= 7, i.buf[i.pos++] = 127 & e | 128, e >>>= 7, i.buf[i.pos++] = 127 & e | 128, e >>>= 7, i.buf[i.pos] = 127 & e;
                }(i, 0, t), function (e, t) {
                  var i = (7 & e) << 4;
                  if (t.buf[t.pos++] |= i | ((e >>>= 3) ? 128 : 0), !e) return;
                  if (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), !e) return;
                  if (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), !e) return;
                  if (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), !e) return;
                  if (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), !e) return;
                  t.buf[t.pos++] = 127 & e;
                }(r, t);
              }(e, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = e >>> 7 & 127))));
            },
            writeSVarint: function (e) {
              this.writeVarint(e < 0 ? 2 * -e - 1 : 2 * e);
            },
            writeBoolean: function (e) {
              this.writeVarint(Boolean(e));
            },
            writeString: function (e) {
              e = String(e), this.realloc(4 * e.length), this.pos++;
              var t = this.pos;
              this.pos = function (e, t, i) {
                for (var r, n, s = 0; s < t.length; s++) {
                  if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
                    if (!n) {
                      r > 56319 || s + 1 === t.length ? (e[i++] = 239, e[i++] = 191, e[i++] = 189) : n = r;
                      continue;
                    }
                    if (r < 56320) {
                      e[i++] = 239, e[i++] = 191, e[i++] = 189, n = r;
                      continue;
                    }
                    r = n - 55296 << 10 | r - 56320 | 65536, n = null;
                  } else n && (e[i++] = 239, e[i++] = 191, e[i++] = 189, n = null);
                  r < 128 ? e[i++] = r : (r < 2048 ? e[i++] = r >> 6 | 192 : (r < 65536 ? e[i++] = r >> 12 | 224 : (e[i++] = r >> 18 | 240, e[i++] = r >> 12 & 63 | 128), e[i++] = r >> 6 & 63 | 128), e[i++] = 63 & r | 128);
                }
                return i;
              }(this.buf, e, this.pos);
              var i = this.pos - t;
              i >= 128 && h(t, i, this), this.pos = t - 1, this.writeVarint(i), this.pos += i;
            },
            writeFloat: function (e) {
              this.realloc(4), r.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function (e) {
              this.realloc(8), r.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function (e) {
              var t = e.length;
              this.writeVarint(t), this.realloc(t);
              for (var i = 0; i < t; i++) this.buf[this.pos++] = e[i];
            },
            writeRawMessage: function (e, t) {
              this.pos++;
              var i = this.pos;
              e(t, this);
              var r = this.pos - i;
              r >= 128 && h(i, r, this), this.pos = i - 1, this.writeVarint(r), this.pos += r;
            },
            writeMessage: function (e, t, i) {
              this.writeTag(e, n.Bytes), this.writeRawMessage(t, i);
            },
            writePackedVarint: function (e, t) {
              t.length && this.writeMessage(e, d, t);
            },
            writePackedSVarint: function (e, t) {
              t.length && this.writeMessage(e, c, t);
            },
            writePackedBoolean: function (e, t) {
              t.length && this.writeMessage(e, g, t);
            },
            writePackedFloat: function (e, t) {
              t.length && this.writeMessage(e, p, t);
            },
            writePackedDouble: function (e, t) {
              t.length && this.writeMessage(e, f, t);
            },
            writePackedFixed32: function (e, t) {
              t.length && this.writeMessage(e, m, t);
            },
            writePackedSFixed32: function (e, t) {
              t.length && this.writeMessage(e, y, t);
            },
            writePackedFixed64: function (e, t) {
              t.length && this.writeMessage(e, v, t);
            },
            writePackedSFixed64: function (e, t) {
              t.length && this.writeMessage(e, b, t);
            },
            writeBytesField: function (e, t) {
              this.writeTag(e, n.Bytes), this.writeBytes(t);
            },
            writeFixed32Field: function (e, t) {
              this.writeTag(e, n.Fixed32), this.writeFixed32(t);
            },
            writeSFixed32Field: function (e, t) {
              this.writeTag(e, n.Fixed32), this.writeSFixed32(t);
            },
            writeFixed64Field: function (e, t) {
              this.writeTag(e, n.Fixed64), this.writeFixed64(t);
            },
            writeSFixed64Field: function (e, t) {
              this.writeTag(e, n.Fixed64), this.writeSFixed64(t);
            },
            writeVarintField: function (e, t) {
              this.writeTag(e, n.Varint), this.writeVarint(t);
            },
            writeSVarintField: function (e, t) {
              this.writeTag(e, n.Varint), this.writeSVarint(t);
            },
            writeStringField: function (e, t) {
              this.writeTag(e, n.Bytes), this.writeString(t);
            },
            writeFloatField: function (e, t) {
              this.writeTag(e, n.Fixed32), this.writeFloat(t);
            },
            writeDoubleField: function (e, t) {
              this.writeTag(e, n.Fixed64), this.writeDouble(t);
            },
            writeBooleanField: function (e, t) {
              this.writeVarintField(e, Boolean(t));
            }
          };
        },
        125: function (e, t, i) {
          e.exports = function () {
            "use strict";

            var e = {
                315: function (e, t) {
                  var i = t.N = {};
                  i.read = function (e, t) {
                    return e.readFields(i._readField, {
                      dictionary: void 0,
                      content: void 0
                    }, t);
                  }, i._readField = function (e, t, r) {
                    1 === e ? t.dictionary = i.Dictionary.read(r, r.readVarint() + r.pos) : 2 === e && (t.content = i.Content.read(r, r.readVarint() + r.pos));
                  }, i.Dictionary = {}, i.Dictionary.read = function (e, t) {
                    return e.readFields(i.Dictionary._readField, {
                      constants: []
                    }, t);
                  }, i.Dictionary._readField = function (e, t, i) {
                    1 === e && t.constants.push(i.readString());
                  }, i.Feature = {}, i.Feature.read = function (e, t) {
                    return e.readFields(i.Feature._readField, {
                      type: 0,
                      id: "",
                      latitude: 0,
                      longitude: 0,
                      name: "",
                      classifiers: [],
                      score: 0
                    }, t);
                  }, i.Feature._readField = function (e, t, i) {
                    1 === e ? t.type = i.readVarint() : 2 === e ? t.id = i.readString() : 3 === e ? t.latitude = i.readVarint(!0) : 4 === e ? t.longitude = i.readVarint(!0) : 5 === e ? t.name = i.readString() : 6 === e ? i.readPackedVarint(t.classifiers, !0) : 7 === e && (t.score = i.readVarint(!0));
                  }, i.Feature.Type = {
                    UNKNOWN: 0,
                    PLACE: 1,
                    PRODUCT: 2
                  }, i.Content = {}, i.Content.read = function (e, t) {
                    return e.readFields(i.Content._readField, {
                      features: []
                    }, t);
                  }, i.Content._readField = function (e, t, r) {
                    1 === e && t.features.push(i.Feature.read(r, r.readVarint() + r.pos));
                  };
                }
              },
              t = {};
            function r(i) {
              var n = t[i];
              if (void 0 !== n) return n.exports;
              var s = t[i] = {
                exports: {}
              };
              return e[i](s, s.exports, r), s.exports;
            }
            r.n = function (e) {
              var t = e && e.__esModule ? function () {
                return e.default;
              } : function () {
                return e;
              };
              return r.d(t, {
                a: t
              }), t;
            }, r.d = function (e, t) {
              for (var i in t) r.o(t, i) && !r.o(e, i) && Object.defineProperty(e, i, {
                enumerable: !0,
                get: t[i]
              });
            }, r.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }, r.r = function (e) {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(e, "__esModule", {
                value: !0
              });
            };
            var n = {};
            r.r(n), r.d(n, {
              EGTSCodec: function () {
                return p;
              }
            });
            var s = i(10),
              o = r.n(s),
              a = r(315);
            function l(e) {
              return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                return typeof e;
              } : function (e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
              }, l(e);
            }
            function u(e, t) {
              var i = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
              if (!i) {
                if (Array.isArray(e) || (i = function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return h(e, t);
                    var i = {}.toString.call(e).slice(8, -1);
                    return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? h(e, t) : void 0;
                  }
                }(e)) || t && e && "number" == typeof e.length) {
                  i && (e = i);
                  var r = 0,
                    n = function () {};
                  return {
                    s: n,
                    n: function () {
                      return r >= e.length ? {
                        done: !0
                      } : {
                        done: !1,
                        value: e[r++]
                      };
                    },
                    e: function (e) {
                      throw e;
                    },
                    f: n
                  };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }
              var s,
                o = !0,
                a = !1;
              return {
                s: function () {
                  i = i.call(e);
                },
                n: function () {
                  var e = i.next();
                  return o = e.done, e;
                },
                e: function (e) {
                  a = !0, s = e;
                },
                f: function () {
                  try {
                    o || null == i.return || i.return();
                  } finally {
                    if (a) throw s;
                  }
                }
              };
            }
            function h(e, t) {
              (null == t || t > e.length) && (t = e.length);
              for (var i = 0, r = Array(t); i < t; i++) r[i] = e[i];
              return r;
            }
            function d(e, t) {
              for (var i = 0; i < t.length; i++) {
                var r = t[i];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, c(r.key), r);
              }
            }
            function c(e) {
              var t = function (e, t) {
                if ("object" != l(e) || !e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var r = i.call(e, t || "default");
                  if ("object" != l(r)) return r;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
              }(e, "string");
              return "symbol" == l(t) ? t : t + "";
            }
            var p = function () {
              return e = function e() {
                !function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e);
              }, (t = [{
                key: "decode",
                value: function (e) {
                  var t = this;
                  return new Promise(function (i) {
                    var r,
                      n = new (o())(e),
                      s = a.N.read(n),
                      l = [],
                      h = u(s.content.features);
                    try {
                      for (h.s(); !(r = h.n()).done;) {
                        var d = r.value;
                        l.push({
                          id: d.id,
                          type: t._getType(d.type),
                          lat: d.latitude / 1e6 - 90,
                          lng: d.longitude / 1e6 - 180,
                          name: d.name,
                          qualifiers: d.classifiers.map(function (e) {
                            return s.dictionary.constants[e];
                          }),
                          score: d.score / 1e4
                        });
                      }
                    } catch (e) {
                      h.e(e);
                    } finally {
                      h.f();
                    }
                    i(l);
                  });
                }
              }, {
                key: "_getType",
                value: function (e) {
                  for (var t in a.N.Feature.Type) if (a.N.Feature.Type[t] === e) return t.toLowerCase();
                }
              }]) && d(e.prototype, t), i && d(e, i), Object.defineProperty(e, "prototype", {
                writable: !1
              }), e;
              var e, t, i;
            }();
            return n;
          }();
        },
        328: function (e, t) {
          t.read = function (e, t, i, r, n) {
            var s,
              o,
              a = 8 * n - r - 1,
              l = (1 << a) - 1,
              u = l >> 1,
              h = -7,
              d = i ? n - 1 : 0,
              c = i ? -1 : 1,
              p = e[t + d];
            for (d += c, s = p & (1 << -h) - 1, p >>= -h, h += a; h > 0; s = 256 * s + e[t + d], d += c, h -= 8);
            for (o = s & (1 << -h) - 1, s >>= -h, h += r; h > 0; o = 256 * o + e[t + d], d += c, h -= 8);
            if (0 === s) s = 1 - u;else {
              if (s === l) return o ? NaN : 1 / 0 * (p ? -1 : 1);
              o += Math.pow(2, r), s -= u;
            }
            return (p ? -1 : 1) * o * Math.pow(2, s - r);
          }, t.write = function (e, t, i, r, n, s) {
            var o,
              a,
              l,
              u = 8 * s - n - 1,
              h = (1 << u) - 1,
              d = h >> 1,
              c = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              p = r ? 0 : s - 1,
              f = r ? 1 : -1,
              g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
            for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = h) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + d >= 1 ? c / l : c * Math.pow(2, 1 - d)) * l >= 2 && (o++, l /= 2), o + d >= h ? (a = 0, o = h) : o + d >= 1 ? (a = (t * l - 1) * Math.pow(2, n), o += d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, n), o = 0)); n >= 8; e[i + p] = 255 & a, p += f, a /= 256, n -= 8);
            for (o = o << n | a, u += n; u > 0; e[i + p] = 255 & o, p += f, o /= 256, u -= 8);
            e[i + p - f] |= 128 * g;
          };
        },
        569: function (e) {
          !function () {
            "use strict";

            var t = function (e) {
                return (e = "number" == typeof e ? {
                  precision: e
                } : e || {}).precision = e.precision || 5, e.factor = e.factor || Math.pow(10, e.precision), e.dimension = e.dimension || 2, e;
              },
              i = {
                encode: function (e, i) {
                  i = t(i);
                  for (var r = [], n = 0, s = e.length; n < s; ++n) {
                    var o = e[n];
                    if (2 === i.dimension) r.push(o.lat || o[0]), r.push(o.lng || o[1]);else for (var a = 0; a < i.dimension; ++a) r.push(o[a]);
                  }
                  return this.encodeDeltas(r, i);
                },
                decode: function (e, i) {
                  i = t(i);
                  for (var r = this.decodeDeltas(e, i), n = [], s = 0, o = r.length; s + (i.dimension - 1) < o;) {
                    for (var a = [], l = 0; l < i.dimension; ++l) a.push(r[s++]);
                    n.push(a);
                  }
                  return n;
                },
                encodeDeltas: function (e, i) {
                  i = t(i);
                  for (var r = [], n = 0, s = e.length; n < s;) for (var o = 0; o < i.dimension; ++o, ++n) {
                    var a = e[n].toFixed(i.precision),
                      l = a - (r[o] || 0);
                    r[o] = a, e[n] = l;
                  }
                  return this.encodeFloats(e, i);
                },
                decodeDeltas: function (e, i) {
                  i = t(i);
                  for (var r = [], n = this.decodeFloats(e, i), s = 0, o = n.length; s < o;) for (var a = 0; a < i.dimension; ++a, ++s) n[s] = Math.round((r[a] = n[s] + (r[a] || 0)) * i.factor) / i.factor;
                  return n;
                },
                encodeFloats: function (e, i) {
                  i = t(i);
                  for (var r = 0, n = e.length; r < n; ++r) e[r] = Math.round(e[r] * i.factor);
                  return this.encodeSignedIntegers(e);
                },
                decodeFloats: function (e, i) {
                  i = t(i);
                  for (var r = this.decodeSignedIntegers(e), n = 0, s = r.length; n < s; ++n) r[n] /= i.factor;
                  return r;
                },
                encodeSignedIntegers: function (e) {
                  for (var t = 0, i = e.length; t < i; ++t) {
                    var r = e[t];
                    e[t] = r < 0 ? ~(r << 1) : r << 1;
                  }
                  return this.encodeUnsignedIntegers(e);
                },
                decodeSignedIntegers: function (e) {
                  for (var t = this.decodeUnsignedIntegers(e), i = 0, r = t.length; i < r; ++i) {
                    var n = t[i];
                    t[i] = 1 & n ? ~(n >> 1) : n >> 1;
                  }
                  return t;
                },
                encodeUnsignedIntegers: function (e) {
                  for (var t = "", i = 0, r = e.length; i < r; ++i) t += this.encodeUnsignedInteger(e[i]);
                  return t;
                },
                decodeUnsignedIntegers: function (e) {
                  for (var t = [], i = 0, r = 0, n = 0, s = e.length; n < s; ++n) {
                    var o = e.charCodeAt(n) - 63;
                    i |= (31 & o) << r, o < 32 ? (t.push(i), i = 0, r = 0) : r += 5;
                  }
                  return t;
                },
                encodeSignedInteger: function (e) {
                  return e = e < 0 ? ~(e << 1) : e << 1, this.encodeUnsignedInteger(e);
                },
                encodeUnsignedInteger: function (e) {
                  for (var t, i = ""; e >= 32;) t = 63 + (32 | 31 & e), i += String.fromCharCode(t), e >>= 5;
                  return t = e + 63, i += String.fromCharCode(t);
                }
              };
            if ("object" == typeof e.exports && (e.exports = i), "object" == typeof L) {
              L.Polyline.prototype.fromEncoded || (L.Polyline.fromEncoded = function (e, t) {
                return L.polyline(i.decode(e), t);
              }), L.Polygon.prototype.fromEncoded || (L.Polygon.fromEncoded = function (e, t) {
                return L.polygon(i.decode(e), t);
              });
              var r = {
                encodePath: function () {
                  return i.encode(this.getLatLngs());
                }
              };
              L.Polyline.prototype.encodePath || L.Polyline.include(r), L.Polygon.prototype.encodePath || L.Polygon.include(r), L.PolylineUtil = i;
            }
          }();
        },
        801: function () {},
        908: function (e) {
          e.exports = function () {
            function e(s, o) {
              if (!(this instanceof e)) return new e(s, o);
              o = Object.assign({}, i, o);
              var a = Math.pow(10, o.precision);
              this.intValue = s = t(s, o), this.value = s / a, o.increment = o.increment || 1 / a, o.groups = o.useVedic ? n : r, this.s = o, this.p = a;
            }
            function t(t, i) {
              var r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2],
                n = i.decimal,
                s = i.errorOnInvalid,
                o = i.fromCents,
                a = Math.pow(10, i.precision),
                l = t instanceof e;
              if (l && o) return t.intValue;
              if ("number" == typeof t || l) n = l ? t.value : t;else if ("string" == typeof t) s = new RegExp("[^-\\d" + n + "]", "g"), n = new RegExp("\\" + n, "g"), n = (n = t.replace(/\((.*)\)/, "-$1").replace(s, "").replace(n, ".")) || 0;else {
                if (s) throw Error("Invalid Input");
                n = 0;
              }
              return o || (n = (n * a).toFixed(4)), r ? Math.round(n) : n;
            }
            var i = {
                symbol: "$",
                separator: ",",
                decimal: ".",
                errorOnInvalid: !1,
                precision: 2,
                pattern: "!#",
                negativePattern: "-!#",
                format: function (e, t) {
                  var i = t.pattern,
                    r = t.negativePattern,
                    n = t.symbol,
                    s = t.separator,
                    o = t.decimal;
                  t = t.groups;
                  var a = ("" + e).replace(/^-/, "").split("."),
                    l = a[0];
                  return a = a[1], (0 <= e.value ? i : r).replace("!", n).replace("#", l.replace(t, "$1" + s) + (a ? o + a : ""));
                },
                fromCents: !1
              },
              r = /(\d)(?=(\d{3})+\b)/g,
              n = /(\d)(?=(\d\d)+\d\b)/g;
            return e.prototype = {
              add: function (i) {
                var r = this.s,
                  n = this.p;
                return e((this.intValue + t(i, r)) / (r.fromCents ? 1 : n), r);
              },
              subtract: function (i) {
                var r = this.s,
                  n = this.p;
                return e((this.intValue - t(i, r)) / (r.fromCents ? 1 : n), r);
              },
              multiply: function (t) {
                var i = this.s;
                return e(this.intValue * t / (i.fromCents ? 1 : Math.pow(10, i.precision)), i);
              },
              divide: function (i) {
                var r = this.s;
                return e(this.intValue / t(i, r, !1), r);
              },
              distribute: function (t) {
                var i = this.intValue,
                  r = this.p,
                  n = this.s,
                  s = [],
                  o = Math[0 <= i ? "floor" : "ceil"](i / t),
                  a = Math.abs(i - o * t);
                for (r = n.fromCents ? 1 : r; 0 !== t; t--) {
                  var l = e(o / r, n);
                  0 < a-- && (l = l[0 <= i ? "add" : "subtract"](1 / r)), s.push(l);
                }
                return s;
              },
              dollars: function () {
                return ~~this.value;
              },
              cents: function () {
                return ~~(this.intValue % this.p);
              },
              format: function (e) {
                var t = this.s;
                return "function" == typeof e ? e(this, t) : t.format(this, Object.assign({}, t, e));
              },
              toString: function () {
                var e = this.s,
                  t = e.increment;
                return (Math.round(this.intValue / this.p / t) * t).toFixed(e.precision);
              },
              toJSON: function () {
                return this.value;
              }
            }, e;
          }();
        }
      },
      t = {};
    function i(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var s = t[r] = {
        exports: {}
      };
      return e[r].call(s.exports, s, s.exports, i), s.exports;
    }
    i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return i.d(t, {
        a: t
      }), t;
    }, i.d = function (e, t) {
      for (var r in t) i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, i.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    }(), i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      i.r(r), i.d(r, {
        Animation: function () {
          return s;
        },
        BaseMap: function () {
          return ho;
        },
        BrowserUtils: function () {
          return n;
        },
        Cache: function () {
          return Ai;
        },
        ConfigHelper: function () {
          return Gs;
        },
        ConfigLoader: function () {
          return Di;
        },
        ConsoleLogger: function () {
          return Ci;
        },
        ContentProviderService: function () {
          return Qr;
        },
        ContentProvidersManager: function () {
          return tn;
        },
        EGMap: function () {
          return Co;
        },
        EventTypes: function () {
          return dr;
        },
        EventsManager: function () {
          return cr;
        },
        Geo: function () {
          return o;
        },
        HtmlUtils: function () {
          return e;
        },
        I18n: function () {
          return Bi;
        },
        IconUtils: function () {
          return a;
        },
        InternalQualifiers: function () {
          return ar;
        },
        KeyboardFeatures: function () {
          return Tr;
        },
        KeyboardListeners: function () {
          return qr;
        },
        Labels: function () {
          return l;
        },
        Level: function () {
          return bi;
        },
        Logger: function () {
          return Mi;
        },
        MarkerUtils: function () {
          return u;
        },
        TilesLoader: function () {
          return Mo;
        },
        Utils: function () {
          return t;
        },
        contentProvidersBuilder: function () {
          return en;
        },
        debugOptions: function () {
          return Ii;
        },
        defaultConfig: function () {
          return go;
        },
        defaultIcons: function () {
          return co;
        },
        i18nKeys: function () {
          return kr;
        },
        icons: function () {
          return co;
        },
        identifyUpdates: function () {
          return Xs;
        },
        newLogger: function () {
          return ki;
        },
        newMapData: function () {
          return uo;
        },
        ttlCache: function () {
          return Vi;
        }
      });
      var e = {};
      i.r(e), i.d(e, {
        addClass: function () {
          return tt;
        },
        addClasses: function () {
          return it;
        },
        addNewCssStyle: function () {
          return ht;
        },
        anyChildrenMatching: function () {
          return ue;
        },
        anyChildrenWithAriaRoleDescription: function () {
          return oe;
        },
        anyChildrenWithClasses: function () {
          return ne;
        },
        changeImgSrc: function () {
          return Ue;
        },
        changeSpanTextContent: function () {
          return X;
        },
        changeStyles: function () {
          return Ke;
        },
        changeTextNodeContent: function () {
          return Y;
        },
        childNodesAsArray: function () {
          return te;
        },
        childrenAsArray: function () {
          return ee;
        },
        clearAriaLabel: function () {
          return qe;
        },
        clearStyle: function () {
          return lt;
        },
        createButton: function () {
          return ke;
        },
        createCheckbox: function () {
          return xe;
        },
        createDiv: function () {
          return me;
        },
        createH1: function () {
          return Ce;
        },
        createH2: function () {
          return we;
        },
        createHtml: function () {
          return W;
        },
        createImg: function () {
          return Pe;
        },
        createInput: function () {
          return ge;
        },
        createLabel: function () {
          return be;
        },
        createLi: function () {
          return ve;
        },
        createSpan: function () {
          return Me;
        },
        createTextNode: function () {
          return G;
        },
        createUl: function () {
          return ye;
        },
        detachElement: function () {
          return pe;
        },
        documentIsDefined: function () {
          return J;
        },
        eltAsString: function () {
          return q;
        },
        eltHashCode: function () {
          return Q;
        },
        findChildIndex: function () {
          return le;
        },
        getClasses: function () {
          return et;
        },
        getComponentSize: function () {
          return dt;
        },
        getComponentSizeFromOffscreenRendering: function () {
          return ct;
        },
        getFirstChildWithAriaRoleDescription: function () {
          return ae;
        },
        getFirstChildWithClasses: function () {
          return se;
        },
        getTagName: function () {
          return Be;
        },
        globalObject: function () {
          return pt;
        },
        hasAriaLabel: function () {
          return Le;
        },
        hasClass: function () {
          return Ge;
        },
        insertChild: function () {
          return ut;
        },
        inverseClass: function () {
          return Xe;
        },
        isAnHtmlElement: function () {
          return Z;
        },
        isDisplayed: function () {
          return ze;
        },
        reattachElement: function () {
          return fe;
        },
        removeAllChildren: function () {
          return he;
        },
        removeAriaLabel: function () {
          return _e;
        },
        removeAriaLive: function () {
          return De;
        },
        removeChildById: function () {
          return ce;
        },
        removeClass: function () {
          return rt;
        },
        removeClasses: function () {
          return nt;
        },
        removeElementById: function () {
          return de;
        },
        replaceClasses: function () {
          return st;
        },
        replaceClassesAndStyle: function () {
          return at;
        },
        replaceStyle: function () {
          return ot;
        },
        setAriaHidden: function () {
          return Ee;
        },
        setAriaLabel: function () {
          return Fe;
        },
        setAriaLabelledBy: function () {
          return Oe;
        },
        setAriaLivePolite: function () {
          return Ie;
        },
        setButtonRole: function () {
          return Te;
        },
        setDisplay: function () {
          return Ne;
        },
        setDisplayNone: function () {
          return je;
        },
        setPosition: function () {
          return Qe;
        },
        setPositionAttributes: function () {
          return We;
        },
        setPresentationRole: function () {
          return Ae;
        },
        setRole: function () {
          return Se;
        },
        setTabIndex: function () {
          return Ve;
        },
        setWidthAndHeight: function () {
          return Ze;
        },
        setZIndex: function () {
          return He;
        },
        setupTabAccessible: function () {
          return Re;
        },
        switchClass: function () {
          return Ye;
        },
        switchClasses: function () {
          return Je;
        },
        unsetDisplayNone: function () {
          return $e;
        }
      });
      var t = {};
      i.r(t), i.d(t, {
        areRectPointsAndCircleIntersecting: function () {
          return mi;
        },
        areRectsIntersecting: function () {
          return fi;
        },
        arrayEquals: function () {
          return Dt;
        },
        camelCaseToKebabCase: function () {
          return $t;
        },
        camelCaseToSnakeCase: function () {
          return Ut;
        },
        capitalizeString: function () {
          return vt;
        },
        chunkArray: function () {
          return wt;
        },
        cleanCoordinatesArray: function () {
          return Ft;
        },
        compareBounds: function () {
          return Et;
        },
        convertToCurrency: function () {
          return ii;
        },
        countDecimals: function () {
          return It;
        },
        fastHash: function () {
          return Nt;
        },
        firstDefinedKey: function () {
          return gt;
        },
        firstDefinedValue: function () {
          return ft;
        },
        firstDefinedValueAndKey: function () {
          return mt;
        },
        getBalancedRate: function () {
          return Yt;
        },
        getDistanceToMoveRect: function () {
          return gi;
        },
        getIntersection: function () {
          return pi;
        },
        getMaxRect: function () {
          return oi;
        },
        getMinPrice: function () {
          return Bt;
        },
        getMovedRect: function () {
          return ai;
        },
        getMultiLineLabelText: function () {
          return Jt;
        },
        getPaddedZoomAndCenter: function () {
          return Gt;
        },
        getPaddingPixels: function () {
          return Qt;
        },
        getRect: function () {
          return ni;
        },
        getRectCenter: function () {
          return si;
        },
        hashCode: function () {
          return ti;
        },
        identifyDecimalSeparatorForPrice: function () {
          return St;
        },
        intToHexString: function () {
          return Vt;
        },
        intersectionBottomSide: function () {
          return ci;
        },
        isArray: function () {
          return kt;
        },
        isObject: function () {
          return bt;
        },
        isPointIntersectingCircle: function () {
          return yi;
        },
        kebabCaseToCamelCase: function () {
          return jt;
        },
        listHashKeysSorted: function () {
          return At;
        },
        opacityDecimalToHex: function () {
          return Rt;
        },
        parseClientPadding: function () {
          return Wt;
        },
        randomAlphaNumeric: function () {
          return Kt;
        },
        removeDuplicates: function () {
          return xt;
        },
        replaceDomainInURI: function () {
          return ri;
        },
        round: function () {
          return _t;
        },
        roundLatLng: function () {
          return Ot;
        },
        roundLatOrLng: function () {
          return Lt;
        },
        roundZoom: function () {
          return Pt;
        },
        snakeCaseToCamelCase: function () {
          return zt;
        },
        sortDeeplyObjectAndArray: function () {
          return Ct;
        },
        sortHashKeys: function () {
          return qt;
        },
        splitLabelTextIntoLines: function () {
          return Xt;
        },
        stringify: function () {
          return Mt;
        },
        transformHistoricalBboxOutput: function () {
          return Ht;
        },
        undefNullEmpty: function () {
          return yt;
        },
        verifyKeyIsLegal: function () {
          return ei;
        }
      });
      var n = {};
      i.r(n), i.d(n, {
        getCookieValue: function () {
          return _i;
        },
        promiseAllSettled: function () {
          return Fi;
        },
        timeoutFetch: function () {
          return Li;
        }
      });
      var s = {};
      i.r(s), i.d(s, {
        bounce: function () {
          return Si;
        }
      });
      var o = {};
      i.r(o), i.d(o, {
        addMeterToLat: function () {
          return Yi;
        },
        areBoundsCrossingDateLine: function () {
          return qi;
        },
        areCoordinatesCrossingDateLine: function () {
          return Zi;
        },
        areLongitudesCrossingDateLine: function () {
          return Hi;
        },
        computeTileDistance: function () {
          return Xi;
        },
        computeTilesIds: function () {
          return $i;
        },
        computeZoomFromBBox: function () {
          return Ni;
        },
        convertGeoJsonPolygonToPath: function () {
          return Ji;
        },
        directionFromOrigin: function () {
          return Wi;
        },
        furthestLatOrLong: function () {
          return Qi;
        }
      });
      var a = {};
      i.r(a), i.d(a, {
        areIconsDifferent: function () {
          return or;
        },
        ensureImageIsLoaded: function () {
          return sr;
        },
        events: function () {
          return er;
        },
        extractImgSourcesFromIcons: function () {
          return tr;
        },
        flatIcons: function () {
          return nr;
        },
        flatSuppIcons: function () {
          return rr;
        },
        preloadIcons: function () {
          return ir;
        }
      });
      var l = {};
      i.r(l), i.d(l, {
        createLabels: function () {
          return Yn;
        },
        getLabelVisibilityConfigByFeatureKeyAndZoom: function () {
          return es;
        },
        getRectOfMarkerLabel: function () {
          return rs;
        },
        hideTextLabelsForZoomLevel: function () {
          return Jn;
        },
        isTextLabelHiddenAtZoomLevel: function () {
          return Xn;
        },
        labelPositions: function () {
          return Wn;
        },
        textLabelHiddenCssClass: function () {
          return qn;
        },
        textSubLabelHiddenCssClass: function () {
          return Qn;
        }
      });
      var u = {};
      i.r(u), i.d(u, {
        bounceMarker: function () {
          return ms;
        },
        cleanMarkerListeners: function () {
          return Rs;
        },
        cloneObfuscatedPolygon: function () {
          return Bs;
        },
        createBasicTextMarker: function () {
          return ds;
        },
        createClusterMarker: function () {
          return Ds;
        },
        createCornerIcons: function () {
          return vs;
        },
        createDoubleClickEventCanceller: function () {
          return Fs;
        },
        createImageIcon: function () {
          return hs;
        },
        createInnerIcons: function () {
          return bs;
        },
        createObfuscatedMarker: function () {
          return Ss;
        },
        createPinMarker: function () {
          return _s;
        },
        createTextMarker: function () {
          return Es;
        },
        events: function () {
          return us;
        },
        fillWithMarkerInfo: function () {
          return As;
        },
        finalizeMarkerCreation: function () {
          return Os;
        },
        fixMarkerToUse: function () {
          return Ks;
        },
        haveCornerIconsChanged: function () {
          return Ms;
        },
        haveInnerIconsChanged: function () {
          return Cs;
        },
        identifyCornerIcons: function () {
          return xs;
        },
        identifyInnerIcons: function () {
          return Ps;
        },
        identifyMarkerProperties: function () {
          return ps;
        },
        prepareCreateMarker: function () {
          return Vs;
        },
        registerCompListeners: function () {
          return Ts;
        },
        setMarkerZIndex: function () {
          return gs;
        },
        shouldRecreateMarker: function () {
          return Ns;
        },
        switchHtmlAriaLabel: function () {
          return Ls;
        },
        updatePinMarkerIcon: function () {
          return fs;
        }
      });
      i(801);
      var h = 6371008.8,
        d = {
          centimeters: 637100880,
          centimetres: 637100880,
          degrees: 360 / (2 * Math.PI),
          feet: 20902260.511392,
          inches: 39.37 * h,
          kilometers: 6371.0088,
          kilometres: 6371.0088,
          meters: h,
          metres: h,
          miles: 3958.761333810546,
          millimeters: 6371008800,
          millimetres: 6371008800,
          nauticalmiles: h / 1852,
          radians: 1,
          yards: 6967335.223679999
        };
      function c(e, t, i = {}) {
        const r = {
          type: "Feature"
        };
        return (0 === i.id || i.id) && (r.id = i.id), i.bbox && (r.bbox = i.bbox), r.properties = t || {}, r.geometry = e, r;
      }
      function p(e, t, i = {}) {
        if (!e) throw new Error("coordinates is required");
        if (!Array.isArray(e)) throw new Error("coordinates must be an Array");
        if (e.length < 2) throw new Error("coordinates must be at least 2 numbers long");
        if (!v(e[0]) || !v(e[1])) throw new Error("coordinates must contain numbers");
        return c({
          type: "Point",
          coordinates: e
        }, t, i);
      }
      function f(e, t, i = {}) {
        for (const t of e) {
          if (t.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
          if (t[t.length - 1].length !== t[0].length) throw new Error("First and last Position are not equivalent.");
          for (let e = 0; e < t[t.length - 1].length; e++) if (t[t.length - 1][e] !== t[0][e]) throw new Error("First and last Position are not equivalent.");
        }
        return c({
          type: "Polygon",
          coordinates: e
        }, t, i);
      }
      function g(e, t = "kilometers") {
        const i = d[t];
        if (!i) throw new Error(t + " units is invalid");
        return e / i;
      }
      function m(e) {
        return 180 * (e % (2 * Math.PI)) / Math.PI;
      }
      function y(e) {
        return e % 360 * Math.PI / 180;
      }
      function v(e) {
        return !isNaN(e) && null !== e && !Array.isArray(e);
      }
      function b(e, t, i, r = {}) {
        const n = function (e) {
            if (!e) throw new Error("coord is required");
            if (!Array.isArray(e)) {
              if ("Feature" === e.type && null !== e.geometry && "Point" === e.geometry.type) return [...e.geometry.coordinates];
              if ("Point" === e.type) return [...e.coordinates];
            }
            if (Array.isArray(e) && e.length >= 2 && !Array.isArray(e[0]) && !Array.isArray(e[1])) return [...e];
            throw new Error("coord must be GeoJSON Point or an Array of numbers");
          }(e),
          s = y(n[0]),
          o = y(n[1]),
          a = y(i),
          l = g(t, r.units),
          u = Math.asin(Math.sin(o) * Math.cos(l) + Math.cos(o) * Math.sin(l) * Math.cos(a));
        return p([m(s + Math.atan2(Math.sin(a) * Math.sin(l) * Math.cos(o), Math.cos(l) - Math.sin(o) * Math.sin(u))), m(u)], r.properties);
      }
      var k = function (e, t, i = {}) {
        const r = i.steps || 64,
          n = i.properties ? i.properties : !Array.isArray(e) && "Feature" === e.type && e.properties ? e.properties : {},
          s = [];
        for (let n = 0; n < r; n++) s.push(b(e, t, -360 * n / r, i).geometry.coordinates);
        return s.push(s[0]), f([s], n);
      };
      class M {
        constructor() {}
        getClustersAndFeatures(e, t, i, r, n, s, o) {
          throw new Error("method getClustersAndFeatures not implemented");
        }
      }
      function C(e, t, i, r, n, s) {
        if (n - r <= i) return;
        const o = r + n >> 1;
        w(e, t, o, r, n, s % 2), C(e, t, i, r, o - 1, s + 1), C(e, t, i, o + 1, n, s + 1);
      }
      function w(e, t, i, r, n, s) {
        for (; n > r;) {
          if (n - r > 600) {
            const o = n - r + 1,
              a = i - r + 1,
              l = Math.log(o),
              u = .5 * Math.exp(2 * l / 3),
              h = .5 * Math.sqrt(l * u * (o - u) / o) * (a - o / 2 < 0 ? -1 : 1);
            w(e, t, i, Math.max(r, Math.floor(i - a * u / o + h)), Math.min(n, Math.floor(i + (o - a) * u / o + h)), s);
          }
          const o = t[2 * i + s];
          let a = r,
            l = n;
          for (x(e, t, r, i), t[2 * n + s] > o && x(e, t, r, n); a < l;) {
            for (x(e, t, a, l), a++, l--; t[2 * a + s] < o;) a++;
            for (; t[2 * l + s] > o;) l--;
          }
          t[2 * r + s] === o ? x(e, t, r, l) : (l++, x(e, t, l, n)), l <= i && (r = l + 1), i <= l && (n = l - 1);
        }
      }
      function x(e, t, i, r) {
        P(e, i, r), P(t, 2 * i, 2 * r), P(t, 2 * i + 1, 2 * r + 1);
      }
      function P(e, t, i) {
        const r = e[t];
        e[t] = e[i], e[i] = r;
      }
      function F(e, t, i, r) {
        const n = e - i,
          s = t - r;
        return n * n + s * s;
      }
      const L = e => e[0],
        _ = e => e[1];
      class O {
        constructor(e, t = L, i = _, r = 64, n = Float64Array) {
          this.nodeSize = r, this.points = e;
          const s = e.length < 65536 ? Uint16Array : Uint32Array,
            o = this.ids = new s(e.length),
            a = this.coords = new n(2 * e.length);
          for (let r = 0; r < e.length; r++) o[r] = r, a[2 * r] = t(e[r]), a[2 * r + 1] = i(e[r]);
          C(o, a, r, 0, o.length - 1, 0);
        }
        range(e, t, i, r) {
          return function (e, t, i, r, n, s, o) {
            const a = [0, e.length - 1, 0],
              l = [];
            let u, h;
            for (; a.length;) {
              const d = a.pop(),
                c = a.pop(),
                p = a.pop();
              if (c - p <= o) {
                for (let o = p; o <= c; o++) u = t[2 * o], h = t[2 * o + 1], u >= i && u <= n && h >= r && h <= s && l.push(e[o]);
                continue;
              }
              const f = Math.floor((p + c) / 2);
              u = t[2 * f], h = t[2 * f + 1], u >= i && u <= n && h >= r && h <= s && l.push(e[f]);
              const g = (d + 1) % 2;
              (0 === d ? i <= u : r <= h) && (a.push(p), a.push(f - 1), a.push(g)), (0 === d ? n >= u : s >= h) && (a.push(f + 1), a.push(c), a.push(g));
            }
            return l;
          }(this.ids, this.coords, e, t, i, r, this.nodeSize);
        }
        within(e, t, i) {
          return function (e, t, i, r, n, s) {
            const o = [0, e.length - 1, 0],
              a = [],
              l = n * n;
            for (; o.length;) {
              const u = o.pop(),
                h = o.pop(),
                d = o.pop();
              if (h - d <= s) {
                for (let n = d; n <= h; n++) F(t[2 * n], t[2 * n + 1], i, r) <= l && a.push(e[n]);
                continue;
              }
              const c = Math.floor((d + h) / 2),
                p = t[2 * c],
                f = t[2 * c + 1];
              F(p, f, i, r) <= l && a.push(e[c]);
              const g = (u + 1) % 2;
              (0 === u ? i - n <= p : r - n <= f) && (o.push(d), o.push(c - 1), o.push(g)), (0 === u ? i + n >= p : r + n >= f) && (o.push(c + 1), o.push(h), o.push(g));
            }
            return a;
          }(this.ids, this.coords, e, t, i, this.nodeSize);
        }
      }
      const E = {
          minZoom: 0,
          maxZoom: 16,
          minPoints: 2,
          radius: 40,
          extent: 512,
          nodeSize: 64,
          log: !1,
          generateId: !1,
          reduce: null,
          map: e => e
        },
        I = Math.fround || (D = new Float32Array(1), e => (D[0] = +e, D[0]));
      var D;
      class S {
        constructor(e) {
          this.options = j(Object.create(E), e), this.trees = new Array(this.options.maxZoom + 1);
        }
        load(e) {
          const {
            log: t,
            minZoom: i,
            maxZoom: r,
            nodeSize: n
          } = this.options;
          t && console.time("total time");
          const s = `prepare ${e.length} points`;
          t && console.time(s), this.points = e;
          let o = [];
          for (let t = 0; t < e.length; t++) e[t].geometry && o.push(A(e[t], t));
          this.trees[r + 1] = new O(o, $, z, n, Float32Array), t && console.timeEnd(s);
          for (let e = r; e >= i; e--) {
            const i = +Date.now();
            o = this._cluster(o, e), this.trees[e] = new O(o, $, z, n, Float32Array), t && console.log("z%d: %d clusters in %dms", e, o.length, +Date.now() - i);
          }
          return t && console.timeEnd("total time"), this;
        }
        getClusters(e, t) {
          let i = ((e[0] + 180) % 360 + 360) % 360 - 180;
          const r = Math.max(-90, Math.min(90, e[1]));
          let n = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
          const s = Math.max(-90, Math.min(90, e[3]));
          if (e[2] - e[0] >= 360) i = -180, n = 180;else if (i > n) {
            const e = this.getClusters([i, r, 180, s], t),
              o = this.getClusters([-180, r, n, s], t);
            return e.concat(o);
          }
          const o = this.trees[this._limitZoom(t)],
            a = o.range(V(i), K(s), V(n), K(r)),
            l = [];
          for (const e of a) {
            const t = o.points[e];
            l.push(t.numPoints ? T(t) : this.points[t.index]);
          }
          return l;
        }
        getChildren(e) {
          const t = this._getOriginId(e),
            i = this._getOriginZoom(e),
            r = "No cluster with the specified id.",
            n = this.trees[i];
          if (!n) throw new Error(r);
          const s = n.points[t];
          if (!s) throw new Error(r);
          const o = this.options.radius / (this.options.extent * Math.pow(2, i - 1)),
            a = n.within(s.x, s.y, o),
            l = [];
          for (const t of a) {
            const i = n.points[t];
            i.parentId === e && l.push(i.numPoints ? T(i) : this.points[i.index]);
          }
          if (0 === l.length) throw new Error(r);
          return l;
        }
        getLeaves(e, t, i) {
          t = t || 10, i = i || 0;
          const r = [];
          return this._appendLeaves(r, e, t, i, 0), r;
        }
        getTile(e, t, i) {
          const r = this.trees[this._limitZoom(e)],
            n = Math.pow(2, e),
            {
              extent: s,
              radius: o
            } = this.options,
            a = o / s,
            l = (i - a) / n,
            u = (i + 1 + a) / n,
            h = {
              features: []
            };
          return this._addTileFeatures(r.range((t - a) / n, l, (t + 1 + a) / n, u), r.points, t, i, n, h), 0 === t && this._addTileFeatures(r.range(1 - a / n, l, 1, u), r.points, n, i, n, h), t === n - 1 && this._addTileFeatures(r.range(0, l, a / n, u), r.points, -1, i, n, h), h.features.length ? h : null;
        }
        getClusterExpansionZoom(e) {
          let t = this._getOriginZoom(e) - 1;
          for (; t <= this.options.maxZoom;) {
            const i = this.getChildren(e);
            if (t++, 1 !== i.length) break;
            e = i[0].properties.cluster_id;
          }
          return t;
        }
        _appendLeaves(e, t, i, r, n) {
          const s = this.getChildren(t);
          for (const t of s) {
            const s = t.properties;
            if (s && s.cluster ? n + s.point_count <= r ? n += s.point_count : n = this._appendLeaves(e, s.cluster_id, i, r, n) : n < r ? n++ : e.push(t), e.length === i) break;
          }
          return n;
        }
        _addTileFeatures(e, t, i, r, n, s) {
          for (const o of e) {
            const e = t[o],
              a = e.numPoints;
            let l, u, h;
            if (a) l = R(e), u = e.x, h = e.y;else {
              const t = this.points[e.index];
              l = t.properties, u = V(t.geometry.coordinates[0]), h = K(t.geometry.coordinates[1]);
            }
            const d = {
              type: 1,
              geometry: [[Math.round(this.options.extent * (u * n - i)), Math.round(this.options.extent * (h * n - r))]],
              tags: l
            };
            let c;
            a ? c = e.id : this.options.generateId ? c = e.index : this.points[e.index].id && (c = this.points[e.index].id), void 0 !== c && (d.id = c), s.features.push(d);
          }
        }
        _limitZoom(e) {
          return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
        }
        _cluster(e, t) {
          const i = [],
            {
              radius: r,
              extent: n,
              reduce: s,
              minPoints: o
            } = this.options,
            a = r / (n * Math.pow(2, t));
          for (let r = 0; r < e.length; r++) {
            const n = e[r];
            if (n.zoom <= t) continue;
            n.zoom = t;
            const l = this.trees[t + 1],
              u = l.within(n.x, n.y, a),
              h = n.numPoints || 1;
            let d = h;
            for (const e of u) {
              const i = l.points[e];
              i.zoom > t && (d += i.numPoints || 1);
            }
            if (d > h && d >= o) {
              let e = n.x * h,
                o = n.y * h,
                a = s && h > 1 ? this._map(n, !0) : null;
              const c = (r << 5) + (t + 1) + this.points.length;
              for (const i of u) {
                const r = l.points[i];
                if (r.zoom <= t) continue;
                r.zoom = t;
                const u = r.numPoints || 1;
                e += r.x * u, o += r.y * u, r.parentId = c, s && (a || (a = this._map(n, !0)), s(a, this._map(r)));
              }
              n.parentId = c, i.push(B(e / d, o / d, c, d, a));
            } else if (i.push(n), d > 1) for (const e of u) {
              const r = l.points[e];
              r.zoom <= t || (r.zoom = t, i.push(r));
            }
          }
          return i;
        }
        _getOriginId(e) {
          return e - this.points.length >> 5;
        }
        _getOriginZoom(e) {
          return (e - this.points.length) % 32;
        }
        _map(e, t) {
          if (e.numPoints) return t ? j({}, e.properties) : e.properties;
          const i = this.points[e.index].properties,
            r = this.options.map(i);
          return t && r === i ? j({}, r) : r;
        }
      }
      function B(e, t, i, r, n) {
        return {
          x: I(e),
          y: I(t),
          zoom: 1 / 0,
          id: i,
          parentId: -1,
          numPoints: r,
          properties: n
        };
      }
      function A(e, t) {
        const [i, r] = e.geometry.coordinates;
        return {
          x: I(V(i)),
          y: I(K(r)),
          zoom: 1 / 0,
          index: t,
          parentId: -1
        };
      }
      function T(e) {
        return {
          type: "Feature",
          id: e.id,
          properties: R(e),
          geometry: {
            type: "Point",
            coordinates: [(t = e.x, 360 * (t - .5)), N(e.y)]
          }
        };
        var t;
      }
      function R(e) {
        const t = e.numPoints,
          i = t >= 1e4 ? `${Math.round(t / 1e3)}k` : t >= 1e3 ? Math.round(t / 100) / 10 + "k" : t;
        return j(j({}, e.properties), {
          cluster: !0,
          cluster_id: e.id,
          point_count: t,
          point_count_abbreviated: i
        });
      }
      function V(e) {
        return e / 360 + .5;
      }
      function K(e) {
        const t = Math.sin(e * Math.PI / 180),
          i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
        return i < 0 ? 0 : i > 1 ? 1 : i;
      }
      function N(e) {
        const t = (180 - 360 * e) * Math.PI / 180;
        return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
      }
      function j(e, t) {
        for (const i in t) e[i] = t[i];
        return e;
      }
      function $(e) {
        return e.x;
      }
      function z(e) {
        return e.y;
      }
      var U = i(908),
        H = i.n(U);
      function Z(e) {
        return !!e && void 0 !== e.nodeName;
      }
      function q(e) {
        if (e) return e.outerHTML;
      }
      function Q(e) {
        if (e) return ti(q(e));
      }
      function W(e, t, i, r, n, s, o) {
        let a = document.createElement(t);
        return e && (a.id = e), n && (a.style.cssText = n), r && (a.className = r), o && tt(a, o), i && i.appendChild(a), s && s.length > 0 && G(a, s), a;
      }
      function G(e, t) {
        const i = document.createTextNode(t);
        return e && e.appendChild(i), i;
      }
      function X(e, t) {
        const i = te(e).filter(e => e.nodeType === Node.TEXT_NODE);
        return 1 === i.length && (Y(i[0], t), !0);
      }
      function Y(e, t) {
        e && (e.nodeValue = t);
      }
      function J() {
        return void 0 !== document;
      }
      function ee(e) {
        const t = [];
        if (null != e && e.children) for (let i = 0; i < e.children.length; i++) t.push(e.children[i]);
        return t;
      }
      function te(e) {
        const t = [];
        if (null != e && e.childNodes) for (let i = 0; i < e.childNodes.length; i++) t.push(e.childNodes[i]);
        return t;
      }
      function ie(e) {
        return e ? t => {
          if ("string" == typeof t.className) {
            var i;
            const r = (null === (i = t.className) || void 0 === i ? void 0 : i.split(" ")) || [];
            return e.every(e => r.includes(e));
          }
          return !1;
        } : e => !0;
      }
      function re(e) {
        return t => (null == t ? void 0 : t.getAttribute("aria-roledescription")) === e;
      }
      function ne(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return ue(e, ie(t), i);
      }
      function se(e, t) {
        var i;
        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return null === (i = ue(e, ie(t), r, !0)) || void 0 === i || null === (i = i[0]) || void 0 === i ? void 0 : i.element;
      }
      function oe(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return ue(e, re(t), i);
      }
      function ae(e, t) {
        var i;
        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return null === (i = ue(e, re(t), r, !0)) || void 0 === i || null === (i = i[0]) || void 0 === i ? void 0 : i.element;
      }
      function le(e) {
        if (e) {
          const t = e.parentNode;
          return Array.prototype.indexOf.call(t.children, e);
        }
        return -1;
      }
      function ue(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [];
        if (e && e.children) {
          for (let i = 0; i < e.children.length; i++) {
            const s = e.children[i];
            if (s && t(s) && (n.push({
              element: s,
              parent: e,
              index: i
            }), r)) return n;
          }
          for (let s = 0; s < e.children.length; s++) {
            const o = e.children[s];
            if (o && i && (ue(o, t, i, r, n), r && n.length > 0)) return n;
          }
        }
        return n;
      }
      function he(e) {
        if (e) for (; e.lastElementChild;) e.removeChild(e.lastElementChild);
        return e;
      }
      function de(e) {
        const t = document.getElementById(e);
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      function ce(e, t) {
        if (e) {
          const i = document.getElementById(t);
          i && i.parentNode && i.parentNode === e && e.removeChild(i);
        }
      }
      function pe(e) {
        var t;
        e && (null === (t = e.parentNode) || void 0 === t || t.removeChild(e));
      }
      function fe(e, t) {
        var i;
        e && (null === (i = e.parentNode) || void 0 === i || i.removeChild(e), null == t || t.appendChild(e));
      }
      function ge(e, t, i, r, n, s, o, a) {
        const l = W(e, "input", i, r, n, void 0, a);
        return l.type = t, s && (l.value = s), Fe(l, o), l;
      }
      function me(e, t, i, r, n) {
        return W(e, "div", t, i, r, void 0, n);
      }
      function ye(e, t, i, r, n) {
        return W(e, "ul", t, i, r, void 0, n);
      }
      function ve(e, t, i, r, n, s) {
        return W(e, "li", t, i, r, n, s);
      }
      function be(e, t, i, r, n, s) {
        return W(e, "label", t, i, r, n, s);
      }
      function ke(e, t, i, r, n, s) {
        return W(e, "button", t, i, r, n, s);
      }
      function Me(e, t, i, r, n, s) {
        return W(e, "span", t, i, r, n, s);
      }
      function Ce(e, t, i, r, n, s) {
        return W(e, "h1", t, i, r, n, s);
      }
      function we(e, t, i, r, n, s) {
        return W(e, "h2", t, i, r, n, s);
      }
      function xe(e, t, i, r, n, s, o, a) {
        const l = ge(e, "checkbox", t, i, r, n, o, a);
        return s && (l.checked = !0), l;
      }
      function Pe(e, t, i, r, n, s, o) {
        const a = W(e, "img", t, i, r, void 0, o);
        return n && (a.src = n), Fe(a, s), a;
      }
      function Fe(e, t) {
        e && t && e.setAttribute("aria-label", t);
      }
      function Le(e) {
        if (e) {
          const t = e.getAttribute("aria-label");
          return ((null == t ? void 0 : t.length) || 0) > 0;
        }
        return !1;
      }
      function _e(e) {
        e && e.removeAttribute("aria-label");
      }
      function Oe(e, t) {
        e && e.setAttribute("aria-labelledby", t);
      }
      function Ee(e) {
        e && e.setAttribute("aria-hidden", "true");
      }
      function Ie(e) {
        e && e.setAttribute("aria-live", "polite");
      }
      function De(e) {
        e && e.removeAttribute("aria-live");
      }
      function Se(e, t) {
        e && ("presentation" === t && e.setAttribute("aria-hidden", "true"), e.setAttribute("role", t));
      }
      function Be(e) {
        if (e) return e.tagName;
      }
      function Ae(e) {
        Se(e, "presentation");
      }
      function Te(e) {
        Se(e, "button");
      }
      function Re(e, t) {
        Te(e), Ve(e, t);
      }
      function Ve(e, t) {
        e && e.setAttribute("tabindex", `${t}`);
      }
      function Ke(e, t) {
        for (let i of t) {
          let t = i.indexOf(":");
          const r = i.slice(0, t).trim(),
            n = i.slice(t + 1).trim();
          e.style[r] = n;
        }
      }
      function Ne(e, t) {
        e && (e.style.display = t);
      }
      function je(e) {
        Ne(e, "none");
      }
      function $e(e) {
        Ne(e, "");
      }
      function ze(e) {
        if (e) return !e.style.display || "none" !== e.style.display;
      }
      function Ue(e, t) {
        e && e.setAttribute("src", t);
      }
      function He(e, t) {
        e && (e.style.zIndex = `${t}`);
      }
      function Ze(e, t, i) {
        e && (void 0 !== t && (e.style.width = "number" == typeof t ? `${t}px` : t), void 0 !== i && (e.style.height = "number" == typeof i ? `${i}px` : i));
      }
      function qe(e) {
        e && e.removeAttribute("aria-label");
      }
      function Qe(e, t, i, r, n, s) {
        if (!e) return;
        const o = Math.round(t + (null != n ? n : 0)),
          a = Math.round(i + (null != s ? s : 0));
        e.style.setProperty("transform", `translate(${(e => {
          switch (e) {
            case "top":
              return "-50%, 0%";
            case "middle":
            default:
              return "-50%, -50%";
            case "bottom":
              return "-50%, -100%";
            case "left":
              return "0%, -50%";
            case "right":
              return "-100%, -50%";
            case "top-left":
              return "0%, 0%";
            case "top-right":
              return "-100%, 0%";
            case "bottom-left":
              return "0%, -100%";
            case "bottom-right":
              return "-100%, -100%";
          }
        })(r)}) translate(${o}px, ${a}px)`);
      }
      function We(e, t) {
        const {
          bottom: i,
          left: r,
          right: n,
          top: s
        } = t;
        e && (i || r || n || s) && (e.style.top = null != s ? s : "", e.style.bottom = null != i ? i : "", e.style.left = null != r ? r : "", e.style.right = null != n ? n : "");
      }
      function Ge(e, t) {
        var i;
        return !!e && ((null === (i = e.className) || void 0 === i ? void 0 : i.split(" ")) || []).includes(t);
      }
      function Xe(e, t, i) {
        e && (Ge(e, t) ? Ye(e, t, i) : Ge(e, i) && Ye(e, i, t));
      }
      function Ye(e, t, i) {
        Je(e, [t], [i]);
      }
      function Je(e, t, i) {
        if (e) {
          var r;
          const n = (null === (r = e.className) || void 0 === r ? void 0 : r.split(" ")) || [];
          t && t.forEach(e => {
            n.indexOf(e) >= 0 && n.splice(n.indexOf(e), 1);
          }), i && i.forEach(e => {
            n.includes(e) || n.push(e);
          }), e.className = n.filter(e => e.length > 0).join(" ");
        }
      }
      function et(e) {
        var t;
        return (null == e || null === (t = e.className) || void 0 === t ? void 0 : t.split(" ")) || [];
      }
      function tt(e, t) {
        if (e) {
          var i;
          const r = (null === (i = e.className) || void 0 === i ? void 0 : i.split(" ")) || [];
          r.includes(t) || r.push(t), e.className = r.filter(e => e.length > 0).join(" ");
        }
      }
      function it(e, t) {
        if (e) {
          var i;
          const r = null === (i = e.className) || void 0 === i ? void 0 : i.split(" ");
          t.forEach(e => {
            r.includes(e) || r.push(e);
          }), e.className = r.filter(e => e.length > 0).join(" ");
        }
      }
      function rt(e, t) {
        if (e) {
          var i;
          const r = (null === (i = e.className) || void 0 === i ? void 0 : i.split(" ")) || [];
          r.indexOf(t) >= 0 && r.splice(r.indexOf(t), 1), e.className = r.filter(e => e.length > 0).join(" ");
        }
      }
      function nt(e, t) {
        if (e) {
          var i;
          const r = null === (i = e.className) || void 0 === i ? void 0 : i.split(" ");
          t.forEach(e => {
            r.indexOf(e) >= 0 && r.splice(r.indexOf(e), 1);
          }), e.className = r.filter(e => e.length > 0).join(" ");
        }
      }
      function st(e, t) {
        e && (t ? e.className = t : delete e.className);
      }
      function ot(e, t) {
        e && (t ? e.setAttribute("style", t) : lt(e));
      }
      function at(e, t, i) {
        st(e, t), ot(e, i);
      }
      function lt(e) {
        e && e.removeAttribute("style");
      }
      function ut(e, t, i) {
        if (e && t) if (i >= t.children.length) t.appendChild(e);else {
          const r = ee(t)[i];
          t.insertBefore(e, r);
        }
      }
      function ht(e, t, r, n) {
        let s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : i.g.document;
        if (s) {
          const [i] = s.getElementsByTagName("head");
          if (i) {
            let o = s.createElement("style");
            o.id = e, o.setAttribute("data-meta", t), i.appendChild(o);
            const {
              sheet: a
            } = o;
            let l;
            if (a) if (void 0 !== a.insertRule) l = (e, t, i) => e.insertRule(t + "{" + i + "}", e.cssRules.length);else {
              if (void 0 === a.addRule) throw new Error("no insertRule or addRule in sheet");
              l = (e, t, i) => e.addRule(t, i);
            }
            const u = [];
            Object.keys(n).forEach(e => {
              const t = n[e],
                i = `.egmaps.${r} ${e}`,
                s = Object.keys(t).map(e => `${$t(e)}:${t[e] || "''"}`).join(";");
              l(a, i, s), u.push(`${i} {\n  ${s.split(";").join(";\n  ")};\n}`);
            });
            const h = s.createTextNode(u.join("\n\n"));
            o.appendChild(h);
          }
        }
      }
      function dt(e) {
        const {
          offsetWidth: t,
          offsetHeight: i
        } = e;
        return {
          width: t,
          height: i
        };
      }
      function ct(e, t) {
        const i = e.cloneNode(!0);
        i.style.visibility = "hidden", i.style.position = "absolute", t.appendChild(i);
        const {
            clientWidth: r,
            clientHeight: n,
            scrollWidth: s,
            scrollHeight: o
          } = i,
          a = r || s || 0,
          l = n || o || 0;
        return t.removeChild(i), {
          width: a,
          height: l
        };
      }
      function pt() {
        return "undefined" != typeof window ? window : i.g;
      }
      function ft(e, t) {
        const {
          value: i
        } = mt(e, t) || {};
        return i;
      }
      function gt(e, t) {
        const {
          key: i
        } = mt(e, t) || {};
        return i;
      }
      function mt(e, t) {
        if (t) for (let i of t) if (i) {
          const t = null == e ? void 0 : e[i];
          if (void 0 !== t) return {
            key: i,
            value: t
          };
        }
      }
      function yt(e) {
        return !e || "" === e;
      }
      function vt(e) {
        return e[0].toUpperCase() + e.slice(1);
      }
      function bt(e) {
        return null !== e && "object" == typeof e && !Z(e) && "[object Array]" !== Object.prototype.toString.call(e);
      }
      function kt(e) {
        return Array.isArray(e);
      }
      function Mt(e) {
        return JSON.stringify(e, function () {
          const e = new WeakSet();
          return (t, i) => {
            if ("object" == typeof i && null !== i) {
              if (e.has(i)) return;
              e.add(i);
            }
            return i;
          };
        }());
      }
      function Ct(e) {
        if (e) {
          if (kt(e)) return e.sort();
          if (bt(e)) {
            var t;
            if ("Object" === (null === (t = e.constructor) || void 0 === t ? void 0 : t.name)) {
              const t = {};
              return Object.keys(e).sort().forEach(i => t[i] = Ct(e[i])), t;
            }
            return e;
          }
          return e;
        }
        return e;
      }
      function wt(e, t) {
        if (t <= 0) throw new Error("chunk size should be greater than 0");
        let i = 0,
          r = e.length,
          n = [];
        for (i = 0; i < r; i += t) {
          const r = e.slice(i, i + t);
          n.push(r);
        }
        return n;
      }
      function xt(e) {
        return e && 0 !== e.length ? [...new Set(e)] : [];
      }
      function Pt(e) {
        return _t(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2);
      }
      function Ft(e) {
        return e.filter(e => {
          if (void 0 !== e) {
            let {
              lat: t,
              lng: i
            } = e;
            if (t || void 0 === e.length || ([t, i] = e), void 0 !== t && void 0 !== i) return e;
          }
        }).filter(e => void 0 !== e);
      }
      function Lt(e) {
        let t = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        const i = _t(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5);
        if (t) {
          if (i < -180) return i + 360;
          if (i > 180) return i - 360;
        }
        return i;
      }
      function _t(e, t) {
        const i = Math.pow(10, t);
        let r = e * i;
        return r = Math.round(r), r / i;
      }
      function Ot(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5,
          i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
          {
            lat: r,
            lng: n
          } = e;
        return r || void 0 === e.length || ([r, n] = e), [Lt(r, t, !1), Lt(n, t, i)];
      }
      function Et(e, t) {
        if (!e) return !t;
        if (!t) return !1;
        const {
            sw: i,
            ne: r,
            center: n
          } = e,
          {
            sw: s,
            ne: o,
            center: a
          } = t;
        return i[0] === s[0] && i[1] === s[1] && r[0] === o[0] && r[1] === o[1] && n[0] === a[0] && n[1] === a[1];
      }
      function It(e) {
        const t = Number(e);
        return Math.floor(t.valueOf()) === t.valueOf() ? 0 : t.toString().split(".")[1].length || 0;
      }
      function Dt() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
          i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : (e, t) => e === t;
        if (e.length !== t.length) return !1;
        const n = t.slice();
        return e.every((e, t) => {
          const s = n.findIndex(t => r(e, t));
          return s >= 0 && (!i || t === s);
        });
      }
      function St(e) {
        const t = e.indexOf("."),
          i = e.indexOf(",");
        if (-1 !== t || -1 !== i) {
          const r = i > t ? "," : ".",
            n = i > t ? i : t;
          if (e.length <= n + 3) return r;
          for (let t = n + 1; t <= n + 3; t++) {
            const i = e.charAt(t);
            if (isNaN(i) || " " === i) return r;
          }
          if (e.length >= n + 4) {
            const t = e[n + 4];
            if (!isNaN(t) && " " !== t) return r;
          }
        }
      }
      function Bt(e) {
        let t, i, r, n;
        for (let r = 0; r < e.length; r++) {
          const n = e[r];
          if (!t && "string" == typeof n) {
            const e = St(n);
            e && (t = e, i = t && "," === t ? "." : ",");
          }
        }
        if (e.forEach(e => {
          const s = t ? H()(e, {
            decimal: t,
            separator: i
          }).value : H()(e).value;
          (!r || r > s) && (r = s, n = e);
        }), r && isFinite(r)) return n;
      }
      function At(e, t, i) {
        let r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
          n = i ? i.sort() : [],
          s = [];
        const o = e => {
          for (let t = e.depth; t >= 0; t--) {
            const i = e[t];
            for (let e = i.maxQualifiers; e >= 0; e--) i[e] && (s = s.concat(i[e]));
          }
        };
        if (t) {
          const t = {
            depth: 1,
            0: ["hl"]
          };
          Tt("hl#", n.slice(), e, t, 1, 0), o(t), e && s.push(["hl", e].sort().join("#")), s.push("hl");
        }
        const a = {
          depth: -1
        };
        return Tt("", n.slice(), e, a, 0, 0), o(a), e && s.push(e), r && s.push("default"), s;
      }
      function Tt(e, t, i, r, n, s) {
        let o = r[n];
        for (o || (o = {
          maxQualifiers: s
        }, r[n] = o, r.depth = n); t.length > 0;) {
          const a = t.splice(0, 1),
            l = s + 1;
          if (o[l] || (o[l] = []), o.maxQualifiers < l && (o.maxQualifiers = l), o[l].push(`${e}${a}`.split("#").sort().join("#")), i) {
            let t = r[n + 1];
            t || (t = {
              maxQualifiers: l
            }, r[n + 1] = t, r.depth = n + 1), t[l] || (t[l] = []), t[l].push(`${e}${a}#${i}`.split("#").sort().join("#"));
          }
          t.length > 0 && Tt(`${e}${a}#`, t.slice(), i, r, n + 1, s + 1);
        }
      }
      function Rt(e) {
        return Vt(255 * e);
      }
      function Vt(e) {
        let t = parseInt(e);
        t < 0 && (t = 4294967295 + t);
        const i = t.toString(16).toUpperCase();
        return 1 == i.length ? i + "0" : i.slice(-2);
      }
      function Kt() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8,
          t = "";
        const i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let r = 0; r < e; r++) t += i.charAt(Math.floor(62 * Math.random()));
        return t;
      }
      function Nt(e) {
        return e.split("").reduce(function (e, t) {
          const i = (e << 5) - e + t.charCodeAt(0);
          return 0 | i;
        }, 0);
      }
      function jt(e) {
        return e.split("-").map((e, t) => 0 === t ? e.charAt(0).toLowerCase() + e.slice(1) : e.charAt(0).toUpperCase() + e.slice(1)).join("");
      }
      function $t(e) {
        const t = [];
        return e.split("").forEach((e, i) => {
          const r = e.toUpperCase();
          e === r && e.toLowerCase() !== r ? i > 0 ? t.push("-", e.toLowerCase()) : t.push(e.toLowerCase()) : t.push(e);
        }), t.join("");
      }
      function zt(e) {
        return e.split("_").map((e, t) => 0 === t ? e.charAt(0).toLowerCase() + e.slice(1) : e.charAt(0).toUpperCase() + e.slice(1)).join("");
      }
      function Ut(e) {
        const t = [];
        return e.split("").forEach((e, i) => {
          const r = e.toUpperCase();
          e === r && e.toLowerCase() !== r ? i > 0 ? t.push("_", e.toLowerCase()) : t.push(e.toLowerCase()) : t.push(e);
        }), t.join("");
      }
      function Ht(e) {
        return e.substring(e.indexOf("((") + 2, e.lastIndexOf("))")).split(", ").map(e => e.split(" ")).map(e => ({
          lng: Number(parseFloat(e[0]).toFixed(8)),
          lat: Number(parseFloat(e[1]).toFixed(8))
        }));
      }
      const Zt = (e, t, i) => {
          t.has(i) && (e.push(i), t.delete(i));
        },
        qt = e => {
          const t = ["available", "filtered", "sold_out", "unknown"],
            i = new Set(),
            r = new Set();
          e.forEach(e => {
            (e => ["available", "filtered", "sold_out", "unknown"].some(t => -1 !== e.indexOf(t)))(e) || -1 !== e.indexOf("hl") || -1 !== e.indexOf("default") || e.split("#").forEach(e => r.add(e)), i.add(e);
          });
          const n = [];
          Zt(n, i, "default"), t.forEach(e => Zt(n, i, e));
          const s = Array.from(r).sort(),
            o = ((e, t) => {
              const i = (e, t, r, n) => {
                  if (0 != e) for (let s = 0; s < t.length; s++) i(e - 1, t.slice(s + 1), r.concat([t[s]]), n);else r.length > 0 && (n[n.length] = r);
                },
                r = [];
              for (let n = t; n < e.length; n++) i(n, e, [], r);
              return r.push(e), r;
            })(s, 1).map(e => e.join("#"));
          if (s.length > 0) {
            for (let e = 0; e < o.length - 1; e += s.length) {
              for (let t = s.length - 1; t >= 0; t--) Zt(n, i, o[e + t]);
              for (let r = s.length - 1; r >= 0; r--) t.forEach(t => {
                for (let a = s.length; a >= 0; a--) Zt(n, i, `${t}#${o[e + r]}`);
              });
            }
            Zt(n, i, o[o.length - 1]), t.forEach(e => Zt(n, i, `${e}#${o[o.length - 1]}`));
          }
          if (Zt(n, i, "hl"), t.forEach(e => Zt(n, i, `${e}#hl`)), s.length > 0) {
            for (let e = 0; e < o.length - 1; e += s.length) {
              for (let t = s.length - 1; t >= 0; t--) Zt(n, i, `hl#${o[e + t]}`);
              for (let r = s.length - 1; r >= 0; r--) t.forEach(t => {
                for (let a = s.length; a >= 0; a--) Zt(n, i, `${t}#hl#${o[e + r]}`);
              });
            }
            Zt(n, i, `hl#${o[o.length - 1]}`), t.forEach(e => Zt(n, i, `${e}#hl#${o[o.length - 1]}`));
          }
          return n.reverse();
        };
      function Qt(e, t, i) {
        let r;
        return r = "%" === t ? parseFloat(e) * i / 100 : parseFloat(e), Number.isFinite(r) ? r : void 0;
      }
      function Wt(e, t) {
        var i, r;
        if (void 0 === e) return;
        if ("string" != typeof e) throw new Error("Client padding has to be of type string");
        const {
          clientHeight: n,
          clientWidth: s
        } = t || {};
        if (!Number.isFinite(n) || !Number.isFinite(s)) throw new Error(`Dimensions of map element have to be of type number: {height: ${n}, width: ${s}}`);
        const o = e.match(/^(((\d+)(\.\d+)?)(px|%|))( ((\d+)(\.\d+)?)(px|%|))?( ((\d+)(\.\d+)?)(px|%|))?( ((\d+)(\.\d+)?)(px|%|))?$/);
        if (!o) throw new Error("Client padding has to follow CSS syntax and only use 'px' and '%' units");
        const [,, a,,, l,, u,,, h,, d,,, c,, p,,, f] = o;
        return {
          paddingTop: Qt(a, l, n),
          paddingRight: Qt(null != u ? u : a, null != h ? h : l, s),
          paddingBottom: Qt(null != d ? d : a, null != c ? c : l, n),
          paddingLeft: Qt(null !== (i = null != p ? p : u) && void 0 !== i ? i : a, null !== (r = null != f ? f : h) && void 0 !== r ? r : l, s)
        };
      }
      function Gt(e, t, i) {
        let r = Ot(t);
        if (i) {
          const {
              paddingTop: t = 0,
              paddingRight: n = 0,
              paddingBottom: s = 0,
              paddingLeft: o = 0
            } = i,
            a = Math.pow(2, Pt(e + 1)),
            l = [(t - s) / a, (n - o) / a];
          r = Ot(r.map(e => e + l.shift()));
        }
        return {
          zoom: Pt(e),
          center: r
        };
      }
      function Xt(e, t, i) {
        const r = parseInt(t),
          n = parseInt(i),
          s = String(e);
        if (s && r && n && r > 0 && n > 0 && s.length > r) {
          let e = s.replace(/[\u0000-\u001F\u007F-\u009F]/g, " ").trim().split(/\s+/g).map(e => [...e]),
            t = [],
            i = [],
            o = 0;
          for (; e.length > 0 && i.length <= n;) {
            const [n] = e;
            o += n.length, (o <= r || o > r && 0 === t.length) && (t.push(n.join("")), e.shift()), (o >= r || o < r && 0 === e.length) && (i.push(t.join(" ")), t = [], o = 0);
          }
          return i.length > n && (i.pop(), i.push(i.pop() + "...")), i.join("\n");
        }
        return s;
      }
      function Yt(e) {
        const t = e.split("\n").map(e => [...e].length);
        if (1 === t.length) return 0;
        const i = Math.max(...t);
        return Math.min(...t) / i;
      }
      function Jt(e, t, i) {
        let r = String(e);
        let n = 0;
        const s = Math.min(Math.floor(r.length / i), t);
        let o = t;
        for (; o >= s;) {
          const t = Xt(e, o, i),
            s = Yt(t);
          if (!s || 0 === s || s >= .5) return t;
          s > n && (r = t, n = s), o--;
        }
        return r;
      }
      function ei(e) {
        return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
      }
      function ti(e) {
        let t,
          i,
          r = 0;
        if (0 === e.length) return r;
        for (t = 0; t < e.length; t++) i = e.charCodeAt(t), r = (r << 5) - r + i, r |= 0;
        return r;
      }
      function ii(e, t, i, r) {
        if (!e || isNaN(e)) return e;
        const n = t || It(e),
          s = {
            style: "currency",
            currency: i,
            minimumFractionDigits: n,
            maximumFractionDigits: n
          };
        return new Intl.NumberFormat(r, s).format(e);
      }
      function ri(e, t) {
        return e.replace(/^(http[s]?):\/\/([^/\n?#]+)(?:(\/.*))?$/, `$1://${t}$3`);
      }
      function ni(e, t, i, r) {
        const n = t / 2,
          s = i / 2,
          o = e.x - n,
          a = e.y - s,
          l = e.x + n,
          u = e.y + s,
          {
            width: h,
            height: d
          } = r || {},
          c = r ? o < 0 || l > h || a < 0 || u > d : void 0,
          p = r ? l < 0 || o > h || u < 0 || a > d : void 0;
        return {
          center: e,
          width: t,
          height: i,
          left: o,
          top: a,
          right: l,
          bottom: u,
          cutOff: void 0 !== c ? c && !p : void 0,
          outOfViewport: p
        };
      }
      function si(e) {
        return {
          x: (e.right - e.left) / 2 + e.left,
          y: (e.bottom - e.top) / 2 + e.top
        };
      }
      function oi(e) {
        const t = {
          bottom: Math.max(...e.map(e => e.bottom)),
          left: Math.min(...e.map(e => e.left)),
          right: Math.max(...e.map(e => e.right)),
          top: Math.min(...e.map(e => e.top))
        };
        return t.center = si(t), t.width = t.right - t.left, t.height = t.bottom - t.top, t;
      }
      function ai(e, t) {
        const i = {
          bottom: e.bottom + t.y,
          left: e.left + t.x,
          right: e.right + t.x,
          top: e.top + t.y,
          height: e.height,
          width: e.width
        };
        return i.center = si(i), i;
      }
      function li(e, t, i) {
        const r = t.x - e.x,
          n = t.y - e.y;
        return {
          x: r + (i ? i * Math.sign(r) : 0),
          y: n + (i ? i * Math.sign(n) : 0)
        };
      }
      function ui(e, t, i) {
        let r = t * e.right + i;
        if (r >= e.top && r <= e.bottom) return {
          x: e.right,
          y: r
        };
      }
      function hi(e, t, i) {
        let r = t !== -1 / 0 ? (e.top - i) / t : e.center.x;
        if (r >= e.left && r <= e.right) return {
          x: r,
          y: e.top
        };
      }
      function di(e, t, i) {
        let r = t * e.left + i;
        if (r >= e.top && r <= e.bottom) return {
          x: e.left,
          y: r
        };
      }
      function ci(e, t, i) {
        let r = t !== -1 / 0 ? (e.bottom - i) / t : e.center.x;
        if (r >= e.left && r <= e.right) return {
          x: r,
          y: e.bottom
        };
      }
      function pi(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        switch (function (e, t) {
          return e > 0 && 0 === t ? "right" : 0 === e && t < 0 ? "top" : e < 0 && 0 === t ? "left" : 0 === e && t > 0 ? "bottom" : e > 0 && t < 0 ? "topOrRight" : e < 0 && t < 0 ? "topOrLeft" : e < 0 && t > 0 ? "bottomOrLeft" : e > 0 && t > 0 ? "bottomOrRight" : void 0;
        }(arguments.length > 3 ? arguments[3] : void 0, arguments.length > 4 ? arguments[4] : void 0)) {
          case "right":
            return ui(e, t, i);
          case "top":
            return hi(e, t, i);
          case "left":
            return di(e, t, i);
          case "bottom":
            return ci(e, t, i);
          case "topOrRight":
            return hi(e, t, i) ? hi(e, t, i) : ui(e, t, i);
          case "topOrLeft":
            return di(e, t, i) ? di(e, t, i) : hi(e, t, i);
          case "bottomOrLeft":
            return ci(e, t, i) ? ci(e, t, i) : di(e, t, i);
          case "bottomOrRight":
            return ui(e, t, i) ? ui(e, t, i) : ci(e, t, i);
        }
      }
      function fi(e, t) {
        return e.left < t.left + t.width && e.left + e.width > t.left && e.top < t.top + t.height && e.top + e.height > t.top;
      }
      function gi(e, t, i) {
        const r = (t.center.y - e.center.y) / (t.center.x - e.center.x),
          n = li(e.center, t.center),
          s = r !== -1 / 0 ? t.center.y - r * t.center.x : void 0,
          o = {
            from: pi(t, r, s, -n.x, -n.y),
            to: pi(e, r, s, n.x, n.y)
          };
        return li(o.from || t.center, o.to || e.center, i);
      }
      function mi(e, t) {
        return yi(e.right, e.top, t) || yi(e.left, e.top, t) || yi(e.left, e.bottom, t) || yi(e.right, e.bottom, t) || yi(e.center.x, e.center.y, t);
      }
      function yi(e, t, i) {
        return Math.sqrt((e - i.center.x) * (e - i.center.x) + (t - i.center.y) * (t - i.center.y)) < i.radius;
      }
      class vi extends M {
        constructor(e, t, i, r, n) {
          var s, o, a, l, u, h;
          super(), this.createClusterLabel = t, this.logger = e("SuperCluster"), this._config = i, this._defaultConfig = r, this.labelKey = null !== (s = this._config.labelKey) && void 0 !== s ? s : r.labelKey || "unknown", this._radius = null !== (o = null !== (a = null === (l = this._config.superclusterSettings) || void 0 === l ? void 0 : l.radius) && void 0 !== a ? a : null === (u = r.superclusterSettings) || void 0 === u ? void 0 : u.radius) && void 0 !== o ? o : 0, this._previousMapSize = void 0, this._mapSize = void 0, this._tileDim = void 0, this._supercluster = void 0, this.qualifier = n, this.excludedQualifiers = null !== (h = this._config.excludedQualifiers) && void 0 !== h ? h : r.excludedQualifiers;
        }
        get radius() {
          if (!this._tileDim || !this._mapSize) return 0;
          const {
              width: e,
              height: t
            } = this._tileDim,
            {
              clientWidth: i,
              clientHeight: r
            } = this._mapSize,
            n = 75 * i / e,
            s = 75 * r / t;
          return Math.min(this._radius, n, s);
        }
        get supercluster() {
          const {
              clientWidth: e,
              clientHeight: t
            } = this._previousMapSize || {},
            {
              clientWidth: i,
              clientHeight: r
            } = this._mapSize || {};
          var n, s, o;
          this._supercluster && e === i && t === r || (this._supercluster = new S({
            minPoints: null !== (n = this._config.minPoints) && void 0 !== n ? n : this._defaultConfig.minPoints,
            minZoom: null !== (s = this._config.minZoom) && void 0 !== s ? s : this._defaultConfig.minZoom,
            maxZoom: null !== (o = this._config.maxZoom) && void 0 !== o ? o : this._defaultConfig.maxZoom,
            radius: this.radius
          }));
          return this._supercluster;
        }
        getClustersAndFeatures(e, t, i, r, n, s, o) {
          this._previousMapSize = this._mapSize, this._mapSize = s, this._tileDim = o;
          const {
              remainingFeatures: a,
              clusters: l
            } = e,
            u = this._getExcludedFeatures(a, i),
            h = u.map(e => e.id),
            d = a.filter(e => !h.includes(e.id)),
            c = this._loadFeaturesForClustering(d);
          return this._clusterFeatures(c, d, l, t, u, r, n);
        }
        _loadFeaturesForClustering(e) {
          const t = e.map(e => this._makeGeoJsonFeature(e));
          return this.supercluster.load(t);
        }
        _clusterFeatures(e, t, i, r, n, s, o) {
          const a = this._convertBoundsToBbox(s),
            l = e.getClusters(a, Math.floor(o));
          return this._getAllFeaturesAndClusters(e, t, i, r, n, l);
        }
        _convertBoundsToBbox(e) {
          return [e.sw[1], e.sw[0], e.ne[1], e.ne[0]];
        }
        _makeGeoJsonFeature(e) {
          const t = [e.latLng[1], e.latLng[0]];
          return {
            id: e.id,
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: t
            },
            properties: e
          };
        }
        _getAllFeaturesAndClusters(e, t, i, r, n, s) {
          const o = {
            clusters: i,
            remainingFeatures: n
          };
          for (let i of s) if (i.properties.cluster) {
            const n = i.properties.cluster_id,
              s = e.getLeaves(n, 1 / 0),
              a = t.filter(e => !s.every(t => t.properties.id !== e.id || t.properties.type !== e.type)),
              l = Bt(a.map(e => e.price)) || 0,
              [u, h] = i.geometry.coordinates,
              d = {
                id: `${ti(`${r}-${a.map(e => `${e.id}`).sort().join(",")}`)}`.replace("-", "N"),
                children: a,
                minPrice: l,
                lat: h,
                lng: u,
                type: "cluster",
                radius: this.radius,
                text: this.createClusterLabel(a.length, l, this.labelKey),
                featureType: r,
                qualifier: this.qualifier
              };
            o.clusters.push(d);
          } else o.remainingFeatures.push(i.properties);
          return o;
        }
        _getExcludedFeatures(e, t) {
          return e.filter(e => {
            var i;
            return (e.qualifiers || []).some(e => (this.excludedQualifiers || []).includes(e)) || !(null !== (i = e.hashKeys) && void 0 !== i && i.includes(t));
          });
        }
      }
      const bi = {
        OFF: "OFF",
        DEBUG: "DEBUG",
        INFO: "INFO",
        WARN: "WARN",
        ERROR: "ERROR"
      };
      function ki(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        const r = i || !t ? new Ci() : t;
        return {
          debug: (t, n) => r.debug({
            loggerName: e,
            message: t,
            stack: n,
            debugMode: i
          }),
          info: (t, n) => r.info({
            loggerName: e,
            message: t,
            stack: n,
            debugMode: i
          }),
          warn: (t, n) => r.warn({
            loggerName: e,
            message: t,
            stack: n,
            debugMode: i
          }),
          error: (t, n) => r.error({
            loggerName: e,
            message: t,
            stack: n,
            debugMode: i
          }),
          debugEnabled: () => r.debugEnabled(),
          infoEnabled: () => r.infoEnabled(),
          warnEnabled: () => r.warnEnabled(),
          errorEnabled: () => r.errorEnabled()
        };
      }
      class Mi {
        constructor() {}
        log(e, t, i, r, n) {
          throw new Error("method log not implemented");
        }
        enabled(e) {
          throw new Error("method enabled not implemented");
        }
        debug(e) {
          let {
            loggerName: t,
            message: i,
            stack: r,
            debugMode: n
          } = e;
          return this.log(t, bi.DEBUG, i, r, n);
        }
        info(e) {
          let {
            loggerName: t,
            message: i,
            stack: r,
            debugMode: n
          } = e;
          return this.log(t, bi.INFO, i, r, n);
        }
        warn(e) {
          let {
            loggerName: t,
            message: i,
            stack: r,
            debugMode: n
          } = e;
          return this.log(t, bi.WARN, i, r, n);
        }
        error(e) {
          let {
            loggerName: t,
            message: i,
            stack: r,
            debugMode: n
          } = e;
          return this.log(t, bi.ERROR, i, r, n);
        }
        debugEnabled() {
          return this.enabled(bi.DEBUG);
        }
        infoEnabled() {
          return this.enabled(bi.INFO);
        }
        warnEnabled() {
          return this.enabled(bi.WARN);
        }
        errorEnabled() {
          return this.enabled(bi.ERROR);
        }
      }
      class Ci extends Mi {
        constructor() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : bi.WARN,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (e, t, i) => `${new Date().toISOString()} EGMAPS-9.4.1 ${e || "undefined"} ${t} ${i}`;
          super(), this.formatter = t, this.level = e;
        }
        enabled(e) {
          if (this.level !== bi.OFF) switch (e) {
            case bi.DEBUG:
              return this.level === bi.DEBUG;
            case bi.INFO:
              return this.level === bi.DEBUG || this.level === bi.INFO;
            case bi.WARN:
              return this.level === bi.DEBUG || this.level === bi.INFO || this.level === bi.WARN;
            case bi.ERROR:
              return this.level === bi.DEBUG || this.level === bi.INFO || this.level === bi.WARN || this.level === bi.ERROR;
            default:
              throw new Error(`level not implemented: ${e}`);
          }
          return !1;
        }
        log(e, t, i, r, n) {
          if (this.enabled(t || bi.INFO) || n) {
            const n = [this.formatter(e, t || bi.INFO, i)];
            switch (r && n.push(r), t) {
              case bi.DEBUG:
                console.debug(...n);
                break;
              case bi.INFO:
              default:
                console.info(...n);
                break;
              case bi.WARN:
                console.warn(...n);
                break;
              case bi.ERROR:
                console.error(...n);
            }
            return !0;
          }
        }
      }
      function wi(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function xi(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? wi(Object(i), !0).forEach(function (t) {
            Pi(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : wi(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function Pi(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      function Fi(e) {
        return Promise.allSettled ? Promise.allSettled(e) : Promise.all(e.map(e => e.then(e => ({
          status: "fulfilled",
          value: e
        })).catch(e => ({
          status: "rejected",
          reason: e
        }))));
      }
      function Li(e, t) {
        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        if ("undefined" != typeof AbortController) {
          const r = new AbortController();
          return setTimeout(() => r.abort(), t), fetch(e, xi(xi({}, i), {}, {
            signal: r.signal
          })).catch(i => {
            if (null != i && i.toString().includes("The user aborted a request")) return {
              clone: () => this,
              redirected: !1,
              type: "basic",
              url: e,
              ok: !1,
              success: !1,
              status: 504,
              headers: [],
              statusText: `timeout occurs after ${t}ms when fetching ${e}`,
              arrayBuffer: () => Promise.reject(new Error("timeout occurs")),
              body: null,
              bodyUsed: !1,
              blob: () => Promise.reject(new Error("timeout occurs")),
              formData: () => Promise.reject(new Error("timeout occurs")),
              json: () => Promise.reject(new Error("timeout occurs")),
              text: () => Promise.reject(new Error("timeout occurs"))
            };
            throw i;
          });
        }
        return fetch(e, i);
      }
      function _i(e) {
        var t;
        const i = null === (t = document.cookie) || void 0 === t ? void 0 : t.split(";");
        for (const t of i) {
          if ((null == t ? void 0 : t.substring(0, t.indexOf("=")).trim()) === e) {
            if (t.indexOf("=") + 1 > t.length) return;
            return t.substring(t.indexOf("=") + 1);
          }
        }
      }
      const Oi = "configEndpointLab",
        Ei = "wwwexpediacom.integration.sb.karmalab.net";
      const Ii = new class {
        _loadOptionsFromCookie() {
          const e = _i("EGMAPS_DEBUG_OPTIONS");
          this._debugOptions = new Set(null == e ? void 0 : e.split(","));
        }
        _getOptionEnabled(e) {
          var t;
          return this._debugOptions || this._loadOptionsFromCookie(), !(null === (t = this._debugOptions) || void 0 === t || !t.has(e));
        }
        _getOptionValue(e) {
          var t;
          return this._debugOptions || this._loadOptionsFromCookie(), null === (t = [...this._debugOptions].filter(t => t.startsWith(`${e}=`))) || void 0 === t || null === (t = t[0]) || void 0 === t ? void 0 : t.split("=")[1];
        }
        getDebugLoggingEnabled() {
          return this._getOptionEnabled("logging");
        }
        getDebugTilesIdEnabled() {
          return this._getOptionEnabled("tilesId");
        }
        getDebugMarkersPositionEnabled() {
          return this._getOptionEnabled("markersPosition");
        }
        shouldUseGmapsAdvancedMarkers() {
          const e = this._getOptionValue("gmapsMarkerType");
          return "classic" !== e && ("advanced" === e || void 0);
        }
        shouldUseLabConfigEndpoint() {
          return this._getOptionEnabled(Oi) ? Ei : this._getOptionValue(Oi);
        }
        fallbackConfigPath() {
          return `https://${this.shouldUseLabConfigEndpoint() || Ei}/eg-maps-config-service/`;
        }
        shouldUseAdditionalConfigTokens() {
          var e;
          return null === (e = this._getOptionValue("configAddTokens")) || void 0 === e ? void 0 : e.replaceAll("|", ",");
        }
        getDebugConfigEnabled() {
          return this._getOptionEnabled("config");
        }
      }();
      class Di {
        constructor(e, t, i) {
          this.defaultConfig = e, this.config = t, this.overwriteConfig = {}, this.configurations = [t, e].filter(Boolean), this.externalConfig = void 0, this.cache = new Map(), this.configLoaderLogger = this.logger("config-loader"), this.externalConfigLoaded = i ? new Promise(e => {
            this.externalConfig = i, this.configurations = [i, ...this.configurations], e(void 0);
          }) : this._loadExternalConfig((e => {
            let t = null == e ? void 0 : e.externalConfigEndpoint;
            const i = Ii.shouldUseAdditionalConfigTokens();
            i && (t ? t += (t.endsWith("/") ? "" : ",") + i : t = Ii.fallbackConfigPath() + i);
            const r = Ii.shouldUseLabConfigEndpoint();
            return t && r ? ri(t, r) : t;
          })(t), 5e3).then(e => {
            this.configLoaderLogger.debug(`Loaded external config from ${null == t ? void 0 : t.externalConfigEndpoint}`), e && (this.externalConfig = e, this.configurations = [e, ...this.configurations]);
          });
        }
        ready() {
          return this.externalConfigLoaded.then(() => this);
        }
        getConfigurations() {
          return {
            default: this.defaultConfig,
            external: this.externalConfig,
            overwrite: this.overwriteConfig,
            parameter: this.config
          };
        }
        _loadExternalConfig(e, t) {
          return e ? (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Li)(e, t).then(e => e.ok ? e.json().then(e => this.externalConfig = e) : (e.text().then(e => this.configLoaderLogger.error("Failed to load external configuration. Will continue without this config", e)), null)).catch(t => (this.configLoaderLogger.error(`failed to load external config from ${e}`, t), null)) : Promise.resolve(null);
        }
        logger(e) {
          return ki(e, this.readParam("logging,logger"), Ii.getDebugLoggingEnabled());
        }
        clearCache() {
          this.cache.clear();
        }
        writeParam(e, t) {
          this._writeParamAux(e.split(","), t, this.overwriteConfig), this.cache.set(e, t);
        }
        removeOverrideParam(e) {
          this._removeParamAux(e.split(","), this.overwriteConfig), this.cache.delete(e);
        }
        removeParam(e) {
          this.writeParam(e, null);
        }
        _writeParamAux(e, t, i) {
          let [r] = e;
          if (ei(r)) if (1 === e.length) i[r] = t;else {
            i[r] || (i[r] = {});
            let n = i[r];
            e.shift(), this._writeParamAux(e, t, n);
          }
        }
        _removeParamAux(e, t) {
          let [i] = e;
          if (ei(i)) if (1 === e.length) delete t[i];else {
            t[i] || (t[i] = {});
            let r = t[i];
            e.shift(), this._removeParamAux(e, r);
          }
        }
        readParam(e) {
          if (this.cache.has(e)) {
            const t = this.cache.get(e);
            return null === t ? void 0 : t;
          }
          {
            const t = e.split(","),
              i = this._readParamAux(t, this.overwriteConfig, this.configurations);
            return this.cache.set(e, i), i;
          }
        }
        _readParamAux(e, t, i) {
          let [r] = e;
          const n = t ? t[r] : void 0;
          if (null === n) return;
          let s = i.map(e => e[r]).filter(e => void 0 !== e);
          for (let e = 0; e < s.length; e++) if (null === s[e]) {
            s = s.splice(0, e);
            break;
          }
          return 1 === e.length ? Ct(n || (s.length > 0 ? s[0] : void 0)) : (e.shift(), this._readParamAux(e, n, s));
        }
        listStringKeys(e) {
          let t = [],
            i = [];
          return [this.overwriteConfig, ...this.configurations].forEach(r => this._listKeysAux(t, i, (null == e ? void 0 : e.split(",")) || [], [], r)), t;
        }
        listKeys(e) {
          return [...this.listStringKeys(e).map(e => e.split(","))];
        }
        listKeysShallow(e) {
          return this.listStringKeys(e).map(t => t.split(",").slice(0, e.split(",").length + 1).join(",")).filter((e, t, i) => i.indexOf(e) === t).map(e => e.split(","));
        }
        subConfig(e) {
          const t = {};
          return (e ? [e] : Object.keys(this.defaultConfig)).map(e => {
            const i = {};
            return this.listStringKeys(e).map(t => {
              const r = this.readParam(t);
              void 0 !== r && this._writeParamAux(t.substring(e.length + 1).split(","), r, i);
            }), t[e] = i, i;
          }), e ? t[e] : t;
        }
        _listKeysAux(e, t, i, r, n) {
          const s = [];
          let o = n;
          if (i.length > 0) {
            let [e] = i;
            o = n[e], s.push(...r, e);
          }
          void 0 !== o && (i.length <= 1 ? this._listKeysAuxDeep(e, t, s, o) : (i.shift(), this._listKeysAux(e, t, i, s, o)));
        }
        _listKeysAuxDeep(e, t, i, r) {
          if (bt(r) && !Z(r)) for (let n in r) {
            const s = [];
            s.push(...i, n), t.includes(s.join(",")) || this._listKeysAuxDeep(e, t, s, r[n]);
          } else i && (t.includes(i.join(",")) || (null === r ? t.push(i.join(",")) : this._checkIfParentPathAlreadyPresent(e, i) || e.push(i.join(","))));
        }
        _checkIfParentPathAlreadyPresent(e, t) {
          const i = [];
          t.forEach(t => {
            if (i.push(t), e.includes(i.join(","))) return !0;
          });
          const r = t.join(",") + ",";
          return e.some(e => e === t.join(",") || e.startsWith(r));
        }
        _fillObjectWithLeafName(e, t) {
          this.listKeysShallow(e).map(e => {
            const i = e[e.length - 1];
            t(i, this.readParam(e.join(",")));
          });
        }
        propertyValues(e, t, i) {
          let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e => e;
          const n = {};
          return i.map(i => {
            n[i] = {};
            const s = [e, i, t].filter(e => void 0 !== e).join(",");
            this._fillObjectWithLeafName(s, (e, t) => {
              const s = e.split("#").sort().join("#");
              ei(i) && ei(s) && (n[i][s] = r(t));
            });
          }), n;
        }
      }
      function Si(e) {
        const t = ["animate__animated", "animate__bounce"],
          i = r => {
            nt(e, t), e.removeEventListener("animationend", i);
          };
        e.addEventListener("animationend", i), it(e, t);
      }
      class Bi {
        constructor(e, t, i) {
          const {
            readParam: r,
            writeParam: n
          } = i;
          this.locale = t, this.messages = e || {}, this.readParam = r, this.writeParam = n, this.variants = [], this.locale && (this.variants.push(this.locale), t.length > 2 && this.variants.push(this.locale.slice(0, 2))), this.variants.push("default"), this._registerMessages(), this.hookForFormat = this.readParam("i18n,formatFunction");
        }
        _registerMessages() {
          const e = this;
          this.variants.forEach(t => {
            const i = this.messages[t];
            if (i) for (let t in i) {
              const r = `i18n,messages,${t}`;
              void 0 === e.readParam(r) && e.writeParam(r, i[t]);
            }
          });
        }
        format(e) {
          let t;
          for (var i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++) r[n - 1] = arguments[n];
          return t = this._externalFormat(e, ...r), t || (t = this._internalFormat(e, ...r)), t;
        }
        _externalFormat(e) {
          if (this.hookForFormat) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return this.hookForFormat(e, i);
          }
        }
        _internalFormat(e) {
          const t = this.readParam(`i18n,messages,${e}`);
          if (t) {
            let e = t;
            for (var i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++) r[n - 1] = arguments[n];
            if (r) for (let t = 0; t < r.length; t++) {
              const i = r[t];
              e = e.replace(`{${t}}`, void 0 !== i ? i : "");
            }
            return e;
          }
          return `${e} ${this.locale ? this.locale : "default"} NOT FOUND`;
        }
      }
      class Ai {
        constructor() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e => "object" != typeof e,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : () => !1;
          this.isLeaf = e, this.hasExpired = t, this.cache = Object.create(null), this.listeners = new Set();
        }
        get() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
          const {
            cache: r
          } = this;
          let n = r[t[0]];
          for (let e = 1; e < t.length && n; e++) n = n[t[e]];
          return n && this.hasExpired(n, t) ? (this.listeners.forEach(e => e(Ai.EVENTS.EXPIRE, n, t)), void this.set(void 0, ...t)) : n;
        }
        keys() {
          const {
            cache: e
          } = this;
          let t = e;
          for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
          for (let e = 0; e < (null == r ? void 0 : r.length) && t; e++) t = t[r[e]];
          return t ? this._keysAux(r, t) : [];
        }
        _keysAux(e, t) {
          return this.isLeaf(t, e) ? this.hasExpired(t, e) ? [] : [e] : Object.keys(t).flatMap(i => this._keysAux([...e, i], t[i]));
        }
        set(e) {
          const {
              cache: t
            } = this,
            i = [];
          let r = t;
          for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) s[o - 1] = arguments[o];
          for (let t = 0; t < s.length - 1; t++) {
            if (!r[s[t]]) {
              if (!e) return;
              r[s[t]] = {};
            }
            i.push(r), r = r[s[t]];
          }
          if (e) r[s[s.length - 1]] = e;else {
            delete r[s[s.length - 1]];
            for (let e = i.length - 1; e >= 0 && 0 === Object.keys(i[e][s[e]]).length; e--) delete i[e][s[e]];
          }
        }
        addListener(e) {
          this.listeners.add(e);
        }
        removeListener(e) {
          this.listeners.delete(e);
        }
      }
      Ai.EVENTS = {
        EXPIRE: "expire"
      };
      class Ti extends Ai {
        constructor(e) {
          let t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e => e;
          super(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e => null == e ? void 0 : e.leaf, function (i) {
            for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++) n[s - 1] = arguments[s];
            return t(i.time + e < Date.now(), i.content, n);
          });
        }
        set(e) {
          for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
          super.set({
            leaf: !0,
            time: Date.now(),
            content: e
          }, ...i);
        }
        get() {
          var e;
          return null === (e = super.get(...arguments)) || void 0 === e ? void 0 : e.content;
        }
        keys() {
          return super.keys(...arguments);
        }
      }
      class Ri extends Ai {
        set() {}
        get() {}
      }
      function Vi(e, t, i) {
        return !e || e <= 0 ? new Ri() : new Ti(e, t, i);
      }
      const Ki = 6378137;
      function Ni(e, t, i, r, n) {
        let s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
        const {
            zoomMax: o = 21,
            padding: a = 0,
            worldDimensions: l = {
              height: 256,
              width: 256
            },
            parsedClientPadding: u
          } = s,
          h = (zi(r) - zi(t)) / Math.PI,
          d = n - i,
          c = (d < 0 ? d + 360 : d) / 360,
          {
            width: p,
            height: f
          } = dt(e),
          {
            paddingTop: g = 0,
            paddingRight: m = 0,
            paddingBottom: y = 0,
            paddingLeft: v = 0
          } = u || {},
          b = Ui(f - 2 * a - g - y, l.height, h),
          k = Ui(p - 2 * a - m - v, l.width, c);
        return isFinite(b) ? isFinite(k) ? Math.min(b, k, o) : b : k;
      }
      function ji(e, t, i, r, n) {
        let s = Math.sin(e * Math.PI / 180);
        s = Math.min(Math.max(s, -.9999), .9999);
        const o = 1 << i;
        return [Math.floor(r * (.5 + t / 360) * o / r), Math.floor(n * (.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * o / n)];
      }
      function $i(e, t, i, r, n, s, o) {
        const [a, l] = ji(i, t, n, s, o),
          [u, h] = ji(e, r, n, s, o),
          d = [];
        for (let e = 0; e <= u - a; e++) for (let t = 0; t <= h - l; t++) d.push({
          x: a + e,
          y: l + t
        });
        return d;
      }
      function zi(e) {
        const t = Math.sin(e * Math.PI / 180),
          i = Math.log((1 + t) / (1 - t)) / 2;
        return Math.max(Math.min(i, Math.PI), -Math.PI) / 2;
      }
      function Ui(e, t, i) {
        return Math.floor(Math.log(e / t / i) / Math.LN2 * 1e3) / 1e3;
      }
      function Hi(e) {
        let [t] = e,
          [i] = e;
        return e.forEach(e => {
          t > e ? t = e : i < e && (i = e);
        }), e.length > 1 && i - t > t + 360 - i;
      }
      function Zi(e) {
        return Hi(e.map(e => {
          var t;
          return null !== (t = e.lng) && void 0 !== t ? t : e[1];
        }));
      }
      function qi(e, t) {
        var i, r;
        return (null !== (i = t.lng) && void 0 !== i ? i : t[1]) < (null !== (r = e.lng) && void 0 !== r ? r : e[1]);
      }
      function Qi(e, t, i) {
        const r = Hi(t) && i,
          n = r ? Gi(e) : e,
          s = r ? t.map(Gi) : t;
        let o = n;
        return s.forEach(e => {
          let t = Math.abs(n - o);
          Math.abs(n - e) > t && (o = e);
        }), Lt(o, void 0, i);
      }
      function Wi(e, t) {
        var i, r, n, s;
        const o = Zi([e, t]),
          a = null !== (i = e.lat) && void 0 !== i ? i : e[0],
          l = null !== (r = e.lng) && void 0 !== r ? r : e[1],
          u = o ? Gi(l) : l,
          h = null !== (n = t.lat) && void 0 !== n ? n : t[0],
          d = null !== (s = t.lng) && void 0 !== s ? s : t[1],
          c = o ? Gi(d) : d;
        return h > a ? c < u ? "nw" : "ne" : c > u ? "se" : "sw";
      }
      function Gi(e) {
        return e < 0 ? e + 360 : e;
      }
      function Xi(e, t, i, r, n, s) {
        let o;
        if (i === s) o = Math.pow(r - e, 2) + Math.pow(n - t, 2);else if (i > s) {
          const a = 1 << i - s;
          o = Math.pow(r - e / a, 2) + Math.pow(n - t / a, 2);
        } else {
          const a = 1 << s - i;
          o = Math.pow(r / a - e, 2) + Math.pow(n / a - t, 2);
        }
        return Math.sqrt(o);
      }
      function Yi(e, t) {
        const i = e + t / Ki * (180 / Math.PI);
        return i < -180 ? i + 360 : i > 180 ? i - 360 : i;
      }
      function Ji(e) {
        const t = null == e ? void 0 : e.type;
        if (["Polygon", "MultiPolygon"].includes(t)) {
          let i = [];
          "Polygon" === t ? i.push(e.coordinates) : i.push(...e.coordinates);
          const r = [];
          return i.forEach(e => {
            const t = [];
            e.forEach(e => {
              const i = [];
              e.forEach(e => {
                let [t, r] = e;
                return i.push({
                  lat: r,
                  lng: t
                });
              }), t.push(i);
            }), r.push(t);
          }), r;
        }
        throw new Error(`Geometry ${t} not supported`);
      }
      const er = {
        imageLoaded: "load",
        imageLoadingError: "error"
      };
      function tr(e) {
        const t = new RegExp(/(.*?)[\w,\s-]+\.(gif|jpe?g|tiff?|png|webp|bmp|svg)$/),
          i = new Set();
        return e.forEach(e => {
          if (Z(e)) {
            ue(e, e => {
              var t;
              return "IMG" === (null === (t = e.tagName) || void 0 === t ? void 0 : t.toUpperCase());
            }, !0).forEach(e => {
              const r = e.element.src;
              r && t.test(r) && i.add(r);
            });
          } else t.test(e) && i.add(e);
        }), [...i];
      }
      function ir(e, t, i) {
        const r = [];
        return e.forEach(e => {
          const n = new Image();
          n.src = e, r.push(sr(n, t, i));
        }), Fi(r).then(() => Promise.resolve());
      }
      function rr(e) {
        const t = new Set();
        return Object.keys(e).forEach(i => {
          const r = e[i];
          Object.keys(r).forEach(e => {
            const i = r[e];
            Object.keys(i).forEach(e => {
              const r = i[e];
              r && "none" !== r && t.add(r);
            });
          });
        }), [...t];
      }
      function nr(e) {
        const t = new Set();
        return Object.keys(e).forEach(i => {
          const r = e[i];
          Object.keys(r).forEach(e => {
            const i = r[e];
            i && "none" !== i && t.add(i);
          });
        }), [...t];
      }
      function sr(e, t, i) {
        let r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
        return new Promise((n, s) => {
          t(e, er.imageLoaded, n), t(e, er.imageLoadingError, t => {
            r ? (i.debug(`failed to load image ${e.src}`, null == t ? void 0 : t.stack), n()) : s(new Error(`failed to load image ${e.src}. ${t}`));
          });
        });
      }
      function or(e, t, i) {
        return Z(t) && (!Z(e) || q(t) !== q(e)) || !Z(t) && (Z(e) || i && t !== e);
      }
      const ar = {
        FROM_BASE_MAP: "from-base-map",
        FROM_BASE_MAP_NO_MARKER: "from-base-map-no-marker",
        GOOGLE: "google",
        MAPBOX: "mapbox",
        HOVER: "hover"
      };
      class lr {
        constructor() {}
        _buildClusterService(e, t, i, r, n, s, o) {
          const {
            type: a
          } = n;
          if (a) switch (a) {
            case "supercluster":
              return new vi(e, this._createClusterLabelMethod(t, i, r), n, s, o);
            case "none":
              return;
            default:
              throw new Error(`Unknown cluster type ${a}`);
          }
        }
        createClusterers(e, t, i, r, n, s) {
          const o = {};
          return Object.keys(s).forEach(a => {
            o[a] = [];
            const l = n[a],
              u = s[a];
            qt(Object.keys(l)).forEach(n => {
              const s = l[n],
                h = this._buildClusterService(e, t, i, r, s, u, n);
              h && o[a].push({
                qualifier: n,
                clusterer: h
              });
            });
          }), o;
        }
        _createClusterLabelMethod(e, t, i) {
          return (r, n, s) => {
            const o = void 0 !== n,
              a = e(s, r);
            if (o && -1 !== a.indexOf("{1}")) {
              const o = ii(n, void 0, t, i);
              return e(s, r, o);
            }
            return a;
          };
        }
      }
      var ur = i(569),
        hr = i.n(ur);
      const dr = {
        boundsChanged: "boundsChanged",
        markersChanged: "markersChanged",
        selectionChanged: "selectionChanged",
        hoverChanged: "hoverChanged",
        keyPressed: "keyPressed",
        featureContentLoaded: "featureContentLoaded",
        idle: "idle",
        routeChanged: "routeChanged",
        tilesLoaded: "tilesLoaded",
        tilesContentLoaded: "tilesContentLoaded",
        mapTypeChanged: "mapTypeChanged",
        mapClicked: "mapClicked"
      };
      class cr {
        constructor(e) {
          this.registeredListeners = [], this.logger = e;
        }
        pushEvent(e, t) {
          this.logger.debug(`pushing event: ${e}`);
          for (let i of this.registeredListeners) i.eventType === e && i.callback(t);
        }
        _registerInternalListener(e, t, i) {
          if (t) {
            let n;
            var r;
            if (i) n = this._findInternalListener(e, void 0, i), null !== (r = n) && void 0 !== r && r.id && this._unregisterInternalListener(e, void 0, i), n = void 0;else n = this._findInternalListener(e, t, void 0);
            if (!n) {
              const r = {
                id: i,
                eventType: e,
                callback: t
              };
              return this.registeredListeners.push(r), r;
            }
          }
        }
        _identifyListener(e, t, i, r) {
          return !(e.eventType !== t || r && e.id !== r || i && e.callback !== i);
        }
        _findInternalListener(e, t, i) {
          if (!i && !t) throw new Error("Can't find a listener with no id and no callback provided");
          return this.registeredListeners.find(r => this._identifyListener(r, e, t, i));
        }
        _unregisterInternalListener(e, t, i) {
          const r = this._findInternalListener(e, t, i);
          return r && (this.registeredListeners = this.registeredListeners.filter(r => !this._identifyListener(r, e, t, i))), r;
        }
        addBoundChangeListener(e, t) {
          return !!this._registerInternalListener(dr.boundsChanged, e, t);
        }
        removeBoundChangeListener(e) {
          return !!this._unregisterInternalListener(dr.boundsChanged, e);
        }
        deregisterBoundChangeListener(e) {
          return !!this._unregisterInternalListener(dr.boundsChanged, void 0, e);
        }
        addMarkerChangeListener(e, t) {
          return !!this._registerInternalListener(dr.markersChanged, e, t);
        }
        removeMarkerChangeListener(e) {
          return !!this._unregisterInternalListener(dr.markersChanged, e);
        }
        deregisterMarkerChangeListener(e) {
          return !!this._unregisterInternalListener(dr.markersChanged, void 0, e);
        }
        addSelectionChangeListener(e, t) {
          return !!this._registerInternalListener(dr.selectionChanged, e, t);
        }
        removeSelectionChangeListener(e, t) {
          return !!this._unregisterInternalListener(dr.selectionChanged, e, t);
        }
        deregisterSelectionChangeListener(e) {
          return !!this._unregisterInternalListener(dr.selectionChanged, void 0, e);
        }
        addKeyPressListener(e, t) {
          return !!this._registerInternalListener(dr.keyPressed, e, t);
        }
        removeKeyPressListener(e) {
          return !!this._unregisterInternalListener(dr.keyPressed, e);
        }
        deregisterKeyPressListener(e) {
          return !!this._unregisterInternalListener(dr.keyPressed, void 0, e);
        }
        addHoverChangeListener(e, t) {
          return !!this._registerInternalListener(dr.hoverChanged, e, t);
        }
        removeHoverChangeListener(e) {
          return !!this._unregisterInternalListener(dr.hoverChanged, e);
        }
        deregisterHoverChangeListener(e) {
          return !!this._unregisterInternalListener(dr.hoverChanged, void 0, e);
        }
        addFeatureContentLoadedListener(e, t) {
          return !!this._registerInternalListener(dr.featureContentLoaded, e, t);
        }
        removeFeatureContentLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.featureContentLoaded, e);
        }
        deregisterFeatureContentLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.featureContentLoaded, void 0, e);
        }
        addIdleListener(e, t) {
          return !!this._registerInternalListener(dr.idle, e, t);
        }
        removeIdleListener(e) {
          return !!this._unregisterInternalListener(dr.idle, e);
        }
        deregisterIdleListener(e) {
          return !!this._unregisterInternalListener(dr.idle, void 0, e);
        }
        addRouteChangeListener(e, t) {
          return !!this._registerInternalListener(dr.routeChanged, e, t);
        }
        removeRouteChangeListener(e) {
          return !!this._unregisterInternalListener(dr.routeChanged, e);
        }
        deregisterRouteChangeListener(e) {
          return !!this._unregisterInternalListener(dr.routeChanged, void 0, e);
        }
        addTilesLoadedListener(e, t) {
          return !!this._registerInternalListener(dr.tilesLoaded, e, t);
        }
        removeTilesLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.tilesLoaded, e);
        }
        deregisterTilesLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.tilesLoaded, void 0, e);
        }
        addTilesContentLoadedListener(e, t) {
          return !!this._registerInternalListener(dr.tilesContentLoaded, e, t);
        }
        removeTilesContentLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.tilesContentLoaded, e);
        }
        deregisterTilesContentLoadedListener(e) {
          return !!this._unregisterInternalListener(dr.tilesContentLoaded, void 0, e);
        }
        addMapTypeChangedListener(e, t) {
          return !!this._registerInternalListener(dr.mapTypeChanged, e, t);
        }
        deregisterMapTypeChangedListener(e) {
          return !!this._unregisterInternalListener(dr.mapTypeChanged, void 0, e);
        }
        addMapClickListener(e, t) {
          return !!this._registerInternalListener(dr.mapClicked, e, t);
        }
        deregisterMapClickListener(e) {
          return !!this._unregisterInternalListener(dr.mapClicked, void 0, e);
        }
      }
      class pr {
        constructor(e, t, i) {
          this.id = Kt(), this.origin = e, this.destination = t, this.mode = i, this.distance = void 0;
        }
        toString() {
          var e;
          return `Route: {origin:'${this.origin.id}',destination:${null === (e = this.destination) || void 0 === e ? void 0 : e.id},mode:${this.mode}}`;
        }
        originLatLng() {
          return {
            lat: this.origin.latLng[0],
            lng: this.origin.latLng[1]
          };
        }
        destinationLatLng() {
          return this.destination ? {
            lat: this.destination.latLng[0],
            lng: this.destination.latLng[1]
          } : void 0;
        }
      }
      class fr {
        constructor(e, t, i) {
          let {
            logger: r,
            egDistances: n,
            routeLineStyleByDistanceMode: s,
            routeCacheInMs: o,
            findFeature: a,
            eventsManager: l,
            addRouteOnMap: u,
            removeRouteOnMap: h,
            asKey: d
          } = e;
          this.routes = t, this.routeDestinations = i, this.logger = r, this.egDistances = n, this.routeLineStyleByDistanceMode = s, this.findFeature = a, this.eventsManager = l, this.addRouteOnMap = u, this.removeRouteOnMap = h, this.asKey = d, this.routeCache = Vi(o, void 0, (e, t, i) => "polyline" !== i[0] && e);
        }
        _asRoute(e, t) {
          var i, r;
          const n = {
            origin: (null === (i = this.findFeature(e.origin.id, e.origin.type)) || void 0 === i ? void 0 : i.toData()) || {
              id: e.origin.id,
              type: e.origin.type
            },
            destination: e.destination ? (null === (r = this.findFeature(e.destination.id, e.destination.type)) || void 0 === r ? void 0 : r.toData()) || {
              id: e.destination.id,
              type: e.destination.type
            } : void 0,
            transportMode: e.mode
          };
          return t && (n.distance = e.distance), n;
        }
        _asRouteDestinationFeature(e) {
          const {
            id: t,
            type: i
          } = e.idAndType;
          return {
            destination: t && i ? this.findFeature(t, i) : void 0,
            transportMode: e.transportMode
          };
        }
        _asRouteDestination(e) {
          return {
            idAndType: {
              id: e.destination.id,
              type: e.destination.type
            },
            transportMode: e.mode
          };
        }
        _routeDestinationAsKey(e) {
          const {
            id: t,
            type: i
          } = e.idAndType;
          return `${t}|${i}|${e.transportMode}`;
        }
        _buildCacheKeys(e, t, i, r) {
          const n = [];
          return n.push(e), t && n.push(`${t.id}|${t.type}`), i && n.push(`${i.id}|${i.type}`), r && n.push(r), n;
        }
        _sameRoute(e, t) {
          var i, r, n, s;
          return e.origin.id === t.origin.id && e.origin.type === t.origin.type && (null === (i = e.destination) || void 0 === i ? void 0 : i.id) === (null === (r = t.destination) || void 0 === r ? void 0 : r.id) && (null === (n = e.destination) || void 0 === n ? void 0 : n.type) === (null === (s = t.destination) || void 0 === s ? void 0 : s.type) && e.mode === t.mode;
        }
        _sameFeature(e, t) {
          return e.id === t.id && e.type === t.type;
        }
        _sameRouteDestination(e, t) {
          return e.idAndType.id === t.idAndType.id && e.idAndType.type === t.idAndType.type && e.transportMode === t.transportMode;
        }
        showRoutes(e, t) {
          let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          const r = this._asRouteDestinationFeature.bind(this),
            n = (t && t.length > 0 ? t.map(r) : [...this.listRegisteredRoutes(e).map(e => {
              let {
                destination: t
              } = e;
              return {
                destination: t.idAndType,
                transportMode: t.transportMode
              };
            }), ...this.routeDestinations]).map(t => new pr(e, t.destination, t.transportMode));
          return Fi(n.filter(e => !this.routes.some(t => this._sameRoute(t, e)) && !this._sameFeature(e.origin, e.destination)).map(t => new Promise((i, r) => {
            const {
              destination: n,
              mode: s
            } = t;
            let o;
            const a = "none" === this.routeLineStyleByDistanceMode[t.mode].lineStyle,
              l = a ? void 0 : this.routeCache.get(...this._buildCacheKeys("polyline", e, n, s));
            if (l) o = Promise.resolve(l);else {
              const i = this._buildCacheKeys(a ? "distance" : "route", e, n, s),
                r = this.routeCache.get(...i);
              if (r) o = Promise.resolve(r);else {
                if (!this.egDistances) return Promise.reject("EGDistances is not enabled: routes or distances can't be computed on demand");
                o = a ? this.fetchDistance(t, i) : this.fetchRoute(t, i);
              }
            }
            o.then(e => {
              let {
                route: t,
                egDistanceRoute: r,
                routeResult: n
              } = e;
              t && (this.routes.push(t), r ? this.addRouteOnMap(t, r).then(e => i(t)) : n ? this.addRouteOnMap(t, n).then(e => i(t)) : i(t));
            }).catch(e => r({
              error: e,
              route: t
            }));
          }))).then(e => {
            const t = e.filter(e => "fulfilled" === e.status).map(e => e.value).filter(e => void 0 !== e);
            e.filter(e => "rejected" === e.status).forEach(this._handleReject.bind(this));
            const r = t.map(e => this._asRoute(e, !0));
            return i && r.length > 0 && this._handleRouteChanged(!0, r), r;
          });
        }
        fetchDistance(e, t) {
          return this.egDistances.getDistances(e.originLatLng(), e.destinationLatLng(), e.mode).then(i => {
            if ("SUCCESS" === i.status) {
              e.distance = i.matrix[0][0].modes[e.mode];
              const r = {
                route: e
              };
              return this.routeCache.set(r, ...t), r;
            }
            throw new Error(i.errors.join(", "));
          });
        }
        handleFlight(e) {
          const t = e.originLatLng(),
            i = e.destinationLatLng(),
            r = e;
          return r.copyrights = "", r.warnings = "", r.status = "SUCCESS", r.route = {
            path: [t, i],
            mode: r.mode
          }, Promise.resolve(r);
        }
        fetchRoute(e, t) {
          let i;
          return i = "flying" == e.mode ? this.handleFlight(e) : this.egDistances.getRoute(e.originLatLng(), e.destinationLatLng(), e.mode), i.then(i => {
            if ("SUCCESS" === i.status) {
              e.distance = i.route.distance;
              const r = {
                route: e,
                egDistanceRoute: i
              };
              return this.routeCache.set(r, ...t), r;
            }
            throw new Error(i.error);
          });
        }
        registerRoute(e, t, i) {
          const {
              idAndType: r,
              transportMode: n
            } = t,
            s = this._buildCacheKeys("polyline", e, r, n);
          if (!this._sameFeature(e, r)) if (void 0 !== e.id && e.type && void 0 !== r.id && r.type && i) {
            const t = this.findFeature(e.id, e.type),
              o = this.findFeature(r.id, r.type);
            if (t && o) {
              const e = new pr(t, o, n),
                r = {
                  route: {
                    path: hr().decode(i).map(e => {
                      let [t, i] = e;
                      return {
                        lat: t,
                        lng: i
                      };
                    })
                  }
                };
              return this.routeCache.set({
                route: e,
                routeResult: r
              }, ...s), !0;
            }
          } else this.logger.warn(`Cannot register route from (${e.id}, ${e.type}) to \n          (${r.id}, ${r.type} with polyline ${i}. A mandatory parameter is missing.`);
          return !1;
        }
        updateRoutesOnViewport() {
          const e = [...this.routes];
          return this.hideRoutes().then(() => Promise.all(e.map(e => this.showRoutes(e.origin, [this._asRouteDestination(e)], !1)))).then(() => {});
        }
        listRegisteredRoutes(e) {
          const t = this._buildCacheKeys("polyline", e);
          return this.routeCache.keys(...t).flatMap(e => {
            const t = this.routeCache.get(...e);
            if (t) {
              const {
                route: e,
                routeResult: i
              } = t;
              return [{
                origin: {
                  id: e.origin.id,
                  type: e.origin.type
                },
                destination: {
                  idAndType: {
                    id: e.destination.id,
                    type: e.destination.type
                  },
                  transportMode: e.mode
                },
                polyline: hr().encode(i.route.path)
              }];
            }
            return [];
          });
        }
        deregisterRoute(e, t) {
          const i = this.listRegisteredRoutes(e).filter(e => {
            let {
              destination: i
            } = e;
            return !t || this._sameRouteDestination(i, t);
          }).map(e => {
            const {
                origin: t,
                destination: i
              } = e,
              r = this._buildCacheKeys("polyline", t, i.idAndType, i.transportMode);
            return this.routeCache.set(void 0, ...r), e;
          });
          if (i) {
            const t = this.findFeature(e.id, e.type);
            this.hideRoutes(t, i.map(e => e.destination));
          }
          return i;
        }
        _handleReject(e) {
          const {
            reason: {
              message: t,
              stack: i,
              error: r,
              route: n
            }
          } = e;
          r ? /OVER_QUERY_LIMIT/.test(null == r ? void 0 : r.message) ? this.logger.info(`Error when showing route ${n}: ${r.message}`, r.stack) : this.logger.warn(`Error when showing route ${n}: ${r.message}`, r.stack) : t && this.logger.error(`Error when showing route ${t}`, i);
        }
        hideRoutes(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          const r = this._asRoute.bind(this),
            n = this.asKey,
            s = t.length > 0 ? t.map(e => `${this.asKey(e.idAndType)}-${e.transportMode}`) : void 0;
          return Promise.all(this.routes.filter(t => (!e || t.origin.id === e.id && t.origin.type === e.type) && (!s || s.includes(`${n(t.destination)}-${t.mode}`))).map(e => this.removeRouteOnMap(e).then(() => (this.routes.splice(this.routes.findIndex(t => e === t), 1), e)))).then(e => (i && e.length > 0 && this._handleRouteChanged(!1, e), e.map(e => r(e))));
        }
        listRoutesDisplayed() {
          return this.routes.map(e => this._asRoute(e, !0));
        }
        _handleRouteChanged(e, t) {
          const i = {
            routes: t,
            action: e ? "show" : "hide"
          };
          this.eventsManager.pushEvent(dr.routeChanged, i);
        }
        registerRouteDestination() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
          t.forEach(e => {
            var t;
            if (null === (t = this.listRegisteredRouteDestinations()) || void 0 === t || !t.map(this._routeDestinationAsKey).includes(this._routeDestinationAsKey(e))) {
              const {
                  id: t,
                  type: i
                } = e.idAndType,
                r = e.transportMode,
                n = this.findFeature(t, i);
              n && this.routeDestinations.push({
                destination: n,
                transportMode: r
              });
            }
          });
        }
        listRegisteredRouteDestinations() {
          return this.routeDestinations.flatMap(e => {
            const t = e.destination,
              i = e.transportMode;
            return t ? [{
              idAndType: {
                id: t.id,
                type: t.type
              },
              transportMode: i
            }] : [];
          });
        }
        deregisterRouteDestination() {
          const e = [];
          for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++) i[r] = arguments[r];
          return i.forEach(t => {
            const {
                id: i,
                type: r
              } = t.idAndType,
              n = t.transportMode,
              s = this.routeDestinations.findIndex(e => e.destination && e.destination.id === i && e.destination.type === r && e.transportMode === n);
            s >= 0 && (this.routeDestinations.splice(s, 1), e.push(t));
          }), this.hideRoutes(void 0, e), e;
        }
      }
      const {
        firstDefinedValue: gr,
        removeDuplicates: mr
      } = t;
      class yr {
        constructor(e) {
          let {
            logger: t,
            findFeature: i,
            addPolygonsOnMap: r,
            removePolygonsOnMap: n,
            asKey: s,
            polygons: o,
            polygonStyles: a
          } = e;
          this.logger = t, this.findFeature = i, this.addPolygonsOnMap = r, this.removePolygonsOnMap = n, this.asKey = s, this.polygons = o, this.polygonStyles = a, this.polygons.length > 0 && this.showPolygons(...this.polygons);
        }
        _isPolygonDisplayed(e) {
          return this.polygons.some(t => this.asKey(t) === this.asKey(e));
        }
        _isPolygonNotDisplayed(e) {
          return !this._isPolygonDisplayed(e);
        }
        showPolygons() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
          const r = mr(t.filter(this._isPolygonNotDisplayed.bind(this))),
            n = this._findPolygonToDisplay(r);
          return this.addPolygonsOnMap(n).then(e => (this.polygons.push(...e), e));
        }
        hidePolygons() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
          const r = t.length > 0 ? t.filter(this._isPolygonDisplayed.bind(this)) : [...this.polygons];
          return this.removePolygonsOnMap(r).then(e => (e.forEach(e => {
            this.polygons.splice(this.polygons.indexOf(e), 1);
          }), e));
        }
        _findPolygonToDisplay(e) {
          return e.map(e => {
            let {
              id: t,
              type: i
            } = e;
            const r = this.findFeature(t, i);
            if (r && r.polygon) {
              const e = gr(this.polygonStyles[i], r.hashKeys);
              return {
                polygonDisplayed: {
                  id: t,
                  type: i,
                  polygon: r.polygon
                },
                style: e
              };
            }
          }).filter(e => void 0 !== e);
        }
        listPolygonsDisplayed() {
          return this._findPolygonToDisplay(this.polygons).map(e => e.polygonDisplayed);
        }
        updatePolygonsOnViewport() {
          const e = [...this.polygons];
          return this.hidePolygons().then(() => this.showPolygons(...e)).then(() => {});
        }
      }
      function vr(e, t) {
        return !!t && e.from === t.from && e.to === t.to && Dt(e.roomOccupancies, t.roomOccupancies, !1, (e, t) => function (e, t) {
          return (e.nbAdults || 0) === (t.nbAdults || 0) && Dt(e.childrenAges || [], t.childrenAges || []);
        }(e, t));
      }
      class br {
        constructor(e, t) {
          this.availabilityProvider = t, this.logger = e("AvailabilityCheck"), this.availabilityProvider = void 0, this.featureComputationInProgress = new Map(), this.stay = void 0;
        }
        saveStay(e) {
          return !(!e || this.stay && vr(e, this.stay)) && (this.stay = e, this.featureComputationInProgress.clear(), !0);
        }
        isAvailabilityCheckActive() {
          return void 0 !== this.availabilityProvider && void 0 !== this.stay;
        }
        updateAvailability(e) {
          if (!this.isAvailabilityCheckActive()) return Promise.resolve([]);
          const {
              stay: t
            } = this,
            i = [],
            r = Date.now(),
            n = e.length,
            s = new Map();
          for (let t = 0; t < n; t++) {
            const n = e[t],
              {
                id: o
              } = n;
            !this.featureComputationInProgress.has(o) && n.hasTileData() && "unknown" === n.toTileData().status && (i.push(o), s.set(o, t), this.featureComputationInProgress.set(o, r));
          }
          if (0 === i.length) return Promise.resolve([]);
          const o = [],
            a = wt(i, 300),
            l = a.length;
          for (let e = 0; e < l; e++) o.push(this.availabilityProvider.checkAvailability(t, a[e]));
          return Fi(o).then(i => (i.filter(e => "rejected" === e.status).forEach(e => {
            this.logger.error(`Check availability failed with result ${e.reason}`);
          }), i.filter(e => "fulfilled" === e.status).map(i => i.value.map(i => {
            const r = s.get(i.id);
            if (r >= 0 && this.stay === t) {
              const t = e[r];
              return t.mergeTileData(i), t;
            }
          }).filter(e => void 0 !== e)).flat())).finally(() => {
            i.forEach(e => this.featureComputationInProgress.delete(e));
          });
        }
      }
      var kr = {
          variant: "var",
          defaultClusterProductLabel: "prodClusterLbl",
          defaultClusterPropertyLabel: "propClusterLbl",
          defaultClusterPlaceLabel: "placeClusterLbl",
          keyboardFeaturesNoData: "keybFeatNoData",
          keyboardFeaturesPreviousPage: "keybFeatPrev",
          keyboardFeaturesNextPage: "keybFeatNext",
          filterBoxLegend: "fboxLegend",
          ariaFilterBoxToggleLegend: "ariaFboxTglLegend",
          ariaFilterBoxImgProductAvailable: "ariaFboxImgProdAvailable",
          ariaFilterBoxImgProductFiltered: "ariaFboxImgProdFiltered",
          ariaFilterBoxImgProductSoldOut: "ariaFboxImgProdSoldOut",
          ariaFilterBoxImgProductUnknown: "ariaFboxImgProdUnknown",
          ariaFilterBoxImgPropertyAvailable: "ariaFboxImgPropAvailable",
          ariaFilterBoxImgPropertyFiltered: "ariaFboxImgPropFiltered",
          ariaFilterBoxImgPropertySoldOut: "ariaFboxImgPropSoldOut",
          ariaFilterBoxImgPropertyUnknown: "ariaFboxImgPropUnknown",
          ariaFilterBoxCheckBoxProductAvailable: "ariaFboxCbProdAvailable",
          ariaFilterBoxCheckBoxProductFiltered: "ariaFboxCbProdFiltered",
          ariaFilterBoxCheckBoxProductSoldOut: "ariaFboxCbProdSoldOut",
          ariaFilterBoxCheckBoxProductUnknown: "ariaFboxCbProdUnknown",
          ariaFilterBoxCheckBoxPropertyAvailable: "ariaFboxCbPropAvailable",
          ariaFilterBoxCheckBoxPropertyFiltered: "ariaFboxCbPropFiltered",
          ariaFilterBoxCheckBoxPropertySoldOut: "ariaFboxCbPropSoldOut",
          ariaFilterBoxCheckBoxPropertyUnknown: "ariaFboxCbPropUnknown",
          filterBoxProductAvailable: "fboxProductAvailable",
          filterBoxProductFiltered: "fboxProductFiltered",
          filterBoxProductSoldOut: "fboxProductSoldOut",
          filterBoxProductUnknown: "fboxProductUnknown",
          filterBoxPropertyAvailable: "fboxPropertyAvailable",
          filterBoxPropertyFiltered: "fboxPropertyFiltered",
          filterBoxPropertySoldOut: "fboxPropertySoldOut",
          filterBoxPropertyUnknown: "fboxPropertyUnknown",
          filterBoxPlaceUnknown: "fboxPlaceUnknown",
          ariaFilterBoxImgPlaceUnknown: "ariaFboxImgPlaceUnknown",
          ariaFilterBoxCheckBoxPlaceUnknown: "ariaFboxCbPlaceUnknown"
        },
        Mr = {
          default: {
            [kr.variant]: "default",
            [kr.defaultClusterProductLabel]: "{0} products",
            [kr.defaultClusterPropertyLabel]: "{0} properties",
            [kr.defaultClusterPlaceLabel]: "{0} places",
            [kr.keyboardFeaturesNoData]: "no data",
            [kr.keyboardFeaturesPreviousPage]: "Show previous...",
            [kr.keyboardFeaturesNextPage]: "Show next...",
            [kr.filterBoxLegend]: "Legend",
            [kr.ariaFilterBoxToggleLegend]: "Toggle legend",
            [kr.ariaFilterBoxImgProductAvailable]: "icon used for products matching dates and criteria",
            [kr.ariaFilterBoxImgProductFiltered]: "icon used for products matching dates but not your criteria",
            [kr.ariaFilterBoxImgProductSoldOut]: "icon used for products not available for these dates",
            [kr.ariaFilterBoxImgProductUnknown]: "icon used for products with no availability information for these dates",
            [kr.ariaFilterBoxImgPropertyAvailable]: "icon used for properties matching dates and criteria",
            [kr.ariaFilterBoxImgPropertyFiltered]: "icon used for properties matching dates but not your criteria",
            [kr.ariaFilterBoxImgPropertySoldOut]: "icon used for properties not available for these dates",
            [kr.ariaFilterBoxImgPropertyUnknown]: "icon used for properties with no availability information for these dates",
            [kr.ariaFilterBoxCheckBoxProductAvailable]: "filter products matching dates and criteria",
            [kr.ariaFilterBoxCheckBoxProductFiltered]: "filter products matching dates but not your criteria",
            [kr.ariaFilterBoxCheckBoxProductSoldOut]: "filter products sold out for these dates",
            [kr.ariaFilterBoxCheckBoxProductUnknown]: "filter products with no availability information for these dates",
            [kr.ariaFilterBoxCheckBoxPropertyAvailable]: "filter properties matching dates and criteria",
            [kr.ariaFilterBoxCheckBoxPropertyFiltered]: "filter properties matching dates but not your criteria",
            [kr.ariaFilterBoxCheckBoxPropertySoldOut]: "filter properties sold out for these dates",
            [kr.ariaFilterBoxCheckBoxPropertyUnknown]: "filter properties with no availability information for these dates",
            [kr.filterBoxProductAvailable]: "Matches dates and criteria",
            [kr.filterBoxProductFiltered]: "Doesn’t match your criteria",
            [kr.filterBoxProductSoldOut]: "Sold out for these dates",
            [kr.filterBoxProductUnknown]: "Availability unknown",
            [kr.filterBoxPropertyAvailable]: "Matches dates and criteria",
            [kr.filterBoxPropertyFiltered]: "Doesn’t match your criteria",
            [kr.filterBoxPropertySoldOut]: "Sold out for these dates",
            [kr.filterBoxPropertyUnknown]: "Availability unknown",
            [kr.filterBoxPlaceUnknown]: "Places",
            [kr.ariaFilterBoxImgPlaceUnknown]: "icon used for places",
            [kr.ariaFilterBoxCheckBoxPlaceUnknown]: "filter places"
          },
          "en-US": {
            [kr.variant]: "en-US"
          },
          en: {
            [kr.variant]: "en"
          },
          fr: {
            [kr.variant]: "fr",
            [kr.defaultClusterProductLabel]: "{0} établissements",
            [kr.defaultClusterPropertyLabel]: "{0} établissements",
            [kr.defaultClusterPlaceLabel]: "{0} points d'intérêt",
            [kr.keyboardFeaturesNoData]: "Pas de données",
            [kr.keyboardFeaturesPreviousPage]: "Afficher les précédents...",
            [kr.keyboardFeaturesNextPage]: "Afficher les suivants...",
            [kr.filterBoxLegend]: "Légende",
            [kr.ariaFilterBoxToggleLegend]: "Afficher la légende",
            [kr.ariaFilterBoxImgProductAvailable]: "icône pour les établissements disponibles et vérifiant les critères",
            [kr.ariaFilterBoxImgProductFiltered]: "icône pour les établissements disponibles mais ne vérifiant pas les critères",
            [kr.ariaFilterBoxImgProductSoldOut]: "icône pour les établissements non disponibles pour les dates",
            [kr.ariaFilterBoxImgProductUnknown]: "icône pour les établissements sans information de disponibilité",
            [kr.ariaFilterBoxImgPropertyAvailable]: "icône pour les établissements disponibles et vérifiant les critères",
            [kr.ariaFilterBoxImgPropertyFiltered]: "icône pour les établissements disponibles mais ne vérifiant pas les critères",
            [kr.ariaFilterBoxImgPropertySoldOut]: "icône pour les établissements non disponibles pour les dates",
            [kr.ariaFilterBoxImgPropertyUnknown]: "icône pour les établissements sans information de disponibilité",
            [kr.ariaFilterBoxCheckBoxProductAvailable]: "filtre pour les établissements disponibles et vérifiant les critères",
            [kr.ariaFilterBoxCheckBoxProductFiltered]: "filtre pour les établissements disponibles mais ne vérifiant pas les critères",
            [kr.ariaFilterBoxCheckBoxProductSoldOut]: "filtre pour les établissements non disponibles pour les dates",
            [kr.ariaFilterBoxCheckBoxProductUnknown]: "filtre pour les établissements sans information de disponibilité",
            [kr.ariaFilterBoxCheckBoxPropertyAvailable]: "filtre pour les établissements disponibles et vérifiant les critères",
            [kr.ariaFilterBoxCheckBoxPropertyFiltered]: "filtre pour les établissements disponibles mais ne vérifiant pas les critères",
            [kr.ariaFilterBoxCheckBoxPropertySoldOut]: "filtre pour les établissements non disponibles pour les dates",
            [kr.ariaFilterBoxCheckBoxPropertyUnknown]: "filtre pour les établissements sans information de disponibilité",
            [kr.filterBoxProductAvailable]: "Disponibles",
            [kr.filterBoxProductFiltered]: "Disponibles mais filtrés",
            [kr.filterBoxProductSoldOut]: "Indisponible",
            [kr.filterBoxProductUnknown]: "Disponibilité inconnue",
            [kr.filterBoxPropertyAvailable]: "Disponibles",
            [kr.filterBoxPropertyFiltered]: "Disponibles mais filtrés",
            [kr.filterBoxPropertySoldOut]: "Indisponible",
            [kr.filterBoxPropertyUnknown]: "Disponibilité inconnue",
            [kr.filterBoxPlaceUnknown]: "Points d'intérêt",
            [kr.ariaFilterBoxImgPlaceUnknown]: "icône pour les point d'intérêts",
            [kr.ariaFilterBoxCheckBoxPlaceUnknown]: "filtre pour les point d'intérêts"
          }
        };
      const Cr = ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        wr = {
          cluster: {
            available: 9,
            filtered: 7,
            sold_out: 3,
            unknown: 1
          },
          product: {
            available: 10,
            filtered: 8,
            sold_out: 4,
            unknown: 2
          },
          property: {
            available: 10,
            filtered: 8,
            sold_out: 4,
            unknown: 2
          },
          place: {
            unknown: 5
          }
        },
        xr = "keydown",
        Pr = "keypress",
        Fr = "no-data",
        Lr = "keyboard-features-enabled",
        _r = "keyboard-features-list",
        Or = "keyboard-features-list-element",
        Er = "keyboard-features-list-element-info",
        Ir = "keyboard-features-list-element-number",
        Dr = "keyboard-features-list-element-div",
        Sr = "keyboard-features-list-nav",
        Br = "keyboard-features-not-in-list-marker",
        Ar = "kbc-button";
      class Tr {
        constructor(e, t) {
          this.keyboardFeaturesIcon = e, this.getI18N = t, this.keyboardNavigationMode = !1, this.keyPressZero = 48, this.keyDownBackspace = 8, this.pageIndex = 0, this.pageCount = 0, this.uiElementIds = [];
        }
        init(e) {
          let {
            node: t,
            uniqId: i,
            containerBounds: r,
            listFeatures: n,
            zIndexes: s,
            maxZIndex: o,
            getMapNavFocusElement: a,
            registerListenerOnMapFocusElement: l,
            handleClick: u,
            actionsOnClick: h,
            isFeatureSelected: d,
            clearSelectedFeature: c
          } = e;
          this.node = t, this.containerBounds = r, this.listFeatures = n, this.zIndexes = s, this.maxZIndex = o, this.getMapNavFocusElement = a, this.registerListenerOnMapFocusElement = l, this.handleClick = u, this.actionsOnClick = h, this.isFeatureSelected = d, this.clearSelectedFeature = c;
          const p = i("keyboard-features");
          this._createKeyboardFeaturesIcon(p), this._createKeyboardFeaturesSquare(p), this._createKeyboardFeaturesList(p), this._initializeListeners();
        }
        removeAllUIElements() {
          this.uiElementIds.forEach(e => ce(this.node, e));
        }
        _createKeyboardFeaturesIcon(e) {
          const t = `${e}-icon`;
          this.keyboardIcon = me(t, this.node, "keyboard-features-icon", void 0), this.uiElementIds.push(t), this.keyboardNavigationMode || je(this.keyboardIcon);
          const i = this.keyboardFeaturesIcon;
          Ae(Pe(`${e}-img`, this.keyboardIcon, "keyboard-features-icon-img", void 0, i, "icon to show that keyboard features is enabled")), He(this.keyboardIcon, this.maxZIndex + 1);
        }
        _createKeyboardFeaturesSquare(e) {
          const t = `${e}-focus`;
          this.focusArea = me(t, this.node, "keyboard-features-focus-area", void 0), this.uiElementIds.push(t), this.keyboardNavigationMode || je(this.focusArea), He(this.focusArea, this.maxZIndex + 1);
        }
        _createKeyboardFeaturesList(e) {
          const t = `${e}-features`;
          this.keybNavFeatures = me(t, this.node, "keyboard-features-dialog", void 0), this.uiElementIds.push(t), this.keybNavFeaturesList = ye(`${e}-list`, this.keybNavFeatures, `${_r} ${Fr}`, void 0), this.keybNavFeaturesElements = [];
          for (let t = 0; t < 7; t++) {
            const i = ve(`${e}-elt-${t + 1}`, this.keybNavFeaturesList, `${Or} ${Fr}`, void 0);
            Me(`${i.id}-info`, i, Er, void 0, "-"), this.keybNavFeaturesElements.push(i);
          }
          const i = this.getI18N(kr.keyboardFeaturesNoData);
          this.keybNavNoFeatures = Me(`${e}-nodata`, this.keybNavFeatures, `${_r}-no-feature-message`, void 0, i), this.keyboardNavigationMode || je(this.keybNavFeatures), He(this.keybNavFeatures, this.maxZIndex + 1);
          const r = `${Or} ${Sr} ${Sr}-previous ${Fr}`,
            n = ve(`${e}-elt-prev`, this.keybNavFeaturesList, r, void 0),
            s = this.getI18N(kr.keyboardFeaturesPreviousPage),
            o = me(`${n.id}-container`, n, Dr, void 0);
          Me(`${n.id}-number`, o, `${Ir} ${Ar}`, void 0, Cr[7]), Me(`${n.id}-info`, o, Er, void 0, s), this.keybNavFeaturesElements.push(n);
          const a = `${Or} ${Sr} ${Sr}-next ${Fr}`,
            l = ve(`${e}-elt-next`, this.keybNavFeaturesList, a, void 0),
            u = this.getI18N(kr.keyboardFeaturesNextPage),
            h = me(`${l.id}-container`, l, Dr, void 0);
          Me(`${l.id}-number`, h, `${Ir} ${Ar}`, void 0, Cr[8]), Me(`${l.id}-info`, h, Er, void 0, u), this.keybNavFeaturesElements.push(l);
        }
        _clickFeatureAtIndex(e) {
          const t = this.features[7 * this.pageIndex + e];
          if (t) return this.isFeatureSelected(t) ? this.clearSelectedFeature() : (this.handleClick(t, !0, this.actionsOnClick, "dialog-keyboard-pressed"), "cluster" !== t.type && ms(t.marker)), !0;
        }
        _paginateFeaturePage(e) {
          return e && this.pageIndex < this.pageCount - 1 ? (this.pageIndex += 1, !0) : !e && this.pageIndex > 0 && (this.pageIndex -= 1, !0);
        }
        _clearSelectedFeature() {
          return this.clearSelectedFeature(), !0;
        }
        _initializeListeners() {
          this.registerListenerOnMapFocusElement(Pr, e => {
            const t = (e.which || e.keyCode || e.key) - this.keyPressZero;
            let i = !1;
            t >= 0 && t <= 9 && (e.preventDefault(), 0 === t ? this._clearSelectedFeature() : t <= 7 ? this._clickFeatureAtIndex(t - 1) : i = 8 === t ? this._paginateFeaturePage(!1) : this._paginateFeaturePage(!0), i && this._updateKeyboardFeaturesDialog());
          }), this.registerListenerOnMapFocusElement(xr, e => {
            Number(e.which || e.keyCode || e.key) === this.keyDownBackspace && (e.preventDefault(), this.clearSelectedFeature(), this._updateKeyboardFeaturesDialog());
          });
        }
        refreshKeyboardNavIconVisibility(e) {
          (void 0 !== e ? e : this.keyboardNavigationMode) ? $e(this.keyboardIcon) : je(this.keyboardIcon);
        }
        _resetFeatures(e) {
          const t = this._resetMarker.bind(this);
          e && e.forEach(t);
        }
        _resetMarker(e) {
          e && e.marker && Ge(e.marker.cssElement, Br) && (rt(e.marker.cssElement, Br), gs(e.marker, ft(this.zIndexes[e.type], e.hashKeys)));
        }
        _updateFeatureMarkersAsNotInList(e) {
          e && e.forEach(e => {
            gs(e.marker, 1), tt(e.marker.cssElement, Br);
          });
        }
        _clear() {
          this._resetFeatures(this.features);
        }
        turnKeyboardFeaturesMode(e) {
          if (!this.node) throw new Error("You need to have the map initialized to turn on the keyboard navigation");
          this.keyboardNavigationMode = e, e ? tt(this.node, Lr) : rt(this.node, Lr), this.keyboardNavigationMode && document.activeElement === this.getMapNavFocusElement() ? $e(this.keyboardIcon) : je(this.keyboardIcon), this.keyboardNavigationMode ? ($e(this.focusArea), $e(this.keybNavFeatures)) : (je(this.focusArea), je(this.keybNavFeatures)), this.keyboardNavigationMode || this._clear();
        }
        isKeyboardFeaturesModeEnabled() {
          return this.keyboardNavigationMode;
        }
        _computeScore(e) {
          return wr[e.type][e.status || ("cluster" === e.type ? "available" : "unknown")] + (e.score || 0) * (e.score < 1 ? 1 : Math.pow(10, -("" + e.score).split(".")[0].length)) + Math.pow(10, -5) * (e.children || []).length;
        }
        _prioritizeFeaturesForKeyboardNav(e, t) {
          const i = this._computeScore(e),
            r = this._computeScore(t);
          return i === r ? ("" + e.name).localeCompare(t.name) : r - i;
        }
        updateKeyboardFeatures() {
          if (this.keyboardNavigationMode) {
            const e = this.containerBounds(this.focusArea);
            e && (this._resetFeatures(this.features), this.features = this.listFeatures(e => e.visible, e).sort(this._prioritizeFeaturesForKeyboardNav.bind(this)), this.pageCount = 0 === this.features.length ? 0 : Math.floor((this.features.length - 1) / 7 + 1), this.pageIndex >= this.pageCount && (this.pageIndex = 0), this._updateKeyboardFeaturesDialog());
          }
        }
        _updateKeyboardFeaturesDialog() {
          0 === this.pageCount ? tt(this.keybNavFeaturesList, Fr) : rt(this.keybNavFeaturesList, Fr);
          const e = [];
          for (let r = 0; r < 7; r++) {
            var t;
            const n = null === (t = this.keybNavFeaturesElements) || void 0 === t ? void 0 : t[r];
            if (n) {
              he(n);
              const t = this.features[7 * this.pageIndex + r];
              if (t) {
                rt(n, Fr);
                const s = me(`${n.id}-container`, n, Dr, void 0);
                if (Me(`${n.id}-number`, s, `${Ir} ${Ar}`, void 0, Cr[r]), t.marker) {
                  this._resetMarker(t);
                  const e = t.marker.clone();
                  var i;
                  if (e) ot(e, null == e || null === (i = e.dataset) || void 0 === i ? void 0 : i.cloneStyles), ne(e, void 0, !0).map(e => e.element).forEach(e => lt(e));
                  if (tt(e, "keyboard-features-list-element-icon"), "cluster" === t.type) {
                    const [t] = ne(e, ["cluster-label-content"], !0).map(e => e.element);
                    tt(t, "no-text-overflow"), t.innerHTML = t.innerHTML.replace(/\s/g, " ");
                  }
                  s.appendChild(e);
                }
                e.push(t), "cluster" !== t.type && Me(`${n.id}-info-${t.id}`, s, Er, void 0, t.name || `${t.type} ${t.id}`);
              } else tt(n, Fr);
            }
          }
          this._updateFeatureMarkersAsNotInList((this.features || []).filter(t => !e.includes(t) && t.marker));
          const [,,,,,,, r, n] = this.keybNavFeaturesElements || [];
          this._updateNavButton(r, this.pageCount <= 1, 0 === this.pageIndex), this._updateNavButton(n, this.pageCount <= 1, this.pageIndex === this.pageCount - 1);
        }
        _updateNavButton(e, t, i) {
          const r = "disabled";
          t ? (tt(e, Fr), rt(e, r)) : (rt(e, Fr), i ? tt(e, r) : rt(e, r));
        }
      }
      const Rr = "ArrowUp",
        Vr = "ArrowDown",
        Kr = "ArrowRight",
        Nr = "ArrowLeft",
        jr = "+",
        $r = "-",
        zr = "moveKeyboard",
        Ur = "zoomInKeyboard",
        Hr = "zoomOutKeyboard",
        Zr = {
          [zr]: "center_changed",
          [Ur]: "zoom_changed",
          [Hr]: "zoom_changed"
        };
      class qr {
        constructor(e, t, i) {
          this.panBy = e, this.zoomIn = t, this.zoomOut = i, this.events = [], this.deltaX = 5, this.deltaY = 5, this.keyDownListenerCallback = this._keyDownListenerCallback.bind(this), this.keyUpListenerCallback = this._keyUpListenerCallback.bind(this), this.keyPressListenerCallback = this._keyPressListenerCallback.bind(this);
        }
        _panUntil(e, t, i) {
          this.panBy(e), setTimeout(() => {
            if (t()) {
              const e = i();
              this._panUntil(e, t, i);
            }
          }, 40);
        }
        _keyDownListenerCallback(e) {
          const {
            key: t
          } = e;
          if ([Rr, Vr, Nr, Kr].includes(t)) switch (e.preventDefault(), t) {
            case Rr:
              this.keyUpPressed || (this.keyUpPressed = !0, this._panUntil([0, -this.deltaY], () => this.keyUpPressed, () => (this.deltaY < 100 && (this.deltaY += 7), [0, -this.deltaY])));
              break;
            case Vr:
              this.keyDownPressed || (this.keyDownPressed = !0, this._panUntil([0, this.deltaY], () => this.keyDownPressed, () => (this.deltaY < 100 && (this.deltaY += 7), [0, this.deltaY])));
              break;
            case Nr:
              this.keyLeftPressed || (this.keyLeftPressed = !0, this._panUntil([-this.deltaX, 0], () => this.keyLeftPressed, () => (this.deltaX < 100 && (this.deltaX += 7), [-this.deltaX, 0])));
              break;
            case Kr:
              this.keyRightPressed || (this.keyRightPressed = !0, this._panUntil([this.deltaX, 0], () => this.keyRightPressed, () => (this.deltaX < 100 && (this.deltaX += 7), [this.deltaX, 0])));
          }
        }
        _keyUpListenerCallback(e) {
          const {
            key: t
          } = e;
          if ([Rr, Vr, Nr, Kr].includes(t)) {
            switch (e.preventDefault(), t) {
              case Rr:
                this.keyUpPressed = !1, this.deltaY = 5;
                break;
              case Vr:
                this.keyDownPressed = !1, this.deltaY = 5;
                break;
              case Nr:
                this.keyLeftPressed = !1, this.deltaX = 5;
                break;
              case Kr:
                this.keyRightPressed = !1, this.deltaX = 5;
            }
            this.events.splice(0, 0, zr);
          }
        }
        _keyPressListenerCallback(e) {
          const {
            key: t
          } = e;
          if ([jr, $r].includes(t)) switch (e.preventDefault(), t) {
            case jr:
              this.events.splice(0, 0, Ur), this.zoomIn();
              break;
            case $r:
              this.events.splice(0, 0, Hr), this.zoomOut();
          }
        }
        extractKeyboardEvent(e) {
          const t = this.events.filter(t => Zr[t] === e);
          return this.events = this.events.filter(t => Zr[t] !== e), xt(t);
        }
      }
      class Qr {
        constructor() {}
        isValid() {
          throw new Error("method isValid not implemented");
        }
        loadContent(e, t) {
          return Promise.reject("method loadContent not implemented");
        }
      }
      function Wr(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function Gr(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Wr(Object(i), !0).forEach(function (t) {
            Xr(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Wr(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function Xr(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      const {
          firstDefinedValue: Yr,
          listHashKeysSorted: Jr
        } = t,
        en = {
          GooglePlacesApi: (e, t, i, r) => {
            if ("undefined" != typeof egmapsGoogleMaps) return new egmapsGoogleMaps.GooglePlaceContentProvider(e, t("GooglePlaceContentProvider"), i, r);
            throw new Error("You need to load '@eg-maps/google-maps' to use this content provider");
          }
        };
      class tn {
        constructor(e, t, i, r, n, s) {
          this.eventsManager = t;
          const o = new Map();
          this.featureTypeProviders = {}, r.forEach(t => {
            const r = {},
              a = n[t];
            Object.keys(a).forEach(t => {
              a[t].forEach(n => {
                let a = o.get(n);
                if (void 0 === a) {
                  const t = s[n],
                    r = en[t.type];
                  r && (a = r(n, e, i, t), o.set(n, a));
                }
                a && a.isValid() && (void 0 === r[t] && (r[t] = []), r[t].push(a));
              });
            }), this.featureTypeProviders[t] = r;
          });
        }
        loadFeatureContent(e, t) {
          const i = void 0 !== e.toData ? e.toData() : e,
            {
              type: r,
              qualifiers: n,
              status: s
            } = e,
            o = Jr(s, !1, n),
            a = Yr(this.featureTypeProviders[r], o);
          if (a && a.length > 0) {
            let e = a[0].loadContent(Gr(Gr({}, i), {}, {
              qualifiers: [],
              lat: void 0,
              lng: void 0,
              status: void 0
            })).then(e => ({
              contentLoaded: void 0 !== e,
              f: e || i
            }));
            return a.slice(1).forEach(t => {
              e = e.then(e => {
                let {
                  contentLoaded: r,
                  f: n
                } = e;
                return t.loadContent(n).then(e => ({
                  contentLoaded: r || void 0 !== e,
                  f: e || i
                }));
              });
            }), t && (e = e.then(e => {
              let {
                contentLoaded: t,
                f: i
              } = e;
              if (t) {
                const {
                    id: e,
                    type: t,
                    additionalContent: r
                  } = i,
                  n = {
                    success: !0,
                    id: e,
                    type: t,
                    content: r
                  };
                this.eventsManager.pushEvent(dr.featureContentLoaded, n);
              }
              return {
                contentLoaded: t,
                f: i
              };
            })), e;
          }
          return Promise.resolve({
            contentLoaded: !1,
            f: i
          });
        }
      }
      class rn {
        constructor(e, t, i, r) {
          [e, t, i, r].some(e => "object" == typeof e && e.lng && e.lat) ? (this.x1 = i.lng, this.x2 = t.lng, this.y1 = e.lat, this.y2 = t.lat) : (this.x1 = e, this.x2 = i, this.y1 = t, this.y2 = r), this.coordinates = [{
            lng: this.x2,
            lat: this.y1
          }, {
            lng: this.x2,
            lat: this.y2
          }, {
            lng: this.x1,
            lat: this.y2
          }, {
            lng: this.x1,
            lat: this.y1
          }, {
            lng: this.x2,
            lat: this.y1
          }];
        }
        getCoordinates() {
          return this.coordinates;
        }
        getOriginPoints() {
          return [this.x1, this.y1, this.x2, this.y2];
        }
        containsPoint(e, t) {
          return this.x1 <= e && e <= this.x2 && this.y1 <= t && t <= this.y2;
        }
        containsBoundingBox(e) {
          const t = e.getOriginPoints();
          return this.containsPoint(t[0], t[1]) && this.containsPoint(t[2], t[3]);
        }
      }
      function nn(e, t, i, r) {
        return [{
          lng: i,
          lat: t
        }, {
          lng: i,
          lat: r
        }, {
          lng: e,
          lat: r
        }, {
          lng: e,
          lat: t
        }, {
          lng: i,
          lat: t
        }];
      }
      function sn(e, t) {
        const {
            lowerQuantile: i = .1,
            upperQuantile: r = .9,
            marginMultiplier: n = .2,
            minMargin: s = .01
          } = e,
          o = t.map(e => e.lat || e[0]),
          a = t.map(e => e.lng || e[1]);
        let l, u, h, d;
        a.length > 10 ? (l = on(a, i), u = on(a, r), h = on(o, i), d = on(o, r)) : {
          lowerLongitude: l,
          upperLongitude: u,
          lowerLatitude: h,
          upperLatitude: d
        } = function (e, t) {
          return {
            lowerLongitude: Math.min(...e),
            upperLongitude: Math.max(...e),
            lowerLatitude: Math.min(...t),
            upperLatitude: Math.max(...t)
          };
        }(a, o);
        const c = Math.max(n * (u - l), s),
          p = Math.max(n * (d - h), s);
        return new rn(l - c, h - p, u + c, d + p);
      }
      function on(e, t) {
        const i = e.sort((e, t) => e - t);
        let r = (i.length - 1) * t,
          n = Math.floor(r),
          s = r - n;
        return void 0 !== i[n + 1] ? i[n] + s * (i[n + 1] - i[n]) : i[n];
      }
      function an(e, t) {
        const [i, r, n, s] = e.getOriginPoints(),
          o = n - i,
          a = s - r,
          l = (r + s) / 2,
          u = 1 / Math.cos(l * Math.PI / 180),
          h = u * (a / o);
        if (h > t) {
          const e = (u * a / t - o) / 2;
          return nn(i - e, r, n + e, s);
        }
        if (h < t) {
          const e = (o * t / u - a) / 2;
          return nn(i, r - e, n, s + e);
        }
        return e.getCoordinates();
      }
      class ln {
        computeBoundingBox(e, t, i, r, n) {
          if (!e || 0 === e.length) throw new Error("Cannot calculate bounds. No valid coordinate values given.");
          if (!t) return e[0].lat ? e : e.map(e => ({
            lat: e[0],
            lng: e[1]
          }));
          const s = null != i ? i : {},
            o = function (e, t, i, r) {
              const {
                minimumPins: n = 50,
                interpolationRatio: s = .75
              } = e;
              if (i <= n) {
                if (r) {
                  const e = new rn(...r);
                  if (e.containsBoundingBox(t)) {
                    const [i, r, n, o] = e.getOriginPoints(),
                      [a, l, u, h] = t.getOriginPoints();
                    return new rn(a + (i - a) * s, l + (r - l) * s, u + (n - u) * s, h + (o - h) * s);
                  }
                  return t;
                }
                return t;
              }
              return t;
            }(s, sn(s, e), e.length, r);
          return an(o, n);
        }
        computeCenteredBoundingBox(e, t, i) {
          if (!e || 0 === e.length) throw new Error("Cannot calculate bounds. No valid coordinate values given.");
          return an(function (e, t) {
            var i, r;
            const n = null !== (i = e.lat) && void 0 !== i ? i : e[0],
              s = null !== (r = e.lng) && void 0 !== r ? r : e[1],
              o = Qi(n, t.map(e => {
                var t;
                return null !== (t = e.lat) && void 0 !== t ? t : e[0];
              }), !1),
              a = Qi(s, t.map(e => {
                var t;
                return null !== (t = e.lng) && void 0 !== t ? t : e[1];
              }), !0),
              l = s - a,
              u = Lt(n + (n - o), void 0, !1),
              h = Lt(s + l, void 0, !0);
            switch (Wi([n, s], [o, a])) {
              case "sw":
                return new rn(a, o, h, u);
              case "ne":
                return new rn(h, u, a, o);
              case "se":
                return new rn(h, o, a, u);
              default:
                return new rn(a, u, h, o);
            }
          }(t.centeredOn, e), i);
        }
      }
      const {
          roundLatLng: un,
          listHashKeysSorted: hn,
          arrayEquals: dn,
          undefNullEmpty: cn
        } = t,
        pn = "qualifiers",
        fn = {
          default: void 0,
          onSelect: void 0
        },
        gn = "product",
        mn = "property",
        yn = "place",
        vn = "cluster",
        bn = [gn, mn],
        kn = [gn, mn, yn],
        Mn = "unknown",
        Cn = ["available", "filtered", "sold_out", Mn],
        wn = Cn,
        xn = [...kn, vn];
      class Pn {
        constructor(e, t, i) {
          this.id = e, this.type = t, this.configHelper = i, this.data = [void 0, void 0], this.visible = !1, this.intersectingKeys = [], this._clean();
        }
        _clean() {
          this.marker = void 0, this.popupContent = void 0, this.visible = !1, this.inBounds = !0, this._highlighted = !1, this.clearHashkeys(), this.intersectingKeys = [];
        }
        updateConfigHelper(e) {
          this.configHelper = e;
        }
        clearHashkeys() {
          this._hashKeys = void 0;
        }
        _importData(e, t) {
          e && (void 0 === this.data[t] && (this.data[t] = {}), this._hashKeys = void 0);
        }
        _removeData(e) {
          delete this.data[e], this._clean();
        }
        get hashKeys() {
          return void 0 === this._hashKeys && (this._hashKeys = hn(void 0, this._highlighted, [])), this._hashKeys;
        }
        importUserData(e) {
          this._importData(e, 0);
        }
        importTileData(e) {
          this._importData(e, 1);
        }
        removeTileData() {
          this._removeData(1);
        }
        removeUserData() {
          this._removeData(0);
        }
        mergeUserData(e) {
          this._mergeData(e, 0);
        }
        mergeTileData(e) {
          this._mergeData(e, 1);
        }
        _mergeData(e, t) {
          e && Object.assign(this.data[t], e), this._hashKeys = void 0;
        }
        _toData(e) {
          if (this.data[e]) return {
            id: this.id,
            type: this.type
          };
        }
        toUserData() {
          return this._toData(0);
        }
        toTileData() {
          return this._toData(1);
        }
        toData() {
          return Object.assign(Object.assign({}, this.toTileData()), this.toUserData());
        }
        hasUserData() {
          return this._hasData(0);
        }
        hasTileData() {
          return this._hasData(1);
        }
        _hasData(e) {
          const t = this.data[e];
          return void 0 !== t && Object.keys(t).length > 0;
        }
        get defined() {
          return !!this.data.find(e => e);
        }
        get userData() {
          return this.data[0];
        }
        set userData(e) {
          this.data[0] = e;
        }
        get tileData() {
          return this.data[1];
        }
        set tileData(e) {
          this.data[1] = e;
        }
        get latLng() {
          return this._getLatLngFromData(this._getFirstDefined.bind(this));
        }
        get userLatLng() {
          return this._getLatLngFromData(this._getUserProp.bind(this));
        }
        _getLatLngFromData(e) {
          const t = e("latLng");
          if (2 === (null == t ? void 0 : t.length)) return t;
        }
        get highlighted() {
          return !0 === this._highlighted;
        }
        set highlighted(e) {
          this._highlighted = e, this._hashKeys = void 0;
        }
        _getFirstDefined(e) {
          return (this.data.find(t => (t || {})[e]) || {})[e];
        }
        _getUserProp(e) {
          return (this.data[0] || {})[e];
        }
        set intersectingFeatureIds(e) {
          void 0 !== e && (this.intersectingKeys = e);
        }
        get intersectingFeatureIds() {
          return this.intersectingKeys;
        }
      }
      class Fn extends Pn {
        constructor(e, t, i) {
          super(e, t, i);
        }
        get hashKeys() {
          return void 0 === this._hashKeys && this.refreshHashkeys(), this._hashKeys;
        }
        addQualifier() {
          let e = !1;
          const t = this._getFirstDefined(pn);
          for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
          return r.forEach(i => {
            t.includes(i) || (t.push(i), e = !0);
          }), e && (this._hashKeys = void 0), e;
        }
        refreshHashkeys() {
          const e = this.qualifiers && this.configHelper ? this.configHelper.filterQualifiersUsed(this.type, this.qualifiers) : this.qualifiers,
            t = hn(this.status, this._highlighted || !1, e);
          this._hashKeys = this.configHelper ? this.configHelper.filterHashkeysUsed(this.type, t) : t;
        }
        removeQualifier() {
          let e = !1;
          const t = this._getFirstDefined(pn);
          for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
          return r.forEach(i => {
            const r = t.indexOf(i);
            -1 !== r && (t.splice(r, 1), e = !0);
          }), e && (this._hashKeys = void 0), e;
        }
        _assign(e, t, i) {
          void 0 !== i ? e[t] = i : void 0 !== e[t] && delete e[t];
        }
        _importData(e, t) {
          e && (void 0 === this.data[t] && (this.data[t] = {}), this._assign(this.data[t], "status", e.status), this._assign(this.data[t], "name", e.name), this._assign(this.data[t], pn, e.qualifiers || []), this._assign(this.data[t], "textLabel", e.textLabel), this._assign(this.data[t], "price", e.price), this._assign(this.data[t], "polygon", e.polygon), this._assign(this.data[t], "text", e.text), this._assign(this.data[t], "latLng", void 0 !== e.lat && void 0 !== e.lng ? un([e.lat, e.lng]) : void 0), this._assign(this.data[t], "score", e.score), this._assign(this.data[t], "thumbnail", e.thumbnail), this._assign(this.data[t], "description", e.description), this._assign(this.data[t], "tile", e.tile), this._assign(this.data[t], "ariaLabels", e.ariaLabels), this._assign(this.data[t], "additionalContent", e.additionalContent), this._hashKeys = void 0);
        }
        _toData(e) {
          const t = this.data[e];
          if (t) {
            const e = {
              id: this.id,
              type: this.type,
              status: t.status || Mn,
              qualifiers: t.qualifiers || [],
              name: t.name,
              price: t.price,
              polygon: t.polygon,
              text: t.text,
              lat: t.latLng ? t.latLng[0] : void 0,
              lng: t.latLng ? t.latLng[1] : void 0,
              score: t.score,
              thumbnail: t.thumbnail,
              description: t.description,
              ariaLabels: t.ariaLabels,
              additionalContent: t.additionalContent
            };
            return void 0 === e.additionalContent && delete e.additionalContent, e;
          }
        }
        hasLatLngChanged(e, t, i) {
          if (void 0 === e && void 0 !== t && void 0 !== i) return !0;
          if (void 0 === e || void 0 !== t && void 0 !== i) {
            if (void 0 === e && void 0 === t && void 0 === i) return !1;
            {
              const [r, n] = un([t, i]);
              return Math.abs(e[0] - r) > 1e-5 || Math.abs(e[1] - n) > 1e-5;
            }
          }
          return !0;
        }
        isUserDataChanged(e) {
          return !!e && (!this._same(this.userStatus || Mn, e.status || Mn) || !this._same(this.userPrice, e.price) || !this._same(this.userPolygon, e.polygon) || !this._same(this.userText, e.text) || !this._same(this.userName, e.name) || !this._same(this.userDescription, e.description) || !dn(this.userQualifiers, e.qualifiers, !1) || this.hasLatLngChanged(this.userLatLng, e.lat, e.lng));
        }
        _same(e, t) {
          return e === t || cn(e) && cn(t);
        }
        get status() {
          return this._getStatusFromData(this._getFirstDefined.bind(this));
        }
        get userStatus() {
          return this._getStatusFromData(this._getUserProp.bind(this));
        }
        _getStatusFromData(e) {
          return e("status") || Mn;
        }
        get qualifiers() {
          return this._getQualifiersFromData(this._getFirstDefined.bind(this));
        }
        get userQualifiers() {
          return this._getQualifiersFromData(this._getUserProp.bind(this));
        }
        _getQualifiersFromData(e) {
          return e("qualifiers");
        }
        get name() {
          return this._getFirstDefined("name");
        }
        get userName() {
          return this._getNameFromData(this._getUserProp.bind(this));
        }
        _getNameFromData(e) {
          return e("name");
        }
        get description() {
          return this._getFirstDefined("description");
        }
        get userDescription() {
          return this._getDescriptionFromData(this._getUserProp.bind(this));
        }
        _getDescriptionFromData(e) {
          return e("description");
        }
        get price() {
          return this._getPriceFromData(this._getFirstDefined.bind(this));
        }
        get ariaLabels() {
          return this._getFirstDefined("ariaLabels") || fn;
        }
        get additionalContent() {
          return this._getFirstDefined("additionalContent");
        }
        get userPrice() {
          return this._getPriceFromData(this._getUserProp.bind(this));
        }
        _getPriceFromData(e) {
          return e("price");
        }
        get polygon() {
          return this._getPolygonFromData(this._getFirstDefined.bind(this));
        }
        get userPolygon() {
          return this._getPolygonFromData(this._getUserProp.bind(this));
        }
        _getPolygonFromData(e) {
          return e("polygon");
        }
        get text() {
          return this._getFirstDefined("text");
        }
        get userText() {
          return this._getTextFromData(this._getUserProp.bind(this));
        }
        _getTextFromData(e) {
          return e("text");
        }
        get score() {
          return this._getFirstDefined("score");
        }
      }
      class Ln extends Pn {
        constructor(e) {
          super(e, vn), this._computedLatLng = [];
        }
        _clean() {
          super._clean(), this.visible = !0;
        }
        _importData(e, t) {
          e && (this.data[t] = {
            children: e.children,
            radius: e.radius,
            minPrice: e.minPrice,
            text: e.text,
            originalLatLng: un([e.lat, e.lng]),
            featureType: e.featureType,
            qualifier: e.qualifier
          }, this._hashKeys = void 0);
        }
        _toData(e) {
          const t = this.data[e];
          if (t) return {
            id: this.id,
            type: this.type,
            radius: t.radius,
            children: t.children,
            minPrice: t.minPrice,
            lat: t.originalLatLng[0],
            lng: t.originalLatLng[1],
            text: t.text,
            featureType: t.featureType,
            qualifier: t.qualifier
          };
        }
        toData() {
          const e = super.toData();
          return e.children = e.children.map(e => e.toData()), e;
        }
        set computedLatLng(e) {
          e && e.length > 0 ? this._computedLatLng = un([e[0], e[1]]) : this._computedLatLng = [];
        }
        get latLng() {
          return this._getFirstDefined("originalLatLng");
        }
        get computedLatLng() {
          return this._computedLatLng;
        }
        get children() {
          return this._getFirstDefined("children");
        }
        get radius() {
          return this._getFirstDefined("radius");
        }
        get minPrice() {
          return this._getFirstDefined("minPrice");
        }
        get text() {
          return this._getFirstDefined("text");
        }
        get featureType() {
          return this._getFirstDefined("featureType");
        }
        get qualifier() {
          return this._getFirstDefined("qualifier");
        }
      }
      class _n {
        constructor(e, t, i) {
          this.type = e, this.logger = i, this.newInstance = t, this.index = new Map(), this._data = [];
        }
        get data() {
          return this._data.filter(e => e && e.defined);
        }
        contains(e) {
          return !!this.find(e);
        }
        find(e) {
          if ("string" == typeof e || "number" == typeof e) {
            var t;
            const r = null !== (t = this.index.get(e)) && void 0 !== t ? t : -1;
            var i;
            return r > -1 && this._data[r] && null !== (i = this._data[r]) && void 0 !== i && i.defined ? this._data[r] : void 0;
          }
          var r;
          null === (r = this.logger) || void 0 === r || r.warn("The feature id passed is not defined");
        }
        save(e) {
          if (e.type === this.type) {
            var t;
            const i = null !== (t = this.index.get(e.id)) && void 0 !== t ? t : -1;
            i > -1 ? this._data[i] = e : (this.index.set(e.id, this._data.length), this._data.push(e));
          }
        }
        delete(e) {
          if (e.type === this.type) {
            var t;
            const i = null !== (t = this.index.get(e.id)) && void 0 !== t ? t : -1;
            i > -1 && (this._data[i] = void 0);
          }
        }
        clearAll() {
          this._data = [], this.index = new Map();
        }
      }
      class On {
        constructor(e) {
          this.logger = e, this._repositories = {
            product: new _n(gn, (e, t) => new Fn(e.id, gn, t), e),
            property: new _n(mn, (e, t) => new Fn(e.id, mn, t), e),
            place: new _n(yn, (e, t) => new Fn(e.id, yn, t), e),
            cluster: new _n(vn, (e, t) => new Ln(e.id), e)
          };
        }
        allProducts() {
          return this.all(e => e === gn);
        }
        allProductsWithCoordinates() {
          return this.allProducts().filter(e => void 0 !== e.latLng);
        }
        allProperties() {
          return this.all(e => e === mn);
        }
        allPropertiesWithCoordinates() {
          return this.allProperties().filter(e => void 0 !== e.latLng);
        }
        allPlaces() {
          return this.all(e => e === yn);
        }
        allPlacesWithCoordinates() {
          return this.allPlaces().filter(e => void 0 !== e.latLng);
        }
        allWithCoordinates(e) {
          return this.all().filter(t => void 0 !== t.latLng && (!e || t.type === e));
        }
        allExceptClusters() {
          return this.all(e => e !== vn);
        }
        allClusters() {
          return this.all(e => e === vn);
        }
        find(e, t) {
          if (t) return this.repository(t).find(e);
          var i;
          null === (i = this.logger) || void 0 === i || i.warn("The feature type passed is not defined");
        }
        delete(e, t) {
          this.repository(t).delete({
            id: e,
            type: t
          });
        }
        repository(e) {
          return this._repositories[e];
        }
        all() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => !0,
            t = [];
          return Object.keys(this._repositories).filter(t => e(t)).forEach(e => {
            t = t.concat(this._repositories[e].data);
          }), t;
        }
        upsertUserData(e, t) {
          return this._upsert(e, "importUserData", t);
        }
        upsertTileData(e, t) {
          return this._upsert(e, "importTileData", t);
        }
        insertTileData(e, t) {
          let i = this.repository(e.type).find(e.id);
          if (!i) return this._upsert(e, "importTileData", t);
          {
            const r = i.tileData && i.tileData.tile,
              n = e.tile && e.tile[2],
              s = r && r[2];
            if (void 0 === n && void 0 === s || void 0 !== n && (void 0 === s || n < s)) return this._upsert(e, "importTileData", t);
          }
        }
        _upsert(e, t, i) {
          let r = this.repository(e.type).find(e.id);
          return r || (r = this.repository(e.type).newInstance(e, i)), r[t](e), this.repository(r.type).save(r), r;
        }
        deleteTileData(e) {
          return this._delete(e, "removeTileData");
        }
        _delete(e, t) {
          let i = this.repository(e.type).find(e.id);
          return i && (i[t](e), i.defined || this.repository(e.type).delete(e)), i;
        }
      }
      const {
          firstDefinedValue: En
        } = t,
        In = "marker-hidden",
        Dn = "marker-collision",
        Sn = ["none", "low", "medoium", "high"].map(e => `${Dn}-${e}`),
        Bn = "marker-cutoff";
      class An {
        constructor() {}
        init(e) {
          let {
            mapContainer: t,
            asKey: i,
            getMarkerElement: r,
            getRectOfMarker: n,
            moveMarkerPosition: s,
            makeMarkerVisible: o,
            settings: a
          } = e;
          this.mapContainer = t, this.asKey = i, this.getMarkerElement = r, this.getRectOfMarker = n, this.moveMarkerPosition = s, this.makeMarkerVisible = o, this.settings = a;
          const l = a.collision;
          this.textLabelVisibility = l.labelVisibility, this.textLabelDynamicPlacement = l.dynamicPlacement, this.collisionBufferVariation = l.collisionBufferVariation, this.collisionBuffers = l.collisionBuffers, this.tagCollidingMarkersConfig = l.tagCollidingMarkers, this.tagCutOffMarkersConfig = l.tagCutOffMarkers, this.clusterMarkerCollisionBuffer = l.clusterMarkerCollisionBufferInPixels, this.shouldMoveCollidingClusterMarkers = l.shouldMoveCollidingClusterMarkers;
        }
        _isMarkerCollidingOtherMarkerOrLabel(e, t) {
          return this.listMarkerOrLabelsCollisions(e, t, !0).length > 0;
        }
        listMarkerOrLabelsCollisions(e, t) {
          let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          const {
              markerBBox: r
            } = e,
            n = [];
          for (const e of t) {
            const {
              textLabelBBox: t,
              markerBBox: s,
              labelVisibility: o
            } = e;
            if (r && (s && fi(r, s) || o && t && fi(r, t)) && (n.push(e), i)) return n;
          }
          return n;
        }
        _isVisibleExistingLabelCollidingWithAnotherMarkerLabel(e, t) {
          const {
              textLabelBBox: i
            } = e,
            {
              textLabelBBox: r,
              labelVisibility: n
            } = t;
          return n && r && fi(i, r);
        }
        _isVisibleExistingLabelCollidingWithAnotherMarker(e, t) {
          const {
              textLabelBBox: i
            } = e,
            {
              markerBBox: r
            } = t;
          return r && fi(i, r);
        }
        _isLabelCollidingOtherMarkerOrLabel(e, t) {
          const {
            textLabelBBox: i,
            labelVisibility: r
          } = e;
          return !(!i || !r) && t.some(t => this._isVisibleExistingLabelCollidingWithAnotherMarker(e, t) || this._isVisibleExistingLabelCollidingWithAnotherMarkerLabel(e, t));
        }
        _sortCandidateBBoxes(e) {
          return e.sort((e, t) => e.popularity === t.popularity ? e.feature.id < t.feature.id ? -1 : 1 : e.popularity > t.popularity ? -1 : 1);
        }
        _splitFeaturesBoundingBoxes(e) {
          let t = [],
            i = [];
          return e.forEach(e => {
            "always" === e.labelVisibility || !1 === e.isDynamicLabel ? t.push(e) : i.push(e);
          }), {
            safeFeaturesBBoxes: t,
            candidateBBoxes: i
          };
        }
        _nextEligibleLabelPosition(e) {
          var t;
          return null === (t = e.find(e => {
            let {
              isAvailable: t
            } = e;
            return t;
          })) || void 0 === t ? void 0 : t.position;
        }
        _updateMarkerLabelPosition(e, t) {
          const {
            safeFeaturesBBoxes: i,
            candidateBBoxes: r
          } = this._splitFeaturesBoundingBoxes(e);
          for (this._sortCandidateBBoxes(r); r.length > 0;) {
            let [e] = r;
            const {
                feature: n,
                labelVisibility: s,
                availableLabelPositions: o,
                currentLabelPosition: a
              } = e,
              {
                marker: l
              } = n;
            if (this._isMarkerCollidingOtherMarkerOrLabel(e, i)) tt(this.getMarkerElement(n), In), r.shift();else {
              if (s && this._isLabelCollidingOtherMarkerOrLabel(e, i)) {
                o.find(e => {
                  let {
                    position: t
                  } = e;
                  return t === a;
                }).isAvailable = !1;
                const s = this._nextEligibleLabelPosition(o);
                s && n.name ? (l.labels.updateTextLabelPosition(s, t), e.textLabelBBox = rs(n, this.getMarkerElement(n), this.settings, s, this.getRectOfMarker, this.mapContainer), e.currentLabelPosition = s) : (l.labels.hideTextLabel(!0), e.labelVisibility = !1, i.push(e), r.shift());
              } else l.labels.hideTextLabel(!1), i.push(e), r.shift();
            }
          }
        }
        getPopularity(e) {
          var t;
          const i = null !== (t = null == e ? void 0 : e.score) && void 0 !== t ? t : 0;
          return "number" != typeof i ? 0 : i;
        }
        _calculateFeaturesBoundingBoxes(e, t, i) {
          const r = e.map(e => {
            var r;
            const n = this.asKey(e),
              s = (null == t ? void 0 : t[n]) || !1,
              o = null === (r = e.marker) || void 0 === r || null === (r = r.labels) || void 0 === r ? void 0 : r.configuredLabelPosition;
            return {
              labelVisibility: s,
              availableLabelPositions: Wn.map(e => ({
                position: e,
                isAvailable: !0
              })),
              currentLabelPosition: o,
              isDynamicLabel: (null == i ? void 0 : i[n]) || !1,
              markerBBox: this.getRectOfMarker(e),
              textLabelBBox: s && e.name ? rs(e, this.getMarkerElement(e), this.settings, o, this.getRectOfMarker, this.mapContainer) : void 0,
              popularity: this.getPopularity(e),
              feature: e
            };
          });
          return r;
        }
        _resetMarkersAndLabels(e, t) {
          return e.forEach(e => {
            rt(this.getMarkerElement(e), In), Jn(e.marker, t, this.settings, e);
          }), es(e, t, this.settings, this.asKey);
        }
        handleMarkerLabelCollision(e, t) {
          const i = e.filter(e => this.getMarkerElement(e)),
            r = this.getConfigByKey(i, this.textLabelDynamicPlacement);
          if (!Object.values(r).includes(!0)) return;
          const n = this._resetMarkersAndLabels(i, t),
            s = this._calculateFeaturesBoundingBoxes(i, n, r);
          this._updateMarkerLabelPosition(s, t);
        }
        identifyMarkerCollisionOrCutOff(e) {
          const t = e.filter(e => this.getMarkerElement(e)),
            i = this._calculateFeaturesBoundingBoxes(t),
            r = new Map();
          for (; i.length > 0;) {
            const e = i.shift(),
              t = {
                id: e.feature.id,
                type: e.feature.type
              },
              n = this.listMarkerOrLabelsCollisions(e, i);
            n.forEach(e => {
              let {
                feature: i,
                markerBBox: n
              } = e;
              const s = {
                  id: i.id,
                  type: i.type
                },
                o = this.asKey(i);
              r.has(o) ? r.get(o).collidingFeatures.push(t) : r.set(o, {
                idAndType: s,
                collidingFeatures: [t],
                markerCutOff: n.cutOff || !1,
                outOfViewport: n.outOfViewport || !1
              });
            });
            const s = n.map(e => ({
                id: e.feature.id,
                type: e.feature.type
              })),
              o = this.asKey(t);
            r.has(o) ? r.get(o).collidingFeatures.push(...s) : r.set(o, {
              idAndType: t,
              collidingFeatures: s,
              markerCutOff: e.markerBBox.cutOff || !1,
              outOfViewport: e.markerBBox.outOfViewport || !1
            });
          }
          return r;
        }
        _compareCluster(e, t) {
          const i = e.children,
            r = t.children;
          return i.length > r.length ? -1 : i.length < r.length ? 1 : i[0].id < r[0].id ? -1 : 1;
        }
        _sortClusterWithMarkerRects(e) {
          e.sort((e, t) => {
            const i = Ge(e.marker, "cluster-marker-moved"),
              r = Ge(t.marker, "cluster-marker-moved");
            if (Ge(e.marker, "cluster-marker-moved")) return i ? r ? this._compareCluster(e.cluster, t.cluster) : -1 : r ? 1 : this._compareCluster(e.cluster, t.cluster);
          });
        }
        _filterClusterWithMarkerRects(e) {
          return e.flatMap(e => {
            const {
              feature: t,
              key: i,
              markerRect: r,
              markerRectWithBuffer: n,
              markerCollisionBuffer: s
            } = e;
            if ("cluster" !== e.feature.type) return [];
            {
              const o = this.getMarkerElement(e.feature);
              if (o) return {
                cluster: t,
                key: i,
                markerRect: r,
                markerRectWithBuffer: n,
                marker: o,
                markerCollisionBuffer: s
              };
            }
          });
        }
        moveCollidingClusterMarkers(e) {
          const t = this._filterClusterWithMarkerRects(e);
          this._sortClusterWithMarkerRects(t), t.forEach(t => {
            const {
                cluster: i,
                key: r,
                markerCollisionBuffer: n,
                marker: s,
                markerRect: o
              } = t,
              {
                radius: a
              } = i;
            if (rt(s, "cluster-marker-moved"), rt(s, "cluster-marker-failed-to-move"), i.intersectingKeys.length > 0) {
              const l = e.filter(e => i.intersectingKeys.includes(e.key)),
                u = gi(this.getMaxRectOfMarkers(l), o, this.clusterMarkerCollisionBuffer),
                h = ai(o, u),
                d = ni(h.center, h.width + 2 * n, h.height + 2 * n, dt(this.mapContainer)),
                c = e.filter(e => e.key !== r && this.getMarkerElement(e.feature));
              this.withinClusterRadius(o.center, h, a) && this.noNewClusterCollision(d, c) ? (this.moveMarkerPosition(i, u), tt(s, "cluster-marker-moved"), this.updateIntersectingFeatureKeysAfterMovingClusterMarkerPosition(i, h, c), t.markerRect = h, t.markerRectWithBuffer = d) : tt(s, "cluster-marker-failed-to-move");
            }
          }, this);
        }
        updateIntersectingFeatureKeysAfterMovingClusterMarkerPosition(e, t, i) {
          const r = this.asKey(e);
          e.intersectingKeys = [], i.forEach(e => {
            const i = e.feature.intersectingKeys.indexOf(r);
            fi(e.markerRectWithBuffer, t) ? i < 0 && e.feature.intersectingKeys.push(r) : i > -1 && e.feature.intersectingKeys.splice(i, 1);
          });
        }
        withinClusterRadius(e, t, i) {
          return mi(t, this.getClusterCircle(e, i));
        }
        noNewClusterCollision(e, t) {
          return !t.some(t => fi(e, t.markerRect));
        }
        getClusterCircle(e, t) {
          return {
            radius: t,
            center: {
              x: e.x,
              y: e.y
            }
          };
        }
        getMaxRectOfMarkers(e) {
          return oi(e.map(e => e.markerRect));
        }
        hideCollidingMarkers(e, t) {
          const i = e.filter(e => this.getMarkerElement(e) && "cluster" !== e.type);
          let r = [],
            n = [];
          i.forEach(e => {
            "none" === t[this.asKey(e)] ? r.push(e) : n.push(e);
          });
          let s = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [{
              score: "DESC"
            }, {
              id: "ASC"
            }];
            return e.sort((e, i) => {
              for (const r of t) for (const t of Object.keys(r)) {
                let n = e[t],
                  s = i[t],
                  o = 0;
                if (void 0 === n && void 0 !== s ? o = -1 : void 0 !== n && void 0 === s ? o = 1 : void 0 !== n && void 0 !== s && (n < s && (o = -1), n > s && (o = 1)), "DESC" === r[t] && (o *= -1), 0 !== o) return o;
              }
              return 0;
            });
          }(n, [{
            type: "ASC"
          }, {
            score: "DESC"
          }, {
            id: "ASC"
          }]);
          for (; s.length > 0;) {
            let e = s.shift(),
              t = !1;
            for (const n of r) if (e && n && e.type === n.type && e.intersectingKeys.includes(this.asKey(n))) {
              this.makeMarkerVisible(e, !1), this.updateIntersectingFeatureKeysAfterHidingMarker(i, this.asKey(e)), t = !0;
              break;
            }
            t || r.push(e);
          }
        }
        updateIntersectingFeatureKeysAfterHidingMarker(e, t) {
          e.forEach(e => {
            const i = e.intersectingKeys.indexOf(t);
            i > -1 && e.intersectingKeys.splice(i, 1);
          });
        }
        tagCollidingMarkers(e, t, i) {
          const r = e.flatMap(e => {
            const t = this.getMarkerElement(e);
            return t ? [{
              f: e,
              marker: t,
              key: this.asKey(e)
            }] : [];
          });
          r.forEach(e => {
            let {
              marker: t
            } = e;
            return nt(t, [Dn, ...Sn]);
          });
          r.filter(e => {
            let {
              f: i,
              key: r
            } = e;
            return i.intersectingKeys.length > 0 && t[r];
          }).forEach(e => {
            let {
              f: t,
              marker: n,
              key: s
            } = e;
            for (const {
              key: e
            } of r) if (s !== e && t.intersectingKeys.includes(e)) {
              it(n, [Dn, `${Dn}-${i[s]}`]);
              break;
            }
          });
        }
        tagCutOffMarkers(e, t) {
          const i = e.flatMap(e => {
            let {
              feature: t,
              key: i,
              markerRect: r
            } = e;
            const n = this.getMarkerElement(t);
            return n ? [{
              f: t,
              marker: n,
              key: i,
              markerRect: r
            }] : [];
          });
          i.forEach(e => {
            let {
              key: i,
              marker: r,
              markerRect: n
            } = e;
            t[i] ? !0 === n.cutOff ? tt(r, Bn) : !1 === n.cutOff && rt(r, Bn) : rt(r, Bn);
          });
        }
        updateMarkerPosition(e) {
          const t = e.filter(e => this.getMarkerElement(e)),
            i = this.getConfigByKey(t, this.collisionBufferVariation),
            r = this.getFeaturesWithMarkerRects(t, i);
          this.updateIntersectingFeatureKeys(r), this.shouldMoveCollidingClusterMarkers && this.moveCollidingClusterMarkers(r);
          Object.values(i).some(e => "none" !== e) && this.hideCollidingMarkers(t, i);
          const n = this.getConfigByKey(t, this.tagCollidingMarkersConfig);
          Object.values(n).includes(!0) && this.tagCollidingMarkers(t, n, i);
          const s = this.getConfigByKey(t, this.tagCutOffMarkersConfig);
          Object.values(s).includes(!0) && this.tagCutOffMarkers(r, s);
        }
        getConfigByKey(e, t) {
          const i = {};
          return e.forEach(e => {
            const r = this.asKey(e);
            i[r] = En(t[e.type], e.hashKeys);
          }), i;
        }
        updateIntersectingFeatureKeys(e) {
          e.forEach(t => {
            var i;
            if ((null === (i = t.feature.intersectingKeys) || void 0 === i ? void 0 : i.length) > 0 && (t.feature.intersectingKeys = []), "cluster" === t.feature.type) {
              t.feature.computedLatLng = [];
            }
            e.forEach(e => {
              t.key !== e.key && fi(t.markerRectWithBuffer, e.markerRect) && t.feature.intersectingKeys.push(e.key);
            });
          });
        }
        getFeaturesWithMarkerRects(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return e.filter(e => this.getMarkerElement(e)).map(e => {
            const i = t[this.asKey(e)],
              r = this.collisionBuffers[i] || 0,
              n = this.getRectOfMarker(e, r),
              s = this.getRectOfMarker(e);
            return {
              feature: e,
              key: this.asKey(e),
              markerRectWithBuffer: n,
              markerRect: s,
              markerCollisionBuffer: r
            };
          });
        }
      }
      function Tn(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function Rn(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Tn(Object(i), !0).forEach(function (t) {
            Vn(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Tn(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function Vn(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      const {
        FROM_BASE_MAP: Kn,
        FROM_BASE_MAP_NO_MARKER: Nn,
        GOOGLE: jn,
        MAPBOX: $n
      } = ar;
      class zn {
        constructor(e) {
          let {
            logger: t,
            mapProvider: i,
            locale: r,
            baseMapMarkersClickConfig: n,
            actionsOnMarkerClick: s,
            handleClick: o,
            eventsManager: a,
            saveFeature: l,
            selectFeature: u,
            findFeature: h,
            listFeatures: d,
            removeFeatures: c,
            contentProvidersManager: p
          } = e;
          this.logger = t, this.mapProvider = i, this.locale = r, this.baseMapMarkerClickUnregisterListenerCallback = void 0, this.contentProviderType = void 0, this.baseMapMarkersClickConfig = n, this.actionsOnMarkerClick = s, this.eventsManager = a, this.handleClick = o, this.saveFeature = l, this.selectFeature = u, this.findFeature = h, this.listFeatures = d, this.removeFeatures = c, this.contentProvidersManager = p;
        }
        isEnabled() {
          var e;
          return !0 === (null === (e = this.baseMapMarkersClickConfig) || void 0 === e ? void 0 : e.enabled);
        }
        handleBaseMapMarkerClick(e, t, i) {
          const r = `${"google-maps" === this.mapProvider ? "googlemaps-" : "mapbox-"}${t}`,
            n = "place",
            s = this.findFeature(r, n);
          return (s ? this._refreshData(s.toData()) : this._newFeature(r, n, i)).then(t => {
            if (t) {
              const i = !0,
                r = !1,
                n = !0;
              this.handleClick(t, i, this.actionsOnMarkerClick, e, r, n);
            }
          });
        }
        _newFeature(e, t, i) {
          const r = "google-maps" === this.mapProvider ? jn : $n,
            n = [Kn, r];
          this.baseMapMarkersClickConfig.createMarkerOnSelection || n.push(Nn);
          const {
              lat: s,
              lng: o
            } = i,
            a = {
              id: e,
              type: t,
              status: "unknown",
              lat: s,
              lng: o,
              qualifiers: n
            };
          return this._refreshData(a);
        }
        _refreshData(e) {
          const t = this.contentProvidersManager.loadFeatureContent(e, !0).then(t => {
            let {
              f: i
            } = t;
            const r = Rn(Rn(Rn({}, i), e), {}, {
              qualifiers: [...(e.qualifiers || []), ...(i.qualifiers || [])]
            });
            return this.saveFeature(r, !0);
          });
          return this.baseMapMarkersClickConfig.waitForContent ? t : Promise.resolve(this.saveFeature(e));
        }
        registerBaseMapMarkerClickUnregisterListenerCallback(e) {
          this.baseMapMarkerClickUnregisterListenerCallback = e;
        }
        clean() {
          var e;
          null === (e = this.baseMapMarkerClickUnregisterListenerCallback) || void 0 === e || e.call(this), this.baseMapMarkerClickUnregisterListenerCallback = void 0, this.removeFeatures(e => e.qualifiers.includes(Kn)), this.contentProviderType = void 0, this.contentProvider = void 0;
        }
        isListenerRegistered() {
          return void 0 !== this.baseMapMarkerClickUnregisterListenerCallback;
        }
        updateConfiguration(e, t, i, r, n) {
          this.logger = e, this.locale = t, this.actionsOnMarkerClick = n, this.contentProvidersManager = r, this.baseMapMarkersClickConfig = i, null != i && i.enabled ? this._clearFromBaseMapMarkers(i) : this.clean();
        }
        _clearFromBaseMapMarkers(e) {
          const {
            createMarkerOnSelection: t
          } = e;
          (t && this.listFeatures(e => e.qualifiers.includes(Nn)).length > 0 || !t && this.listFeatures(e => e.qualifiers.includes(Kn)).length > 0) && this.removeFeatures(e => e.qualifiers.includes(Kn));
        }
      }
      class Un {
        init(e, t) {
          return Promise.reject(new Error("method init not implemented"));
        }
        createPinMarker(e, t, i) {
          throw new Error("method createPinMarker not implemented");
        }
        createTextMarker(e, t, i) {
          throw new Error("method createTextMarker not implemented");
        }
        createClusterMarker(e) {
          throw new Error("method createClusterMarker not implemented");
        }
        createObfuscatedMarker(e) {
          throw new Error("method createObfuscatedMarker not implemented");
        }
        createPriceObfuscatedMarker(e, t) {
          throw new Error("method createPriceObfuscatedMarker not implemented");
        }
        createPinObfuscatedMarker(e, t, i) {
          throw new Error("method createPinObfuscatedMarker not implemented");
        }
        hasObfuscatedAreaStyleChanged(e) {
          throw new Error("method _hasObfuscatedAreaStyleChanged not implemented");
        }
        deleteMarker(e) {
          throw new Error("method deleteMarker not implemented");
        }
        updatePopupPositionOnLayer() {
          throw new Error("method updatePopupPositionOnLayer not implemented");
        }
        ensurePopupVisibility() {
          throw new Error("method ensurePopupVisibility not implemented");
        }
        getMarkerElement(e) {
          throw new Error("method getMarkerElement not implemented");
        }
        moveMarkerPosition(e, t) {
          throw new Error("method moveMarkerPosition not implemented");
        }
        getRectOfMarker(e) {
          throw new Error("method getRectOfMarker not implemented");
        }
        fitBounds(e, t, i, r) {
          return Promise.reject("method fitBounds not implemented");
        }
        nativeBounds() {
          throw new Error("method nativeBounds not implemented");
        }
        asNativeBounds(e, t) {
          throw new Error("method asNativeBounds not implemented");
        }
        computeNativeBoundsFromLatLongs(e) {
          throw new Error("method computeNativeBoundsFromLatLongs not implemented");
        }
        asBounds(e) {
          throw new Error("method asBounds not implemented");
        }
        containerBounds(e) {
          throw new Error("method containerBounds not implemented");
        }
        fitLatLongs(e) {
          return Promise.reject("method fitLatLongs not implemented");
        }
        getZoom() {
          throw new Error("method getZoom not implemented");
        }
        getCenter() {
          throw new Error("method getCenter not implemented");
        }
        isFeatureInRealBound(e, t) {
          throw new Error("method isFeatureInRealBound not implemented");
        }
        centerAndZoomMap(e, t, i) {
          throw new Error("method centerAndZoomMap not implemented");
        }
        addEventListener(e, t, i) {
          throw new Error("method addEventListener not implemented");
        }
        addRouteOnMap(e, t) {
          return Promise.reject(new Error("method addRouteOnMap not implemented"));
        }
        removeRouteOnMap(e) {
          return Promise.reject(new Error("method removeRouteOnMap not implemented"));
        }
        addPolygonsOnMap(e) {
          return Promise.reject(new Error("method addPolygonsOnMap not implemented"));
        }
        removePolygonsOnMap(e) {
          return Promise.reject(new Error("method removePolygonsOnMap not implemented"));
        }
        registerListenerOnMapFocusElement(e, t) {
          throw new Error("method registerListenerOnMapFocusElement not implemented");
        }
        unbindAll() {
          throw new Error("method unbindAll not implemented");
        }
        getTileDim() {
          throw new Error("method getTileDim not implemented");
        }
        resetRouteStyle() {
          throw new Error("method resetRouteStyle not implemented");
        }
        updateMapProviderConfig() {
          throw new Error("method updateMapProviderConfig not implemented");
        }
        forceMapModeView() {
          throw new Error("method forceMapModeView not implemented");
        }
      }
      const {
          firstDefinedValue: Hn,
          getMultiLineLabelText: Zn
        } = t,
        qn = "text-label-hidden",
        Qn = "text-sub-label-hidden",
        Wn = ["right", "left", "above", "below"];
      function Gn(e, t, i, r) {
        e.labels.aligner && pe(e.labels.aligner), e.labels.textLabelPosition = i, e.labels.aligner = me(void 0, e.labels.textLblCont, `marker-labels-aligner ${i}`), e.labels.container ? fe(e.labels.container, e.labels.aligner) : e.labels.container = me(void 0, e.labels.aligner, "marker-labels-container");
        const n = Hn(r.textLabelZIndex[t.type], t.hashKeys);
        "sameAsMarker" != n && He(e.labels.aligner, n);
      }
      function Xn(e, t, i, r) {
        const n = Hn(t[r.type], r.hashKeys),
          s = Hn(i[r.type], r.hashKeys);
        return e < n || e > s;
      }
      function Yn(e, t, i, r, n) {
        const s = Hn(n.textLabelPosition[t.type], t.hashKeys);
        e.labels.configuredLabelPosition = s, i && (Gn(e, t, s, n), is(e, t, i, r, n)), e.labels.updateTextLabel = (i, r, o) => {
          i && !e.labels.aligner && Gn(e, t, s, n), is(e, t, i, r, n), Jn(e, o, n, t);
        }, e.labels.updateTextLabelPosition = function () {
          let i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s,
            r = arguments.length > 1 ? arguments[1] : void 0;
          i !== e.labels.textLabelPosition && (!function (e, t) {
            rt(e.labels.aligner, e.labels.textLabelPosition), tt(e.labels.aligner, t), e.labels.textLabelPosition = t;
          }(e, i), Jn(e, r, n, t));
        }, e.labels.hideTextLabel = t => {
          const {
            aligner: i
          } = e.labels;
          i && (t ? tt(i, qn) : rt(i, qn));
        }, e.labels.hideTextSubLabel = t => {
          const {
            subLabel: i
          } = e.labels;
          i && (t ? tt(i, Qn) : rt(i, Qn));
        }, e.labels.resetPositionAndHidingState = t => {
          e.labels.hideTextLabel(!1), e.labels.hideTextSubLabel(!1), e.labels.updateTextLabelPosition(s, t);
        };
      }
      function Jn(e, t, i, r) {
        Xn(t, i.textLabelMinZoom, i.textLabelMaxZoom, r) && e.labels.hideTextLabel(!0);
        Xn(t, i.textSubLabelMinZoom, i.textSubLabelMaxZoom, r) && e.labels.hideTextSubLabel(!0);
      }
      function es(e, t, i, r) {
        const n = {};
        return e.forEach(e => {
          const s = Hn(i.textLabelVisibility[e.type], e.hashKeys),
            o = Xn(t, i.textLabelMinZoom, i.textLabelMaxZoom, e),
            a = r(e);
          n[a] = "always" === s ? "always" : s && !o;
        }), n;
      }
      function ts(e, t, i, r, n, s, o) {
        const a = Hn(i[e.type], e.hashKeys),
          l = Hn(r[e.type], e.hashKeys);
        let u = Zn(n, a, l);
        return o ? (X(o, u), o) : Me(void 0, t, `marker-${s}-text`, void 0, u);
      }
      function is(e, t, i, r, n) {
        const {
          container: s,
          label: o,
          subLabel: a
        } = e.labels;
        if (i) {
          const {
            textLabelMaxLineLength: l,
            textLabelMaxLines: u
          } = n;
          if (e.labels.label = ts(t, s, l, u, i, "label", o), r) {
            const {
              textSubLabelMaxLineLength: i,
              textSubLabelMaxLines: o
            } = n;
            e.labels.subLabel = ts(t, s, i, o, r, "sublabel", a);
          } else pe(a), e.labels.subLabel = void 0;
        } else e.labels && (pe(e.labels.aligner), e.labels.aligner = void 0, e.labels.container = void 0, e.labels.label = void 0, e.labels.subLabel = void 0, e.labels.textLabelPosition = void 0);
      }
      function rs(e, t, i, r, n, s) {
        const o = se(t, ["marker-labels-container"], !0);
        let {
          width: a,
          height: l,
          center: u
        } = n(e);
        const h = r || Hn(i.textLabelPosition[e.type], e.hashKeys),
          {
            scrollWidth: d,
            scrollHeight: c
          } = o;
        switch (u.x -= a / 2, u.y -= l / 2, h) {
          case "right":
            u.y += l / 2, u.x += a + d / 2;
            break;
          case "left":
            u.y += l / 2, u.x -= d / 2;
            break;
          case "above":
            u.y -= c / 2, u.x += a / 2;
            break;
          default:
            u.y += l + c / 2, u.x += a / 2;
        }
        return ni(u, d, c, dt(s));
      }
      function ns(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function ss(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ns(Object(i), !0).forEach(function (t) {
            os(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ns(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function os(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      const {
          firstDefinedValue: as
        } = t,
        ls = "marker-icon",
        us = {
          defaultClick: "click",
          doubleClick: "dblclick",
          mapClick: "click",
          mouseEnter: "mouseenter",
          mouseLeave: "mouseleave",
          focus: "focus",
          focusOut: "focusout",
          keyDown: "keydown",
          keyUp: "keyup",
          keyPress: "keydown"
        };
      function hs(e, t) {
        let i,
          r,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "none",
          s = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          o = arguments.length > 4 ? arguments[4] : void 0;
        if (Z(e)) {
          i = e.cloneNode(!0), s && (r = Q(i));
          const t = ["component-icon"];
          o && t.push(o), it(i, t);
        } else i = Pe(void 0, void 0, o, void 0, e);
        if ("none" !== n) {
          const e = me(void 0, t, "frame");
          return e.appendChild(i), r && (e.hashCode = r), Ee(e), {
            iconImg: i,
            main: e
          };
        }
        return fe(i, t), r && (i.hashCode = r), {
          iconImg: i,
          main: t
        };
      }
      function ds(e, t, i, r) {
        const n = me(void 0, e, `${t}-label`),
          s = Me(void 0, n, r || `${t}-content`, void 0, i);
        return Ee(s), {
          text: n,
          span: s
        };
      }
      function cs(e, t) {
        const {
            hashKeys: i
          } = e,
          {
            textLabelVisibility: r,
            textSubLabelVisibility: n
          } = t,
          s = {};
        if (as(r[e.type], i)) {
          const t = e.name;
          t && (s.label = t);
        }
        if (as(n[e.type], i)) {
          const t = e.description;
          t && (s.subLabel = t);
        }
        return s;
      }
      function ps(e, t) {
        var i;
        const {
            markerTypes: r,
            frameIcons: n,
            icons: s,
            zIndexes: o,
            tabIndexes: a,
            markersClickable: l,
            cornerIcons: u,
            innerIcons: h,
            iso4217CurrencyCode: d,
            locale: c
          } = t,
          {
            hashKeys: p,
            type: f
          } = e,
          g = e,
          {
            price: m,
            text: y
          } = g,
          v = "cluster" === f,
          b = v ? "clusterMarker" : as(r[f], p),
          k = v ? [] : [e.type, g.status],
          M = as(l[f], p),
          C = ss({
            markerType: b,
            zIndex: 0,
            tabIndex: 0,
            clickable: M,
            cssClasses: {
              toAdd: [...k, g.highlighted ? "hl" : "not-hl", ...(M ? [] : ["not-clickable"])],
              toRemove: [g.highlighted ? "not-hl" : "hl"]
            },
            frameIcon: as(n[f], p),
            icons: {}
          }, cs(g, t));
        switch (b) {
          case "price":
          case "priceObfuscate":
            m ? C.text = ii(m, void 0, d, c) : C.markerType = "price" === b ? "pin" : "pinObfuscate";
            break;
          case "text":
            y ? C.text = y : C.markerType = "pin";
        }
        switch (null != e && null !== (i = e.marker) && void 0 !== i && i.cssClasses && C.cssClasses.toRemove.push(...e.marker.cssClasses.filter(e => "dom-marker" !== e)), C.markerType) {
          case "pin":
            C.cssClasses.toAdd.push("pin-marker"), C.icons.pin = as(s[e.type], p);
            break;
          case "price":
            C.cssClasses.toAdd.push("price-marker");
            break;
          case "text":
            C.cssClasses.toAdd.push("text-marker");
            break;
          case "obfuscate":
            C.cssClasses.toAdd.push("obfuscate-marker");
            break;
          case "pinObfuscate":
            C.cssClasses.toAdd.push("pin-obfuscate-marker"), C.icons.pin = as(s[e.type], p);
            break;
          case "priceObfuscate":
            C.cssClasses.toAdd.push("price-obfuscate-marker");
            break;
          case "clusterMarker":
            {
              const {
                featureType: t,
                qualifier: i
              } = e;
              C.cssClasses.toAdd.push(...Is(t, i)), C.clickable = !0;
            }
            break;
          default:
            throw new Error(`Unknown marker type: ${C.markerType}`);
        }
        "none" !== C.frameIcon && C.cssClasses.toAdd.push(`frame-${C.frameIcon}`);
        const w = g.qualifiers || [];
        w.length > 0 && C.cssClasses.toAdd.push(...w), C.zIndex = as(o[g.type], p), C.tabIndex = as(a[g.type], p);
        const x = xs(g, u);
        u && (C.icons.cornerIcons = x);
        const P = Ps(g, h);
        return h && (C.icons.innerIcons = P), C;
      }
      function fs(e, t, i, r) {
        var n;
        const s = null === (n = e.icons) || void 0 === n ? void 0 : n.pin;
        return new Promise(e => {
          s ? (Ue(s, t), sr(s, i, r).then(() => e(!0))) : e(!1);
        });
      }
      function gs(e, t) {
        if (e) {
          const i = e;
          i.advancedMarker ? i.zIndex = t : e.zIndexElement && (kt(e.zIndexElement) ? e.zIndexElement.forEach(e => He(e, t)) : He(e.zIndexElement, t));
        }
      }
      function ms(e) {
        null != e && e.bounceElement && Si(e.bounceElement);
      }
      function ys(e, t) {
        return "none" !== e[t];
      }
      function vs(e, t) {
        t && Object.keys(t).forEach(i => {
          if (ys(t, i)) {
            const r = me(void 0, e, `corner-icon ${i}`);
            hs(t[i], r);
          }
        });
      }
      function bs(e, t) {
        if (t) {
          const i = e.parentElement || void 0;
          Object.keys(t).forEach(r => {
            if (ys(t, r)) {
              let n;
              switch (r) {
                case "left":
                  {
                    const t = le(e);
                    t >= 0 && (n = me(void 0, void 0, `inner-icon ${r}`), ut(n, i, t));
                  }
                  break;
                case "right":
                  n = me(void 0, i, `inner-icon ${r}`);
              }
              n && hs(t[r], n);
            }
          });
        }
      }
      function ks(e, t) {
        const i = Object.keys(e);
        return !(Dt(i, Object.keys(t), !1) && i.every(i => t[i] && !or(e[i], t[i], !0)));
      }
      function Ms(e, t) {
        return ks(e, t);
      }
      function Cs(e, t) {
        return ks(e, t);
      }
      function ws(e, t) {
        let i;
        return Object.keys(t).forEach(r => {
          const n = as(t[r][e.type], e.hashKeys);
          n && "none" !== n && (i || (i = {}), i[r] = n);
        }), i;
      }
      function xs(e, t) {
        return ws(e, t);
      }
      function Ps(e, t) {
        return ws(e, t);
      }
      function Fs(e, t) {
        return t(e, us.doubleClick, e => {
          e.stopPropagation();
        });
      }
      function Ls(e, t, i) {
        const {
          ariaElement: r
        } = t;
        i && r && (e && i.onSelect ? Fe(r, i.onSelect) : i.default ? Fe(r, i.default) : _e(r));
      }
      function _s(e, t, i, r, n, s, o, a) {
        let {
          feature: l,
          container: u,
          cornerIcons: h,
          innerIcons: d,
          cssClasses: c,
          label: p,
          subLabel: f
        } = t;
        const g = {};
        g.cssClasses = c;
        const m = `${c.join(" ")}`,
          y = u || me(e, i, m, s);
        let v, b;
        g.content = y, u && at(u, m, s), a && (v = me(void 0, y, "pin-marker"), b = me(void 0, v, "marker-icon-inter"), Ee(b));
        const {
          iconImg: k,
          main: M
        } = hs(r, b || y, n, !0, ls);
        g.frameIcon = n, g.icons = {
          cornerIcons: h,
          innerIcons: d,
          pin: Z(r) ? M : k
        }, vs(b || y, h), bs(k, d), g.ariaElement = b || y, g.zIndexElement = v || y, g.bounceElement = M, g.cssElement = y, g.labels = {
          textLblCont: b || y
        }, Yn(g, l, p, f, o);
        const C = "none" !== n ? b || y : k;
        return g.listening !== C && (Rs(g), g.listening = C), a ? (a(g, l), g.clone = () => Bs(l, g, o)) : g.clone = () => y.cloneNode(!0), g;
      }
      function Os(e, t, i, r, n, s) {
        const {
            ariaElement: o
          } = t,
          {
            feature: a,
            zIndex: l,
            tabIndex: u,
            clickable: h,
            ariaLabels: d
          } = i;
        o && (t.advancedMarker || Re(o, u), s(a.highlighted, t, d)), As(e, t), function (e, t, i, r, n) {
          if (t.listening) {
            const s = () => e;
            kt(t.listening) ? t.clean = t.listening.flatMap(e => Ts(e, !0, i, s, r, n)) : t.clean = Ts(t.listening, !0, i, s, r, n);
          }
        }(a, e, h, r, n), gs(e, l);
      }
      function Es(e, t, i, r, n, s, o, a) {
        let {
          feature: l,
          container: u,
          cornerIcons: h,
          innerIcons: d,
          cssClasses: c,
          label: p,
          subLabel: f
        } = t;
        const g = {};
        g.cssClasses = c;
        const m = c.join(" "),
          y = u || me(e, i, m, s);
        let v;
        u && at(u, m, s), a && (v = me(void 0, y, "price-marker")), g.zIndexElement = y;
        const {
          text: b,
          span: k
        } = a ? ds(v, "price", r) : ds(y, n, r);
        g.content = y, g.icons = {
          cornerIcons: h,
          innerIcons: d
        }, vs(b, h), bs(k, d), g.ariaElement = b, g.zIndexElement = v || y, g.bounceElement = b, g.cssElement = y, g.labels = {
          textLblCont: v || y
        }, g.text = r, Yn(g, l, p, f, o);
        const M = v || y;
        return g.listening !== M && (Rs(g), g.listening = M), a ? (a(g, l), g.clone = () => Bs(l, g, o)) : g.clone = () => (v || y).cloneNode(!0), g;
      }
      function Is(e, t) {
        return ["cluster-marker", `cluster-${e}-marker`, ...t.split("#")];
      }
      function Ds(e, t, i, r, n, s) {
        const o = {},
          a = me(e, t, Is(r, n).join(" "), `visibility:false;${s || ""}`),
          {
            text: l
          } = ds(a, "cluster", i.text, "cluster-label-content");
        o.content = a, o.ariaElement = l, Fe(l, i.text), o.zIndexElement = a, o.bounceElement = l, o.cssElement = a, o.text = i.text;
        const u = a;
        return o.listening !== u && (Rs(o), o.listening = u), o.clone = () => a.cloneNode(!0), o;
      }
      function Ss(e, t, i, r, n, s) {
        let {
          feature: o,
          container: a,
          cssClasses: l,
          label: u,
          subLabel: h
        } = t;
        const d = {};
        d.cssClasses = l;
        const c = l.join(" "),
          p = a || me(e, i, c, r);
        d.content = p, a && at(a, c, r);
        const f = s(d, o);
        d.ariaElement = p, d.zIndexElement = p, d.cssElement = p, d.labels = {
          textLblCont: p
        }, Yn(d, o, u, h, n);
        const g = f || p;
        return d.listening !== g && (Rs(d), d.listening = g), d.clone = () => Bs(o, d, n), d;
      }
      function Bs(e, t, i) {
        var r, n, s, o, a;
        const l = as(i.obfuscateStyle[e.type], e.hashKeys),
          u = Rt(null == l || null === (r = l.line) || void 0 === r ? void 0 : r.opacity),
          h = Rt(null == l || null === (n = l.fill) || void 0 === n ? void 0 : n.opacity),
          d = t.content.cloneNode(!0);
        tt(d, "markerClone");
        const c = `${null == l || null === (s = l.fill) || void 0 === s ? void 0 : s.color}${h}`,
          p = `${null == l || null === (o = l.line) || void 0 === o ? void 0 : o.weight}px`,
          f = `${null == l || null === (a = l.line) || void 0 === a ? void 0 : a.color}${u}`;
        return d.dataset.cloneStyles = `--fillcolor:${c}; --linewidth:${p}; --linecolor:${f};`, d;
      }
      function As(e, t) {
        Object.keys(t).filter(e => "content" !== e).forEach(i => {
          e[i] = t[i];
        });
      }
      function Ts(e, t, i, r, n, s) {
        let {
          addEventListener: o,
          stopPropagation: a,
          handleClick: l,
          handleMouseOver: u,
          handleMouseOut: h,
          handleKeyPress: d
        } = s;
        const c = t ? n.actionsOnMarkerClick : n.actionsOnPopupClick,
          p = t ? n.actionsOnMarkerMouseOver : n.actionsOnPopupMouseOver,
          f = t ? n.actionsOnMarkerMouseOut : n.actionsOnPopupMouseOut,
          g = t ? n.keyNamesForMarkerKeyPressEvent : n.keyNamesForPopupKeyPressEvent;
        return [...(i ? [o(e, us.defaultClick, e => {
          a(e), l(r(), t, c, e.type);
        }), o(e, us.keyPress, e => {
          d(r(), g, e.code) && a(e);
        })] : []), o(e, us.mouseEnter, e => {
          a(e), u(r(), t, p, e.type);
        }), o(e, us.mouseLeave, e => {
          a(e), h(r(), t, f, e.type);
        }), Fs(e, o)];
      }
      function Rs(e) {
        var t;
        null === (t = e.clean) || void 0 === t || t.forEach(e => e()), e.clean = [];
      }
      function Vs(e, t, i, r, n) {
        let s = r;
        s || (s = ps(e, i));
        const {
            markerType: o,
            icons: a,
            frameIcon: l,
            cssClasses: u,
            zIndex: h,
            tabIndex: d,
            clickable: c,
            text: p = "?",
            label: f,
            subLabel: g
          } = s,
          {
            pin: m,
            cornerIcons: y,
            innerIcons: v
          } = a || {},
          {
            ariaLabels: b
          } = e;
        Array.isArray(n) && (u.toAdd = [...u.toAdd, ...n]);
        const k = {
            feature: e,
            container: he(t),
            cssClasses: u.toAdd,
            zIndex: h,
            tabIndex: d,
            clickable: c,
            label: f,
            subLabel: g,
            ariaLabels: b
          },
          M = "none" !== l || "pin" !== o && "pinObfuscate" !== o && "obfuscate" !== o;
        return {
          markerType: o,
          frameIcon: l,
          text: p,
          pin: m,
          minimal: k,
          common: ss(ss({}, k), {}, {
            cornerIcons: y,
            innerIcons: M ? v : void 0
          })
        };
      }
      function Ks(e, t, i, r, n, s, o, a, l) {
        const u = ps(e, t),
          {
            icons: h,
            zIndex: d,
            cssClasses: c
          } = u,
          {
            marker: p
          } = e,
          {
            ariaLabels: f
          } = e,
          g = null == h ? void 0 : h.pin;
        Ns(e, u, o) ? r(e, u) : (h && !Z(g) && fs(p, g, s, i).then(t => (t && n(e), t)), Je(p.cssElement, c.toRemove, c.toAdd), p.cssClasses = et(p.cssElement), l(e.highlighted, p, f), gs(p, d), function (e, t, i) {
          var r;
          const {
              marker: n
            } = e,
            {
              label: s,
              subLabel: o
            } = cs(e, t);
          null === (r = n.labels) || void 0 === r || r.updateTextLabel(s, o, i);
        }(e, t, a()));
      }
      function Ns(e, t, i) {
        const {
          marker: r
        } = e;
        if (r) {
          if ("clusterMarker" === r.markerType) return !1;
          {
            const {
                icons: n = {},
                clickable: s,
                markerType: o,
                text: a,
                frameIcon: l
              } = t,
              {
                pin: u,
                cornerIcons: h = {},
                innerIcons: d = {}
              } = n,
              {
                markerType: c,
                icons: {
                  pin: p,
                  cornerIcons: f,
                  innerIcons: g
                } = {},
                text: m,
                frameIcon: y,
                clickable: v
              } = r,
              b = null == p ? void 0 : p.hashCode,
              k = !(!l && !y || l === y),
              M = () => b ? !Z(u) || b !== Q(u) : Z(u),
              C = "price" === c || "text" === c || "priceObfuscate" === c,
              w = "pin" === c || "pinObfuscate" === c,
              x = "pinObfuscate" === c || "priceObfuscate" === c || "obfuscate" === c;
            return c !== o || Ms(f || {}, h) || Cs(g || {}, d) || v !== s || C && a !== m || w && (k || M()) || x && i(e);
          }
        }
        return !0;
      }
      function js(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function $s(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? js(Object(i), !0).forEach(function (t) {
            zs(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : js(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function zs(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      const {
          isObject: Us,
          stringify: Hs,
          firstDefinedValue: Zs
        } = t,
        qs = "markers",
        Qs = "default",
        Ws = "undefined" != typeof google ? google.maps.Marker.MAX_ZINDEX : 0;
      class Gs extends Di {
        constructor(e, t, i, r) {
          super(e, t, r), this._loadLocale(e), this.i18n = new Bi(i, this.locale, {
            readParam: this.readParam.bind(this),
            writeParam: this.writeParam.bind(this)
          }), this.qualifiersAndHashkeysUsed = {};
        }
        ready() {
          return super.ready().then(() => (this.loadQualifiersAndHashkeysUsed(), this));
        }
        getEGMapConfigurations() {
          const e = this.getConfigurations();
          return {
            default: e.default,
            external: e.external,
            overwrite: e.overwrite,
            parameter: e.parameter,
            final: this.subConfig()
          };
        }
        loadQualifiersAndHashkeysUsed(e) {
          (e ? [e] : xn).forEach(e => this.qualifiersAndHashkeysUsed[e] = this._identifyQualifiersAndHashKeysUsedInHashkeys(e));
        }
        _loadLocale(e) {
          this.locale = null == e ? void 0 : e.locale;
          const t = this.readParam("locale");
          if (t) {
            const [, e,,, i] = /^([a-z]{2})((-|_)([A-Z]{2}))?$/.exec(t) || [];
            e && (this.locale = i ? `${e}-${i}` : e);
          }
        }
        mapProvider() {
          return this.readParam("mapProvider");
        }
        getLocale() {
          return this.locale;
        }
        getI18N(e) {
          for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
          return this.i18n.format(e, ...i);
        }
        filterQualifiersUsed(e, t) {
          const i = this.qualifiersAndHashkeysUsed[e].qualifiers;
          return t.filter(e => i.includes(e));
        }
        isQualifiersUsedInConfig(e, t) {
          return this.qualifiersAndHashkeysUsed[e].qualifiers.includes(t);
        }
        filterHashkeysUsed(e, t) {
          const i = this.qualifiersAndHashkeysUsed[e].hashkeys;
          return t.filter(e => i.includes(e));
        }
        _identifyQualifiersAndHashKeysUsedInHashkeys(e) {
          const t = new Set(),
            i = new Set();
          i.add("default");
          return this._identifyAllHashkeys(e).forEach(r => {
            i.add(r), r.split("#").forEach(i => {
              this.getFeatureStatus(e).includes(i) || "hl" === i || t.add(i);
            });
          }), {
            qualifiers: [...t],
            hashkeys: [...i].map(e => e.split("#").sort().join("#"))
          };
        }
        _identifyAllHashkeys(e) {
          const t = this.listStringKeys(`markers,${e}`),
            i = new Set(),
            r = new Set();
          t.forEach(e => {
            if (e.endsWith(Qs)) r.add(e.substring(0, e.length - 7 - 1));else {
              const t = e.indexOf(`,${Qs},`);
              t > 0 ? r.add(e.substring(0, t)) : i.add(e);
            }
          });
          const n = new Set();
          return i.forEach(e => {
            r.forEach(t => {
              e.startsWith(t) && n.add(e.substring(t.length + 1).split(",")[0]);
            });
          }), [...n];
        }
        mapboxAccessToken() {
          return this.readParam("mapbox,accessToken");
        }
        getFeatureTypes() {
          return kn;
        }
        getFeatureStatus(e) {
          switch (e) {
            case gn:
              return Cn;
            case mn:
              return wn;
            case yn:
            case vn:
              return [Mn];
            default:
              throw new Error(`Type unknown: ${e}`);
          }
        }
        iso4217CurrencyCode() {
          return this.readParam("iso4217CurrencyCode");
        }
        icons() {
          return this.propertyValues(qs, "icons", kn);
        }
        frameIcons() {
          return this.propertyValues(qs, "frameIcons", kn);
        }
        cornerIcons() {
          return {
            "top-left": this.propertyValues(qs, "cornerIcons,topLeft", kn),
            "top-right": this.propertyValues(qs, "cornerIcons,topRight", kn),
            "bottom-left": this.propertyValues(qs, "cornerIcons,bottomLeft", kn),
            "bottom-right": this.propertyValues(qs, "cornerIcons,bottomRight", kn)
          };
        }
        innerIcons() {
          return {
            left: this.propertyValues(qs, "innerIcons,left", kn),
            right: this.propertyValues(qs, "innerIcons,right", kn)
          };
        }
        obfuscateRadiusInMeters() {
          return this.propertyValues(qs, "obfuscateMarkers,radiusInM", bn);
        }
        obfuscatePrecision() {
          return this.propertyValues(qs, "obfuscateMarkers,precision", bn);
        }
        obfuscateStyle() {
          return this.propertyValues(qs, "obfuscateMarkers,style", bn);
        }
        polygonStyles() {
          return this.propertyValues("polygons", "style", kn);
        }
        zIndexes() {
          const e = this.propertyValues(qs, "zIndex", xn);
          if ("google-maps" === this.mapProvider()) for (let t in e) for (let i in e[t]) e[t][i] = e[t][i] + Ws;
          return e;
        }
        tabIndexes() {
          return this.propertyValues(qs, "tabIndex", xn);
        }
        maxZIndex() {
          const e = this.zIndexes();
          let t = 0;
          return Object.values(e).forEach(e => Object.values(e).forEach(e => {
            e > t && (t = e);
          })), t;
        }
        textLabelDynamicPlacement() {
          return this.propertyValues(qs, "textLabel,dynamicPlacement", kn);
        }
        textLabelMaxLineLength() {
          return this.propertyValues(qs, "textLabel,maxLineLength", kn);
        }
        textLabelMaxLines() {
          return this.propertyValues(qs, "textLabel,maxLines", kn);
        }
        textLabelMinZoom() {
          return this.propertyValues(qs, "textLabel,minZoom", kn);
        }
        textLabelMaxZoom() {
          return this.propertyValues(qs, "textLabel,maxZoom", kn);
        }
        textSubLabelMinZoom() {
          return this.propertyValues(qs, "textLabel,subLabel,minZoom", kn);
        }
        textSubLabelMaxZoom() {
          return this.propertyValues(qs, "textLabel,subLabel,maxZoom", kn);
        }
        textSubLabelMaxLineLength() {
          return this.propertyValues(qs, "textLabel,subLabel,maxLineLength", kn);
        }
        textSubLabelMaxLines() {
          return this.propertyValues(qs, "textLabel,subLabel,maxLines", kn);
        }
        textLabelVisibility() {
          return this.propertyValues(qs, "textLabel,show", xn);
        }
        textSubLabelVisibility() {
          return this.propertyValues(qs, "textLabel,subLabel,show", xn);
        }
        textLabelZIndex() {
          return this.propertyValues(qs, "textLabel,zIndex", xn);
        }
        textLabelPosition() {
          return this.propertyValues(qs, "textLabel,position", xn, e => {
            let t = e;
            switch (e) {
              case "bottom":
                t = "below";
                break;
              case "top":
                t = "above";
            }
            return t;
          });
        }
        popupPositions() {
          return this.propertyValues(qs, "popup,position", kn, e => {
            let t = e;
            switch (e) {
              case "bottom":
                t = "below";
                break;
              case "top":
                t = "above";
            }
            return t;
          });
        }
        popupVisibilities() {
          return this.propertyValues(qs, "popup,ensureVisibility", kn);
        }
        popupVisibilityPaddings() {
          return this.propertyValues(qs, "popup,visibilityPadding", kn);
        }
        markerTypes() {
          return this.propertyValues(qs, "markerType", kn);
        }
        isAtLeastOneProductStatusUsingObfuscateMarker() {
          return Object.values(this.markerTypes().product || {}).some(e => "obfuscate" === e || "pinObfuscate" === e || "priceObfuscate" === e);
        }
        isAtLeastOnePropertyStatusUsingObfuscateMarker() {
          return Object.values(this.markerTypes().property || {}).some(e => "obfuscate" === e || "pinObfuscate" === e || "priceObfuscate" === e);
        }
        markersShow() {
          return this.propertyValues(qs, "show", kn);
        }
        markersClickable() {
          return this.propertyValues(qs, "clickable", kn);
        }
        markersKeepOutOfViewport() {
          return this.propertyValues(qs, "keepOutOfViewport", kn);
        }
        actionsOnFeatureSelect() {
          return this.propertyValues(qs, "actionOnFeatureSelect", xn);
        }
        actionsOnFeatureDeselect() {
          return this.propertyValues(qs, "actionOnFeatureDeselect", kn);
        }
        actionsOnFeatureOver() {
          return this.propertyValues(qs, "actionOnFeatureOver", xn);
        }
        actionsOnFeatureOut() {
          return this.propertyValues(qs, "actionOnFeatureOut", xn);
        }
        actionsOnMarkerClick() {
          return this.propertyValues(qs, "actionOnClick", xn);
        }
        actionsOnMarkerMouseOver() {
          return this.propertyValues(qs, "actionOnMouseOver", xn);
        }
        actionsOnMarkerMouseOut() {
          return this.propertyValues(qs, "actionOnMouseOut", xn);
        }
        keyNamesForMarkerKeyPressEvent() {
          return this.propertyValues(qs, "keyNameForKeyPressEvent", xn);
        }
        actionsOnPopupClick() {
          return this.propertyValues(qs, "popup,actionOnClick", kn);
        }
        actionsOnPopupMouseOver() {
          return this.propertyValues(qs, "popup,actionOnMouseOver", kn);
        }
        actionsOnPopupMouseOut() {
          return this.propertyValues(qs, "popup,actionOnMouseOut", kn);
        }
        keyNamesForPopupKeyPressEvent() {
          return this.propertyValues(qs, "popup,keyNameForKeyPressEvent", kn);
        }
        actionsOnMapDrag() {
          return this.readParam("map,onMapDrag");
        }
        baseMapMarkersClick() {
          return this.subConfig("map,baseMapMarkersClick");
        }
        actionsOnMapClick() {
          return this.readParam("map,onMapClick");
        }
        singlePropertiesValues(e, t) {
          const i = {};
          return t.map(t => {
            i[t] = this.readParam(`${qs},${t},${e}`);
          }), i;
        }
        threshold() {
          const e = this.propertyValues(qs, "threshold", kn),
            t = this.singlePropertiesValues(`threshold,${Qs}`, kn);
          return kn.forEach(i => e[i].default = t[i]), e;
        }
        style() {
          return this.subConfig("style");
        }
        maxZoomForCount() {
          const e = this.propertyValues(qs, "maxZoomForCount", kn),
            t = this.singlePropertiesValues(`maxZoomForCount,${Qs}`, kn);
          return kn.forEach(i => e[i].default = t[i]), e;
        }
        clusterConfigurationByType() {
          return this.propertyValues(qs, "clustering", kn);
        }
        clusterDefaultConfigurationByType() {
          const e = {};
          return kn.forEach(t => {
            e[t] = this.subConfig(`markers,${t},clustering,default`);
          }), e;
        }
        isKeyboardFeaturesDefined() {
          return void 0 !== this.readParam("a11y,keyboardFeatures,enabled");
        }
        isKeyboardFeaturesEnabled() {
          return !0 === this.readParam("a11y,keyboardFeatures,enabled");
        }
        isAnyContentProviderExists() {
          const e = this.contentProvidersByFeatureType();
          return Object.keys(e).some(t => {
            const i = e[t];
            return Object.keys(i).some(e => i[e].length > 0);
          });
        }
        minZoomForDisplay() {
          const e = this.propertyValues(qs, "minZoomForDisplay", kn),
            t = this.singlePropertiesValues(`minZoomForDisplay,${Qs}`, kn);
          return kn.forEach(i => e[i].default = t[i]), e;
        }
        minZoomForTileRequest() {
          return this.readParam("tiles,minZoomForTileRequest");
        }
        historicalBoundingBoxDataEndpoint() {
          return this.readParam("historicalBoundingBoxDataEndpoint");
        }
        tagCollidingMarkers() {
          const e = this.propertyValues(qs, "tagCollidingMarkers", xn),
            t = this.singlePropertiesValues(`tagCollidingMarkers,${Qs}`, xn);
          return xn.forEach(i => e[i].default = t[i]), e;
        }
        tagCutOffMarkers() {
          const e = this.propertyValues(qs, "tagCutOffMarkers", xn),
            t = this.singlePropertiesValues(`tagCutOffMarkers,${Qs}`, xn);
          return xn.forEach(i => e[i].default = t[i]), e;
        }
        collisionBufferVariation() {
          const e = this.propertyValues(qs, "collisionBufferVariation", xn),
            t = this.singlePropertiesValues(`collisionBufferVariation,${Qs}`, xn);
          return xn.forEach(i => e[i].default = t[i]), e;
        }
        collisionBuffers() {
          return this.subConfig("markers,common,collisionBuffers");
        }
        clusterMarkerCollisionBufferInPixels() {
          return this.readParam("markers,cluster,clusterMarkerCollisionAvoidance,clusterMarkerCollisionBufferInPixels,default");
        }
        shouldMoveCollidingClusterMarkers() {
          return this.readParam("markers,cluster,clusterMarkerCollisionAvoidance,moveCollidingClusterMarkers,default");
        }
        routeLineStyleByDistanceMode() {
          return this.propertyValues("routes,style", void 0, ["driving", "cycling", "walking", "flying"]);
        }
        googleMaps() {
          return this.subConfig("googleMaps");
        }
        mapbox() {
          return this.subConfig("mapbox");
        }
        tilesReaderConfig() {
          return this.subConfig("tiles,enabled");
        }
        tilesProvidersConfig() {
          return this.subConfig("tiles,providers");
        }
        tilesCacheConfig() {
          return this.subConfig("tiles,cache");
        }
        routeCacheInMs() {
          return this.readParam("routes,cacheInMs");
        }
        egDistances() {
          return this.readParam("routes,egDistances");
        }
        keyboardFeaturesIcon() {
          return this.readParam("a11y,keyboardFeatures,keyboardFeaturesIcon");
        }
        contentProvidersByFeatureType() {
          const e = {};
          return kn.forEach(t => e[t] = this.readParam(`contentProvider,${t}`)), e;
        }
        contentProvidersConfigs() {
          return this.subConfig("contentProvider,providers");
        }
        availabilityProvider() {
          return this.subConfig("availability,availabilityProvider");
        }
        gmapsAddConfig() {
          return this.subConfig("googleMaps,gmapsAddConfig");
        }
        loadMapSettings() {
          return {
            mapProvider: this.mapProvider(),
            loggerFactory: this.logger.bind(this),
            featureTypes: kn,
            getFeatureStatus: this.getFeatureStatus.bind(this),
            getI18N: this.getI18N.bind(this),
            actionsOnFeatureSelect: this.actionsOnFeatureSelect(),
            actionsOnFeatureDeselect: this.actionsOnFeatureDeselect(),
            actionsOnFeatureOver: this.actionsOnFeatureOver(),
            actionsOnFeatureOut: this.actionsOnFeatureOut(),
            actionsOnMarkerClick: this.actionsOnMarkerClick(),
            actionsOnMarkerMouseOver: this.actionsOnMarkerMouseOver(),
            actionsOnMarkerMouseOut: this.actionsOnMarkerMouseOut(),
            keyNamesForMarkerKeyPressEvent: this.keyNamesForMarkerKeyPressEvent(),
            actionsOnPopupClick: this.actionsOnPopupClick(),
            actionsOnPopupMouseOver: this.actionsOnPopupMouseOver(),
            actionsOnPopupMouseOut: this.actionsOnPopupMouseOut(),
            keyNamesForPopupKeyPressEvent: this.keyNamesForPopupKeyPressEvent(),
            popupPositions: this.popupPositions(),
            actionsOnMapDrag: this.actionsOnMapDrag(),
            actionsOnMapClick: this.actionsOnMapClick(),
            baseMapMarkersClick: this.baseMapMarkersClick(),
            routeCacheInMs: this.routeCacheInMs(),
            contentProvidersByFeatureType: this.contentProvidersByFeatureType(),
            contentProvidersConfigs: this.contentProvidersConfigs(),
            availabilityProvider: this.availabilityProvider(),
            locale: this.getLocale(),
            isKeyboardFeaturesDefined: this.isKeyboardFeaturesDefined(),
            isKeyboardFeaturesEnabled: this.isKeyboardFeaturesEnabled(),
            keyboardFeaturesIcon: this.keyboardFeaturesIcon(),
            tiles: {
              tilesReaderConfig: this.tilesReaderConfig(),
              tilesProvidersConfig: this.tilesProvidersConfig(),
              tilesCacheConfig: this.tilesCacheConfig(),
              minZoomForTileRequest: this.minZoomForTileRequest(),
              debugTileId: Ii.getDebugTilesIdEnabled()
            },
            styling: this.style(),
            threshold: this.threshold(),
            maxZoomForCount: this.maxZoomForCount(),
            minZoomForDisplay: this.minZoomForDisplay(),
            clusterConfigurationByType: this.clusterConfigurationByType(),
            clusterDefaultConfigurationByType: this.clusterDefaultConfigurationByType(),
            isAnyContentProviderExists: this.isAnyContentProviderExists(),
            historicalBoundingBoxDataEndpoint: this.historicalBoundingBoxDataEndpoint(),
            markerTypes: this.markerTypes(),
            markersClickable: this.markersClickable(),
            isAtLeastOneProductStatusUsingObfuscateMarker: this.isAtLeastOneProductStatusUsingObfuscateMarker(),
            isAtLeastOnePropertyStatusUsingObfuscateMarker: this.isAtLeastOnePropertyStatusUsingObfuscateMarker(),
            obfuscateRadiusInMeters: this.obfuscateRadiusInMeters(),
            obfuscatePrecision: this.obfuscatePrecision(),
            obfuscateStyle: this.obfuscateStyle(),
            icons: this.icons(),
            frameIcons: this.frameIcons(),
            cornerIcons: this.cornerIcons(),
            innerIcons: this.innerIcons(),
            textLabelVisibility: this.textLabelVisibility(),
            textSubLabelVisibility: this.textSubLabelVisibility(),
            zIndexes: this.zIndexes(),
            maxZIndex: this.maxZIndex(),
            tabIndexes: this.tabIndexes(),
            textLabelZIndex: this.textLabelZIndex(),
            textLabelMinZoom: this.textLabelMinZoom(),
            textLabelMaxZoom: this.textLabelMaxZoom(),
            textLabelPosition: this.textLabelPosition(),
            textLabelMaxLineLength: this.textLabelMaxLineLength(),
            textLabelMaxLines: this.textLabelMaxLines(),
            textSubLabelMinZoom: this.textSubLabelMinZoom(),
            textSubLabelMaxZoom: this.textSubLabelMaxZoom(),
            textSubLabelMaxLineLength: this.textSubLabelMaxLineLength(),
            textSubLabelMaxLines: this.textSubLabelMaxLines(),
            polygonStyles: this.polygonStyles(),
            iso4217CurrencyCode: this.iso4217CurrencyCode(),
            debugMarkersPosition: Ii.getDebugMarkersPositionEnabled(),
            collision: {
              labelVisibility: this.textLabelVisibility(),
              dynamicPlacement: this.textLabelDynamicPlacement(),
              collisionBufferVariation: this.collisionBufferVariation(),
              collisionBuffers: this.collisionBuffers(),
              tagCollidingMarkers: this.tagCollidingMarkers(),
              tagCutOffMarkers: this.tagCutOffMarkers(),
              clusterMarkerCollisionBufferInPixels: this.clusterMarkerCollisionBufferInPixels(),
              shouldMoveCollidingClusterMarkers: this.shouldMoveCollidingClusterMarkers()
            },
            routeLineStyleByDistanceMode: this.routeLineStyleByDistanceMode(),
            googleMaps: $s($s({}, this.googleMaps()), {}, {
              debugShouldUseAdvancedMarkers: Ii.shouldUseGmapsAdvancedMarkers()
            }),
            mapbox: this.mapbox()
          };
        }
        getActiveTilesets() {
          const e = this.readParam("tiles,enabled,product"),
            t = this.readParam("tiles,enabled,property"),
            i = this.readParam("tiles,enabled,place"),
            r = [].concat(e, t, i),
            n = this.subConfig("tiles,providers");
          return r.map(e => {
            var t;
            return null === (t = n[e]) || void 0 === t ? void 0 : t.tilesetId;
          });
        }
        overrideMarkerShowConfig(e, t, i) {
          const r = `markers,${e},show,${[i, ...(arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [])].filter(e => void 0 !== e).join("#")}`;
          null === t ? this.removeOverrideParam(r) : this.writeParam(r, t);
        }
      }
      function Xs(e, t) {
        var i, r;
        const n = e.mapProvider !== t.mapProvider || "mapbox" === t.mapProvider && Ys(e.mapbox, t.mapbox) || "google-maps" === t.mapProvider && ((null === (i = e.googleMaps) || void 0 === i || null === (i = i.gmapsAddConfig) || void 0 === i ? void 0 : i.mapId) || "") !== ((null === (r = t.googleMaps) || void 0 === r || null === (r = r.gmapsAddConfig) || void 0 === r ? void 0 : r.mapId) || "");
        if (n) return {
          reinstantiate: n
        };
        const s = "google-maps" === t.mapProvider && (Ys(e.googleMaps.gmapsAddConfig || {}, t.googleMaps.gmapsAddConfig || {}) || Ys(e.baseMapMarkersClick || {}, t.baseMapMarkersClick || {})),
          o = Js(e.icons, t.icons),
          a = Ys(e.frameIcons, t.frameIcons),
          l = Js(e.cornerIcons, t.cornerIcons),
          u = Js(e.innerIcons, t.innerIcons),
          h = Ys(e.contentProvidersByFeatureType, t.contentProvidersByFeatureType),
          d = Ys(e.threshold, t.threshold),
          c = Ys(e.maxZoomForCount, t.maxZoomForCount),
          p = Ys(e.minZoomForDisplay, t.minZoomForDisplay),
          f = Ys(e.clusterConfigurationByType, t.clusterConfigurationByType),
          g = Ys(e.markerTypes, t.markerTypes),
          m = Ys(e.markersClickable, t.markersClickable),
          y = Ys(e.obfuscateRadiusInMeters, t.obfuscateRadiusInMeters),
          v = Ys(e.obfuscatePrecision, t.obfuscatePrecision),
          b = Ys(e.obfuscateStyle, t.obfuscateStyle),
          k = Ys(e.textLabelVisibility, t.textLabelVisibility),
          M = Ys(e.textSubLabelVisibility, t.textSubLabelVisibility),
          C = Ys(e.zIndexes, t.zIndexes),
          w = Ys(e.tabIndexes, t.tabIndexes),
          x = Ys(e.textLabelZIndex, t.textLabelZIndex),
          P = Ys(e.textLabelMinZoom, t.textLabelMinZoom),
          F = Ys(e.textLabelMaxZoom, t.textLabelMaxZoom),
          L = Ys(e.textLabelPosition, t.textLabelPosition),
          _ = Ys(e.textLabelMaxLineLength, t.textLabelMaxLineLength),
          O = Ys(e.textLabelMaxLines, t.textLabelMaxLines),
          E = Ys(e.textSubLabelMinZoom, t.textSubLabelMinZoom),
          I = Ys(e.textSubLabelMaxZoom, t.textSubLabelMaxZoom),
          D = Ys(e.textSubLabelMaxLineLength, t.textSubLabelMaxLineLength),
          S = Ys(e.textSubLabelMaxLines, t.textSubLabelMaxLines),
          B = Ys(e.polygonStyles, t.polygonStyles),
          A = Ys(e.collision, t.collision),
          T = Ys(e.routeLineStyleByDistanceMode, t.routeLineStyleByDistanceMode),
          R = Ys(e.contentProvidersConfigs, t.contentProvidersConfigs),
          V = Ys(e.availabilityProvider, t.availabilityProvider),
          K = Ys(e.clusterDefaultConfigurationByType, t.clusterDefaultConfigurationByType),
          N = Ys(e.tiles, t.tiles),
          j = Ys(e.actionsOnFeatureSelect, t.actionsOnFeatureSelect) || Ys(e.actionsOnFeatureDeselect, t.actionsOnFeatureDeselect) || Ys(e.actionsOnFeatureOver, t.actionsOnFeatureOver) || Ys(e.actionsOnFeatureOut, t.actionsOnFeatureOut) || Ys(e.actionsOnMarkerClick, t.actionsOnMarkerClick) || Ys(e.actionsOnMarkerMouseOver, t.actionsOnMarkerMouseOver) || Ys(e.actionsOnMarkerMouseOut, t.actionsOnMarkerMouseOut) || Ys(e.keyNamesForMarkerKeyPressEvent, t.keyNamesForMarkerKeyPressEvent) || Ys(e.actionsOnPopupClick, t.actionsOnPopupClick) || Ys(e.actionsOnPopupMouseOver, t.actionsOnPopupMouseOver) || Ys(e.actionsOnPopupMouseOut, t.actionsOnPopupMouseOut) || Ys(e.keyNamesForPopupKeyPressEvent, t.keyNamesForPopupKeyPressEvent) || Ys(e.popupPositions, t.popupPositions) || h || d || c || p || e.isAnyContentProviderExists !== t.isAnyContentProviderExists || f || g || m || y || v || b || o || a || l || u || k || M || C || w || x || P || F || L || _ || O || E || I || D || S || A,
          $ = N,
          z = {
            updateMapProviderConfig: s,
            updateViewport: T || e.routeCacheInMs !== t.routeCacheInMs || h || R || V || e.isKeyboardFeaturesDefined !== t.isKeyboardFeaturesDefined || e.isKeyboardFeaturesEnabled !== t.isKeyboardFeaturesEnabled || d || c || p || f || K || e.isAnyContentProviderExists !== t.isAnyContentProviderExists || g || m || e.isAtLeastOneProductStatusUsingObfuscateMarker !== t.isAtLeastOneProductStatusUsingObfuscateMarker || e.isAtLeastOnePropertyStatusUsingObfuscateMarker !== t.isAtLeastOnePropertyStatusUsingObfuscateMarker || y || v || b || o || a || l || u || k || M || C || w || x || P || F || L || _ || O || E || I || D || S || e.debugMarkersPosition !== t.debugMarkersPosition || A || N,
            updateMarkers: g || m || e.isAtLeastOneProductStatusUsingObfuscateMarker !== t.isAtLeastOneProductStatusUsingObfuscateMarker || e.isAtLeastOnePropertyStatusUsingObfuscateMarker !== t.isAtLeastOnePropertyStatusUsingObfuscateMarker || y || v || b || o || a || l || u || k || M || C || w || x || P || F || L || _ || O || E || I || D || S || e.debugMarkersPosition !== t.debugMarkersPosition,
            updateKeyboardA11yUI: e.isKeyboardFeaturesDefined !== t.isKeyboardFeaturesDefined || e.isKeyboardFeaturesEnabled !== t.isKeyboardFeaturesEnabled || Ys(e.actionsOnMarkerClick, t.actionsOnMarkerClick) || Ys(e.keyNamesForMarkerKeyPressEvent, t.keyNamesForMarkerKeyPressEvent) || Ys(e.keyNamesForPopupKeyPressEvent, t.keyNamesForPopupKeyPressEvent) || Ys(e.keyboardFeaturesIcon, t.keyboardFeaturesIcon),
            updateStyling: Ys(e.styling, t.styling),
            resetRouteManagement: T || e.routeCacheInMs !== t.routeCacheInMs,
            resetPolygonManagement: B,
            resetClusterers: f || K,
            resetContentProviders: h || R,
            resetCollisionManagement: A,
            resetAvailabilityCheck: V,
            updateBaseMapMarkersClickManagement: Ys(e.baseMapMarkersClick, t.baseMapMarkersClick),
            clearHashkeys: j,
            updateTiles: $
          };
        return Object.keys(z).filter(e => !1 === z[e]).forEach(e => delete z[e]), z;
      }
      function Ys() {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Hs(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}) !== Hs(e);
      }
      function Js() {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return Ys(eo(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), eo(e));
      }
      function eo(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new WeakSet();
        return Object.keys(e).forEach(r => {
          const n = e[r];
          Z(n) ? t[r] = q(n) : Us(n) ? i.has(n) || (t[r] = {}, eo(e[r], t[r], i)) : t[r] = n;
        }), t;
      }
      class to {
        constructor() {
          this._currentHover = void 0;
        }
        init(e) {
          let {
            switchQualifierMethod: t,
            findFeature: i
          } = e;
          this.switchQualifierMethod = t, this.findFeature = i;
        }
        markHover(e, t, i, r) {
          if (e) {
            const n = this._currentHover;
            if (t) {
              const t = {
                  id: e.id,
                  type: e.type
                },
                s = ft(i[e.type], e.hashKeys).includes("addHoverQualifier"),
                {
                  id: o,
                  type: a
                } = n || {},
                l = n ? this.findFeature(o, a) : void 0,
                u = !!l && ft(r[a], l.hashKeys).includes("removeHoverQualifier");
              if (this._currentHover = t, (s || u) && this.switchQualifierMethod(u ? n : void 0, s ? t : void 0, [ar.HOVER]), n && n.id === e.id && n.type === e.type) return;
              return n;
            }
            e === n && (this._currentHover = void 0);
            ft(r[e.type], e.hashKeys).includes("removeHoverQualifier") && this.switchQualifierMethod(n, void 0, [ar.HOVER]);
          }
        }
      }
      const io = ["id", "type"];
      function ro(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), i.push.apply(i, r);
        }
        return i;
      }
      function no(e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ro(Object(i), !0).forEach(function (t) {
            so(e, t, i[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ro(Object(i)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
          });
        }
        return e;
      }
      function so(e, t, i) {
        return (t = function (e) {
          var t = function (e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
              var r = i.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = i, e;
      }
      const {
          firstDefinedValue: oo,
          listHashKeysSorted: ao
        } = t,
        lo = "click";
      function uo() {
        return {
          highlightedFeatures: [],
          previouslySelectedFeatures: new Set(JSON.parse(sessionStorage.getItem("__map_previously_selected_features"))),
          selectedFeature: void 0,
          featuresOver: new Set(),
          product: {
            withMarkers: []
          },
          property: {
            withMarkers: []
          },
          place: {
            withMarkers: []
          },
          routes: [],
          routeDestinations: [],
          polygons: []
        };
      }
      class ho extends Un {
        constructor(e, t, i, r) {
          super(), this.eventsManager = t, this.features = i, this.mapData = r, this.boundsComputation = new ln(), this.listenersToDeregister = [], this.copyrightsDiv = this.createCopyrightsDiv(), this.copyrights = new Map(), this.popup = void 0, this.ignoreMapClickEvent = !1, this.configHelper = e, this.settings = this.configHelper.loadMapSettings(), this.logger = this.configHelper.logger("BaseMap"), this.logger.debug("BaseMap constructor"), this.featureTypes = this.settings.featureTypes, this.clusterFactory = new lr();
          const n = !1;
          this._newContentProviders(), this._newBaseMapMarkersClickManagement(), this._newKeyboardFeatures(n), this._newRouteManager(), this._newClusterers(), this._newAvailabilityCheck(), this._newCollisionManagement(n), this._newHoverManager(), this.tilesLoader = void 0, this.customMarkerOverlay = void 0;
        }
        _newBaseMapMarkersClickManagement() {
          this.baseMapMarkersClickManagement = new zn({
            logger: this.settings.loggerFactory("BaseMapMarkersClickManagement"),
            mapProvider: this.settings.mapProvider,
            locale: this.settings.locale,
            baseMapMarkersClickConfig: this.settings.baseMapMarkersClick,
            actionsOnMarkerClick: this.settings.actionsOnMarkerClick,
            eventsManager: this.eventsManager,
            handleClick: this.handleClick.bind(this),
            saveFeature: this.createTileFeature.bind(this),
            selectFeature: this.setSelectedFeature.bind(this),
            findFeature: this._findFeature.bind(this),
            listFeatures: this._listRepositoryFeatures.bind(this),
            removeFeatures: this._removeFeatures.bind(this),
            contentProvidersManager: this.contentProvidersManager
          });
        }
        _newKeyboardFeatures(e) {
          this.keyboardFeatures && this.keyboardFeatures.removeAllUIElements(), this.settings.isKeyboardFeaturesDefined ? (this.keyboardFeatures = new Tr(this.settings.keyboardFeaturesIcon, this.settings.getI18N), e && this._initializeKeyboardFeatures(this.keyboardFeatures)) : this.keyboardFeatures = void 0;
        }
        _initializeKeyboardFeatures(e) {
          e.init({
            node: this.node,
            uniqId: this.uniqId.bind(this),
            containerBounds: this.containerBounds.bind(this),
            listFeatures: this._listRepositoryFeatures.bind(this),
            zIndexes: this.settings.zIndexes,
            maxZIndex: this.settings.maxZIndex,
            getMapNavFocusElement: () => this.mapNavFocusElement,
            registerListenerOnMapFocusElement: this.registerListenerOnMapFocusElement.bind(this),
            handleClick: this.handleClick.bind(this),
            actionsOnClick: this.settings.actionsOnMarkerClick,
            isFeatureSelected: this.isFeatureSelected.bind(this),
            clearSelectedFeature: this.clearSelectedFeature.bind(this)
          }), this.settings.isKeyboardFeaturesEnabled && (this.turnKeyboardFeaturesMode(!0), e.updateKeyboardFeatures());
        }
        _updateMarkerPositionFromCollision() {
          var e;
          null === (e = this.collisionManagement) || void 0 === e || e.updateMarkerPosition(this.features.all());
        }
        _newAvailabilityCheck() {
          this.availabilityCheck = new br(this.settings.loggerFactory, this.settings.availabilityProvider);
        }
        _newContentProviders() {
          this.settings.isAnyContentProviderExists ? this.contentProvidersManager = new tn(this.settings.loggerFactory, this.eventsManager, this.settings.locale, this.featureTypes, this.settings.contentProvidersByFeatureType, this.settings.contentProvidersConfigs) : this.contentProvidersManager = void 0;
        }
        _newRouteManager() {
          this.routes = new fr({
            logger: this.settings.loggerFactory("RoutesRepository"),
            egDistances: this.configHelper.egDistances(),
            routeLineStyleByDistanceMode: this.settings.routeLineStyleByDistanceMode,
            routeCacheInMs: this.settings.routeCacheInMs,
            findFeature: this._findFeature.bind(this),
            eventsManager: this.eventsManager,
            addRouteOnMap: this.addRouteOnMap.bind(this),
            removeRouteOnMap: this.removeRouteOnMap.bind(this),
            asKey: this.asKey
          }, this.mapData.routes, this.mapData.routeDestinations);
        }
        _newHoverManager() {
          this.hoverManager = new to(), this.hoverManager.init({
            switchQualifierMethod: this._switchQualifiersFromFeatures.bind(this),
            findFeature: this._findFeature.bind(this)
          });
        }
        _newPolygonManager() {
          this.polygonsManager = new yr({
            logger: this.settings.loggerFactory("PolygonRepository"),
            findFeature: this._findFeature.bind(this),
            addPolygonsOnMap: this.addPolygonsOnMap.bind(this),
            removePolygonsOnMap: this.removePolygonsOnMap.bind(this),
            asKey: this.asKey,
            polygons: this.mapData.polygons,
            polygonStyles: this.settings.polygonStyles
          });
        }
        _updateTilesConfig() {
          var e;
          this.features.allExceptClusters().forEach(e => {
            e.hasUserData() ? e.hasTileData() && e.removeTileData() : this.features.delete(e.id, e.type);
          });
          const {
              sw: t,
              ne: i
            } = this.getBounds(),
            {
              width: r,
              height: n
            } = this.getTileDim(),
            s = this.getZoom(),
            o = $i(t[0], t[1], i[0], i[1], s, r, n);
          null === (e = this.tilesLoader) || void 0 === e || e.instantiateTilesProvider(this.settings), o.forEach(e => {
            let {
              x: t,
              y: i
            } = e;
            return setTimeout(() => {
              var e;
              return null === (e = this.tilesLoader) || void 0 === e ? void 0 : e.loadTile(t, i, Math.floor(s));
            }, 10);
          });
        }
        _newCollisionManagement(e) {
          this.collisionManagement = new An(), e && this._initializeCollisionManagement(this.collisionManagement);
        }
        _getMarkerSizeOnScreen(e) {
          const t = e.marker;
          if (t.size) return t.size;
          {
            const i = this.getMarkerElement(e),
              {
                clientWidth: r,
                clientHeight: n
              } = i;
            let s = {
              width: r,
              height: n
            };
            if (0 === r || 0 === n) {
              const {
                width: e,
                height: t
              } = ct(i, this.clonesDivForMeasure);
              s = {
                width: e,
                height: t
              };
            }
            return 0 === s.width && 0 === s.height || (t.size = s), s;
          }
        }
        _getRectOfMarker(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            i = arguments.length > 2 ? arguments[2] : void 0;
          const r = dt(this.node),
            {
              width: n,
              height: s
            } = this._getMarkerSizeOnScreen(e),
            {
              top: o,
              left: a,
              width: l,
              height: u
            } = this.getMarkerElement(e).getBoundingClientRect();
          let h,
            d = !1;
          if (0 === o && 0 === a && 0 === l && 0 === u) d = !0, h = i(r);else {
            const {
              top: e,
              left: t
            } = this.node.getBoundingClientRect();
            h = {
              x: a - t + n / 2,
              y: o - e + s / 2
            };
          }
          return ni(h, n + 2 * t, s + 2 * t, d && "cluster" !== e.type ? void 0 : r);
        }
        _initializeCollisionManagement(e) {
          e.init({
            mapContainer: this.node,
            asKey: this.asKey.bind(this),
            getMarkerElement: this.getMarkerElement.bind(this),
            getRectOfMarker: this.getRectOfMarker.bind(this),
            moveMarkerPosition: this.moveMarkerPosition.bind(this),
            makeMarkerVisible: this._makeMarkerVisible.bind(this),
            settings: this.settings
          });
        }
        _newClusterers() {
          this.clusterers = this.clusterFactory.createClusterers(this.settings.loggerFactory, this.settings.getI18N, this.settings.iso4217CurrencyCode, this.settings.locale, this.settings.clusterConfigurationByType, this.settings.clusterDefaultConfigurationByType);
        }
        updateConfiguration(e, t, i) {
          this.configHelper = e, this.settings = t;
          const {
              clearHashkeys: r,
              updateMarkers: n,
              updateViewport: s,
              updateMapProviderConfig: o,
              updateKeyboardA11yUI: a,
              updateStyling: l,
              updateTiles: u,
              resetAvailabilityCheck: h,
              resetClusterers: d,
              resetCollisionManagement: c,
              updateBaseMapMarkersClickManagement: p,
              resetContentProviders: f,
              resetRouteManagement: g,
              resetPolygonManagement: m
            } = i,
            y = !0;
          if (u && this._updateTilesConfig(), r && this.clearHashkeys(), h && this._newAvailabilityCheck(), d && this._newClusterers(), g) {
            var v;
            const e = null === (v = this.routes) || void 0 === v ? void 0 : v.listRegisteredRoutes();
            this.resetRouteStyle(), this._newRouteManager(), this.syncRegisteredRoutes(e), this.updateRoutesOnViewport();
          }
          return m && (this.resetRouteStyle(), this._newPolygonManager(), this.updateRoutesOnViewport()), f && (this._newContentProviders(), this._newBaseMapMarkersClickManagement()), c && this._newCollisionManagement(y), a && this._newKeyboardFeatures(y), l && this._addCssStyleFromConfig(this.settings.styling), p && this.baseMapMarkersClickManagement.updateConfiguration(this.settings.loggerFactory("BaseMapMarkersClickManagement"), this.settings.locale, this.settings.baseMapMarkersClick, this.contentProvidersManager, this.settings.actionsOnMarkerClick), o && this.updateMapProviderConfig(), Ii.getDebugConfigEnabled() && console.debug("Configurations updated", this.configHelper.getEGMapConfigurations()), n && this.clearMarkers(), s ? this._updateViewport() : Promise.resolve();
        }
        updateRoutesOnViewport() {
          var e;
          null === (e = this.routes) || void 0 === e || e.updateRoutesOnViewport();
        }
        syncRegisteredRoutes() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          e && e.forEach(e => {
            var t;
            return null === (t = this.routes) || void 0 === t ? void 0 : t.registerRoute(e.origin, e.destination, e.polyline);
          });
        }
        initMap(e, t, i, r) {
          this.logger.debug("map is initializing");
          const n = Date.now();
          this.node = e, this.clonesDivForMeasure = me(this.uniqId("clonesDiv"), document.body, void 0, "position: absolute; top: -9999px; left: -9999px"), this.cssClassId = t, this.idPrefix = `${this.node.id}_`, this._addCssStyleFromConfig(this.settings.styling), this.collisionManagement && this._initializeCollisionManagement(this.collisionManagement);
          const s = i,
            o = null == s ? void 0 : s.options,
            a = null == o ? void 0 : o.gaiaId;
          return Ii.getDebugConfigEnabled() && console.debug("Configurations used", this.configHelper.getEGMapConfigurations()), this._loadHistoricalBoundingBox(a).then(() => this.init(i, r)).then(() => this._lateInit()).then(() => {
            this.logger.debug(`map initialized in ${Date.now() - n}ms`);
          });
        }
        _lateInit() {
          const e = tr([...new Set([...nr(this.settings.icons), ...rr(this.settings.cornerIcons), ...rr(this.settings.innerIcons)])]);
          return this._newPolygonManager(), ir(e, this.addEventListener.bind(this), this.logger).then(() => {
            this.keyboardFeatures && this._initializeKeyboardFeatures(this.keyboardFeatures);
          });
        }
        createCopyrightsDiv() {
          const e = me(this.uniqId("copyrights-div"), this.node, "copyrights");
          return je(this.copyrightsDiv), e;
        }
        uniqId(e) {
          return this.idPrefix + e;
        }
        _loadHistoricalBoundingBox(e) {
          return e ? Li(this.settings.historicalBoundingBoxDataEndpoint, 5e3).then(t => t.ok ? t.json().then(t => {
            if (t.errors) return this.logger.error(`Failed to fetch historical bounding box data for gaia Id: ${e} - ${t.errors}`), Promise.resolve();
            const i = t.find(t => t.gaia_id === e.toString());
            return null != i && i.historical_polygon_wkt && (this.historicalBoundingBox = Ht(i.historical_polygon_wkt)), Promise.resolve();
          }) : Promise.resolve()) : Promise.resolve();
        }
        _computeNativeBounds(e, t, i) {
          var r;
          const n = this.node && 0 !== (null === (r = this.node) || void 0 === r ? void 0 : r.clientWidth) ? this.node.clientHeight / this.node.clientWidth : 1,
            s = (null == i ? void 0 : i.centeredOn) ? this.boundsComputation.computeCenteredBoundingBox(e, i, n) : this.boundsComputation.computeBoundingBox(e, t, i, this.historicalBoundingBox, n);
          return this.computeNativeBoundsFromLatLongs(s);
        }
        _parseClientPadding(e) {
          try {
            if (this.node) return Wt(e, this.node);
          } catch (e) {
            this.logger.error(e.message, e.stack);
          }
        }
        boundsContaining(e, t, i) {
          const r = null == i ? void 0 : i.gaiaId,
            n = Ft(e);
          return r ? this._loadHistoricalBoundingBox(r).then(() => this.asBounds(this._computeNativeBounds(n, t, i))) : Promise.resolve(this.asBounds(this._computeNativeBounds(n, t, i)));
        }
        boundsContainingPolygon(e) {
          const t = Ft(Ji(e).flat(2));
          return this.asBounds(this._computeNativeBounds(t, !1));
        }
        _computeStrictBounds(e) {
          return this.asBounds(this.computeNativeBoundsFromLatLongs(Ft(e)));
        }
        handleBoundsChanged(e) {
          if (this.logger.debug("bounds changed", e), this.boundChangedDisabled) this.boundChangedDisabled = !1;else {
            const t = this.getBounds();
            if (t) return this._updateViewport().then(() => {
              const i = {
                bounds: t,
                zoom: this.getZoom(),
                originalEvent: e
              };
              this.eventsManager.pushEvent(dr.boundsChanged, i);
            });
          }
          return Promise.resolve();
        }
        getCirclePolygonData(e) {
          const t = oo(this.settings.obfuscatePrecision[e.type], e.hashKeys),
            i = oo(this.settings.obfuscateRadiusInMeters[e.type], e.hashKeys);
          return k([e.latLng[1], e.latLng[0]], i / 1e3, {
            units: "kilometers",
            steps: t
          }).geometry.coordinates[0].map(e => ({
            lat: e[1],
            lng: e[0]
          }));
        }
        setStay(e) {
          var t;
          if (!function (e) {
            return void 0 !== e.from && void 0 !== e.to && e.roomOccupancies.length > 0 && e.roomOccupancies.every(e => function (e) {
              return e.nbAdults > 0;
            }(e));
          }(e)) throw new Error("stay is not valid");
          null !== (t = this.availabilityCheck) && void 0 !== t && t.saveStay(e) && (this.cleanAvailabilityTileData(this.features.allProperties()), this._updateViewport());
        }
        _addCssStyleFromConfig(e) {
          this.currentStyleId && (this.logger.debug("remove current inline style", this.currentStyleId), de(this.currentStyleId)), e && Object.keys(e).length > 0 && this.cssClassId ? (this.currentStyleId = this.uniqId("style"), ht(this.currentStyleId, "EgMapsStyling", this.cssClassId, e), this.logger.debug(`new inline style added with id ${this.currentStyleId}`, e)) : (this.logger.debug("no inline style to add"), this.currentStyleId = void 0);
        }
        cleanAvailabilityTileData(e) {
          e.forEach(e => {
            e.hasTileData() && (e.tileData.status = "unknown", e.tileData.price = void 0);
          });
        }
        refresh() {
          return this._updateViewport();
        }
        updateAvailability(e) {
          var t;
          const i = this._newFixMarkerToUse();
          return null === (t = this.availabilityCheck) || void 0 === t ? void 0 : t.updateAvailability(e).then(e => e.forEach(e => i(e)));
        }
        getBounds() {
          const e = this.nativeBounds();
          return this.asBounds(e);
        }
        handleMapClick(e) {
          if (this.logger.debug("map click"), !0 === this.ignoreMapClickEvent) return void (this.ignoreMapClickEvent = !1);
          this.settings.actionsOnMapClick.includes("removeAriaLive") && this._updateAriaLiveOnFeature(this._getFeatureSelected(), !1), this.settings.actionsOnMapClick.forEach(e => {
            var t;
            switch (e) {
              case "clearHighlight":
                this.dehighlightFeatures();
                break;
              case "clearSelection":
                this.setSelectedFeature(void 0, this.settings.actionsOnMarkerClick, true);
                break;
              case "closePopup":
                this._closePopup();
                break;
              case "hideRoutes":
                null === (t = this.routes) || void 0 === t || t.hideRoutes();
            }
          }), e && this.eventsManager.pushEvent(dr.mapClicked, e);
        }
        _updateAriaLiveOnFeature(e, t) {
          var i;
          e && (t ? e.marker && Le(e.marker.ariaElement) && Ie(e.marker.ariaElement) : De(null === (i = e.marker) || void 0 === i ? void 0 : i.ariaElement));
        }
        handleClick(e, t, i, r) {
          let n = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
            s = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
            o = e;
          if (o || t || !this.popup || (o = this.popup.feature), o && (o.visible || !n) && o.type) {
            const e = this.isFeatureSelected(o),
              t = this._isFeatureHighlighted(o),
              r = oo(i[o.type], o.hashKeys),
              n = !0;
            if (r.forEach(i => {
              var r;
              switch (i) {
                case "highlight":
                  t || this._setHighlightedFeature(o);
                  break;
                case "select":
                  this.setSelectedFeature(o, this.settings.actionsOnMarkerClick, n);
                  break;
                case "toggleSelect":
                  this.setSelectedFeature(e ? void 0 : o, this.settings.actionsOnMarkerClick, n);
                  break;
                case "openPopup":
                  this._openPopup(o);
                  break;
                case "closePopup":
                  this._closePopup();
                  break;
                case "zoomToExtent":
                  this._zoomToExtent(o);
                  break;
                case "showRoutes":
                  null === (r = this.routes) || void 0 === r || r.showRoutes(o);
                  break;
                case "loadFeatureContent":
                  e || this.loadFeatureContent(o.toData(), !0, !0);
                  break;
                case "markPreviouslySelected":
                  this.markFeaturePreviouslySelected(o);
              }
            }), r.includes("addAriaLive")) {
              const t = o;
              e ? r.includes("toggleSelect") && this._updateAriaLiveOnFeature(t, !1) : this._updateAriaLiveOnFeature(t, !0);
            }
            r.includes("bounce") && ms(o.marker), s && this._updateViewport();
          }
        }
        bounceMarker(e, t) {
          const i = this._findFeature(e, t);
          null != i && i.marker && ms(i.marker);
        }
        asKey(e) {
          let {
            id: t,
            type: i
          } = e;
          return `${i}-${t}`;
        }
        _setPopupVisible(e) {
          var t, i;
          e ? $e(null === (t = this.popup) || void 0 === t ? void 0 : t.visibleElement) : je(null === (i = this.popup) || void 0 === i ? void 0 : i.visibleElement);
        }
        _findFeature(e, t) {
          return this.features.find(e, t);
        }
        _findClusterContainingFeature(e, t) {
          return this.features.allClusters().find(i => i.children.some(i => i.id === e && i.type === t));
        }
        setPopupContent(e, t, i) {
          let r = this._findFeature(e, t);
          r && (r.popupContent = i);
        }
        _openPopup(e) {
          if (this.popup) {
            var t;
            const {
              name: i
            } = e || {};
            if (e && void 0 === e.popupContent && i) {
              const t = me(this.uniqId("popup-div"), void 0, "default-popup-content");
              Me(this.uniqId("popup-span"), t, void 0, void 0, i), e.popupContent = t;
            }
            if (void 0 !== this.popup.feature && this.popup.feature === e || (this.popup.feature = e), null !== (t = this.popup.feature) && void 0 !== t && t.popupContent) {
              this._fillPopupContent(this.popup.feature), this._setPopupVisible(!0), this.updatePopupPositionOnLayer();
              const e = this.configHelper.popupVisibilities()[this.popup.feature.type];
              oo(e, this.popup.feature.hashKeys) && this.ensurePopupVisibility();
            } else this._fillPopupContent(), this._setPopupVisible(!1);
          }
        }
        _calculatePopupVisibilityOffsetValues(e, t, i, r, n, s, o, a) {
          let l = 0,
            u = 0;
          return e.x < -0 + t ? l = e.x + 0 - t : e.x + s + 0 + t > r && (l = e.x + s + 0 + t - r), a ? e.y < -2 + i + o ? u = e.y + 2 - i - o : e.y + 2 + i > n && (u = e.y + 2 + i - n) : e.y < -2 + i ? u = e.y + 2 - i : e.y + o + 2 + i > n && (u = e.y + o + 2 + i - n), [l, u];
        }
        _closePopup() {
          this.popup && (delete this.popup.feature, this._fillPopupContent(), this._setPopupVisible(!1));
        }
        _fillPopupContent(e) {
          if (this.popup) if (he(this.popup.content), e && e.popupContent) {
            this.popup.content.appendChild(e.popupContent);
            const t = this.popup.backupStyleClass,
              i = oo(this.settings.popupPositions[e.type], e.hashKeys),
              r = [e.type, e.status, i];
            e.qualifiers && r.push(...e.qualifiers), this.popup.backupStyleClass = r, Je(this.popup.cssElement, t, this.popup.backupStyleClass);
          } else {
            const e = this.popup.backupStyleClass;
            this.popup.backupStyleClass = void 0, Je(this.popup.cssElement, e, this.popup.backupStyleClass);
          }
        }
        fillPopupExternally(e, t) {
          e.popupContent = t, this._openPopup(e);
        }
        isFeatureSelected(e) {
          var t, i;
          return void 0 !== e && (null === (t = this.mapData.selectedFeature) || void 0 === t ? void 0 : t.id) === (null == e ? void 0 : e.id) && (null === (i = this.mapData.selectedFeature) || void 0 === i ? void 0 : i.type) === (null == e ? void 0 : e.type);
        }
        getFeatureSelected() {
          var e;
          return null === (e = this._getFeatureSelected()) || void 0 === e ? void 0 : e.toData();
        }
        _getFeatureSelected() {
          if (this.mapData.selectedFeature) {
            const {
              id: e,
              type: t
            } = this.mapData.selectedFeature;
            return this._findFeature(e, t);
          }
        }
        setSelectedFeature(e, t, i) {
          const r = (n = t, e => ({
            hideRoute: Zs(n[e.type], e.hashKeys).some(e => "showRoutes" === e),
            dehighlight: Zs(n[e.type], e.hashKeys).some(e => "highlight" === e),
            removeAriaLive: Zs(n[e.type], e.hashKeys).some(e => "addAriaLive" === e)
          }));
          var n;
          if (this.isFeatureSelected(e)) return;
          const s = this._getFeatureSelected();
          if (e) {
            const {
              id: t,
              type: i
            } = e;
            this.mapData.selectedFeature = {
              id: t,
              type: i
            };
          } else this.mapData.selectedFeature = void 0;
          if (null != s && s.marker) {
            const {
                status: e,
                qualifiers: t,
                type: i
              } = s,
              r = ao(e, !1, t),
              n = this.configHelper.markersShow()[i];
            if (oo(n, r)) {
              const e = oo(this.settings.zIndexes[s.type], r);
              gs(s.marker, e);
            } else this._makeMarkerVisible(s, !1);
          }
          if (e) {
            const {
                status: t,
                type: i,
                qualifiers: r,
                hashKeys: n
              } = e,
              s = ao(t, !0, r);
            if (e.marker) {
              const t = oo(this.settings.zIndexes[e.type], s);
              gs(e.marker, t);
            } else {
              const t = this.configHelper.markersShow()[i];
              oo(t, n) && this._makeMarkerVisible(e, !0);
            }
          }
          if (s) {
            const {
              hideRoute: e = !1,
              dehighlight: t = !1,
              removeAriaLive: i = !1
            } = r(s);
            var o;
            if (e) null === (o = this.routes) || void 0 === o || o.hideRoutes(s);
            t && this._dehighlightFeature(s), i && this._updateAriaLiveOnFeature(s, !1);
          }
          if ((e || s) && i) {
            let t;
            const i = this.fillPopupExternally.bind(this, e);
            e ? t = {
              action: "select",
              feature: e.toData(),
              setPopupContent: i,
              previousSelectedFeature: null == s ? void 0 : s.toData()
            } : s && (t = {
              action: "clearSelection",
              feature: s.toData(),
              setPopupContent: i
            }), this.keyboardFeatures && this._triggerUpdateKeyboardFeatures(), t && this.eventsManager.pushEvent(dr.selectionChanged, t);
          }
        }
        _triggerUpdateKeyboardFeatures() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 50;
          const t = this.keyboardFeatures;
          return new Promise(i => {
            setTimeout(() => {
              t.updateKeyboardFeatures(), i();
            }, e);
          });
        }
        _triggerHandleMarkerLabelCollision() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 100;
          return new Promise(t => {
            setTimeout(() => {
              this.collisionManagement.handleMarkerLabelCollision(this.features.all(), this.getZoom()), t();
            }, e);
          });
        }
        _zoomToFeature(e, t) {
          const {
              id: i,
              type: r
            } = e,
            n = t || this._findClusterContainingFeature(i, r);
          return n ? this._zoomToExtent(n).then(() => {
            const t = this._findClusterContainingFeature(null == e ? void 0 : e.id, null == e ? void 0 : e.type);
            return t ? this._zoomToFeature(e, t) : (this.handleBoundsChanged("clusterExtent"), Promise.resolve());
          }) : Promise.resolve();
        }
        _zoomToExtent(e) {
          const t = e.children;
          if (t && t.length > 0) {
            this._clearClusters();
            const e = t.map(e => e.latLng);
            return this.boundsContaining(e, !1).then(e => this.fitBounds(e.sw, e.ne).then(() => this.handleBoundsChanged("clusterExtent")));
          }
          return Promise.resolve();
        }
        handleKeyPress(e, t, i) {
          const {
            type: r,
            visible: n,
            hashKeys: s
          } = e || {};
          if (n && r) {
            const n = oo(t[r], s),
              o = i.toLowerCase(),
              a = n.find(e => e === o || e === `${o}!`);
            if (a) {
              const t = {
                keyCode: i,
                feature: e.toData()
              };
              if (this.eventsManager.pushEvent(dr.keyPressed, t), a.endsWith("!")) return !0;
            }
          }
          return !1;
        }
        mouseHoveringAsKey(e, t) {
          let {
            id: i,
            type: r
          } = e;
          return `${r}-${i}-mouse-${t ? "over" : "out"}`;
        }
        handleMouseOver(e, t, i, r) {
          let n = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
            s = e;
          if (s || t || !this.popup || (s = this.popup.feature), s && (s.visible || !n) && s.type) {
            const e = this.asKey(s),
              t = this.mapData.featuresOver.has(e);
            if (this.mapData.featuresOver.add(e), !t) {
              const e = oo(i[s.type], s.hashKeys);
              if (e.forEach(e => {
                switch (e) {
                  case "highlight":
                    this._setHighlightedFeature(s);
                    break;
                  case "openPopup":
                    this._openPopup(s);
                }
              }), this.hoverManager.markHover(s, !0, this.settings.actionsOnMarkerMouseOver, this.settings.actionsOnMarkerMouseOut), e.includes("sendEvent")) {
                const e = {
                  action: "mouseEnter",
                  feature: s.toData(),
                  setPopupContent: this.fillPopupExternally.bind(this, s)
                };
                this.eventsManager.pushEvent(dr.hoverChanged, e);
              }
            }
          }
        }
        handleMouseOut(e, t, i, r) {
          let n = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
            s = e;
          if (s || t || !this.popup || (s = this.popup.feature), s && (s.visible || !n) && s.type) {
            const t = this.asKey(e);
            if (this.mapData.featuresOver.has(t)) {
              this.mapData.featuresOver.delete(t);
              const e = oo(i[s.type], s.hashKeys);
              if (e.forEach(e => {
                switch (e) {
                  case "dehighlight":
                    this._dehighlightFeature(s);
                    break;
                  case "dehighlightIfNotSelected":
                    this.isFeatureSelected(s) || this._dehighlightFeature(s);
                    break;
                  case "closePopup":
                    this._closePopup();
                }
              }), this.hoverManager.markHover(s, !1, this.settings.actionsOnMarkerMouseOver, this.settings.actionsOnMarkerMouseOut), e.includes("sendEvent")) {
                const e = {
                  action: "mouseLeave",
                  feature: s.toData(),
                  setPopupContent: this.fillPopupExternally.bind(this, s)
                };
                this.eventsManager.pushEvent(dr.hoverChanged, e);
              }
            }
          }
        }
        handleDragStart() {
          this.settings.actionsOnMapDrag.includes("removeAriaLive") && this._updateAriaLiveOnFeature(this._getFeatureSelected(), !1), this.settings.actionsOnMapDrag.forEach(e => {
            var t;
            switch (e) {
              case "clearHighlight":
                this.dehighlightFeatures();
                break;
              case "clearSelection":
                this.setSelectedFeature(void 0, this.settings.actionsOnMarkerClick, true);
                break;
              case "closePopup":
                this._closePopup();
                break;
              case "hideRoutes":
                null === (t = this.routes) || void 0 === t || t.hideRoutes();
            }
          });
        }
        selectFeature(e, t, i) {
          const r = this._findFeature(e, t);
          if (r) {
            const e = oo(this.settings.actionsOnFeatureSelect[r.type], r.hashKeys),
              t = e.includes("zoomToExtentCluster") ? this._zoomToFeature(r) : Promise.resolve();
            if (r && !this.isFeatureSelected(r)) return t.then(() => {
              this.setSelectedFeature(r, this.settings.actionsOnFeatureSelect, false), i && this.setPopupContent(r.id, r.type, i), e.includes("addAriaLive") && this._updateAriaLiveOnFeature(r, !0), e.forEach(e => {
                var t;
                switch (e) {
                  case "highlight":
                    this._setHighlightedFeature(r);
                    break;
                  case "openPopup":
                    this._openPopup(r);
                    break;
                  case "closePopup":
                    this._closePopup();
                    break;
                  case "showRoutes":
                    null === (t = this.routes) || void 0 === t || t.showRoutes(r);
                    break;
                  case "loadFeatureContent":
                    this.loadFeatureContent(r.toData(), !0, !0);
                    break;
                  case "zoomToExtent":
                    this._zoomToExtent(r);
                }
              }), e.includes("bounce") && ms(r.marker);
            });
          }
          return Promise.resolve();
        }
        registerRouteDestination() {
          for (var e, t = arguments.length, i = new Array(t), r = 0; r < t; r++) i[r] = arguments[r];
          return null === (e = this.routes) || void 0 === e ? void 0 : e.registerRouteDestination(...i);
        }
        registerRoute(e, t, i) {
          var r;
          return !0 === (null === (r = this.routes) || void 0 === r ? void 0 : r.registerRoute(e, t, i));
        }
        listRegisteredRouteDestinations() {
          var e;
          return (null === (e = this.routes) || void 0 === e ? void 0 : e.listRegisteredRouteDestinations()) || [];
        }
        listRegisteredRoutes(e) {
          var t;
          return (null === (t = this.routes) || void 0 === t ? void 0 : t.listRegisteredRoutes(e)) || [];
        }
        deregisterRouteDestination() {
          for (var e, t = arguments.length, i = new Array(t), r = 0; r < t; r++) i[r] = arguments[r];
          return (null === (e = this.routes) || void 0 === e ? void 0 : e.deregisterRouteDestination(...i)) || [];
        }
        deregisterRoute(e, t) {
          var i;
          return (null === (i = this.routes) || void 0 === i ? void 0 : i.deregisterRoute(e, t)) || [];
        }
        showRoutes(e, t) {
          if (!this.routes) return Promise.reject(new Error("map is not initialized"));
          const i = this._findFeature(e, t);
          if (i) {
            for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++) n[s - 2] = arguments[s];
            return this.routes.showRoutes(i, n, !1);
          }
          return Promise.reject(new Error(`feature ${t}-${e} is not found`));
        }
        showPolygons() {
          return this.polygonsManager.showPolygons(...arguments);
        }
        hidePolygons() {
          return this.polygonsManager.hidePolygons(...arguments);
        }
        listPolygonsDisplayed() {
          return this.polygonsManager.listPolygonsDisplayed();
        }
        addQualifierToFeature(e, t) {
          for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
          return this._updateQualifierFromFeatures([{
            id: e,
            type: t
          }], function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return e.addQualifier(...i);
          }, ...r);
        }
        addQualifierToFeatures(e) {
          for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
          return this._updateQualifierFromFeatures(e, function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return e.addQualifier(...i);
          }, ...i);
        }
        removeQualifierFromFeature(e, t) {
          for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
          return this._updateQualifierFromFeatures([{
            id: e,
            type: t
          }], function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return e.removeQualifier(...i);
          }, ...r);
        }
        removeQualifierFromFeatures(e) {
          for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
          return this._updateQualifierFromFeatures(e, function (e) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return e.removeQualifier(...i);
          }, ...i);
        }
        _newFixMarkerToUse() {
          const e = this.switchMarkerType.bind(this),
            t = this.onMarkerIconsChanged.bind(this),
            i = this.addEventListener.bind(this),
            r = this.hasObfuscatedAreaStyleChanged.bind(this),
            n = this.getZoom.bind(this),
            s = this._switchAriaLabel.bind(this);
          return o => Ks(o, this.settings, this.logger, e, t, i, r, n, s);
        }
        _updateQualifierFromFeatures(e, t) {
          for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
          let s = !1;
          const o = this._newFixMarkerToUse();
          return e.forEach(e => {
            let {
              id: i,
              type: n
            } = e;
            const a = this._findFeature(i, n);
            a && t(a, ...r) && (o(a), s = !0);
          }), s ? this._updateViewport().then(() => !0) : Promise.resolve(!1);
        }
        _switchQualifiersFromFeatures(e, t, i) {
          let r = !1;
          const n = this._newFixMarkerToUse(),
            s = e ? this._findFeature(e.id, e.type) : void 0;
          s && s.removeQualifier(...i) && (n(s), r = !0);
          const o = t ? this._findFeature(t.id, t.type) : void 0;
          return o && o.addQualifier(...i) && (n(o), r = !0), r ? this._updateViewport().then(() => !0) : Promise.resolve(!1);
        }
        loadFeatureContent(e, t, i) {
          var r;
          return (null === (r = this.contentProvidersManager) || void 0 === r ? void 0 : r.loadFeatureContent(e, i).then(e => {
            let {
              contentLoaded: i,
              f: r
            } = e;
            return i && (this.createTileFeature(r, !1), t) ? this._updateViewport().then(() => i) : Promise.resolve(i);
          })) || Promise.resolve(!1);
        }
        hideRoutes(e, t) {
          if (!this.routes) return Promise.reject(new Error("map is not initialized"));
          const i = this._findFeature(e, t);
          if (i) {
            for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++) n[s - 2] = arguments[s];
            return this.routes.hideRoutes(i, n, !1);
          }
          return Promise.reject(new Error(`feature ${t}-${e} is not found`));
        }
        listRoutesDisplayed() {
          var e;
          return (null === (e = this.routes) || void 0 === e ? void 0 : e.listRoutesDisplayed()) || [];
        }
        handleTilesLoaded(e, t, i) {
          this.logger.debug(`${e} tiles loaded - ${t} - ${i}`);
          const r = {
            origin: e,
            contentType: t,
            tileIds: i
          };
          this.eventsManager.pushEvent(dr.tilesLoaded, r);
        }
        handleTilesContentLoaded(e) {
          this.eventsManager.pushEvent(dr.tilesContentLoaded, e);
        }
        addCopyright(e, t) {
          const i = ze(this.copyrightsDiv),
            r = [...this.copyrights.entries()].filter(e => {
              let [i, r] = e;
              return r.content === t;
            });
          if (r.length > 0) r[0][1].ownerIds.push(e);else {
            const r = Kt(),
              n = this.uniqId(`copyright-div-${r}`);
            this.copyrights.set(n, {
              content: t,
              ownerIds: [e]
            });
            Me(void 0, me(n, this.copyrightsDiv, "copyright"), "copyright-text", void 0, t), i || $e(this.copyrightsDiv);
          }
        }
        removeCopyrightForOwner() {
          for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
          t.forEach(e => {
            [...this.copyrights.entries()].forEach(t => {
              let [i, r] = t;
              const {
                  ownerIds: n
                } = r,
                s = n.findIndex(t => t === e);
              s >= 0 && (n.splice(s, 1), 0 == n.length && (ce(this.copyrightsDiv, i), this.copyrights.delete(i)));
            });
          });
        }
        clearSelectedFeature() {
          let e = this._getFeatureSelected();
          if (e) {
            this.setSelectedFeature(void 0, this.settings.actionsOnFeatureSelect, !1);
            const t = oo(this.settings.actionsOnFeatureDeselect[e.type], e.hashKeys);
            t.includes("removeAriaLive") && this._updateAriaLiveOnFeature(e, !1), t.forEach(t => {
              var i;
              switch (t) {
                case "dehighlight":
                  this._dehighlightFeature(e);
                  break;
                case "closePopup":
                  this._closePopup();
                  break;
                case "hideRoutes":
                  null === (i = this.routes) || void 0 === i || i.hideRoutes(e);
              }
            }), this.keyboardFeatures && this._triggerUpdateKeyboardFeatures();
          }
        }
        listHighlightedFeatures() {
          return this.mapData.highlightedFeatures.flatMap(e => {
            let {
              id: t,
              type: i
            } = e;
            const r = this._findFeature(t, i);
            if (r) return r.toData();
          });
        }
        markFeatureOver(e, t) {
          const i = this._findFeature(e, t);
          if (i) {
            const r = "cluster" !== i.type ? this._findClusterContainingFeature(e, t) : void 0;
            oo(this.settings.actionsOnFeatureOver[i.type], i.hashKeys).forEach(e => {
              switch (e) {
                case "highlight":
                  this._setHighlightedFeature(r || i);
                  break;
                case "openPopup":
                  this._openPopup(i);
              }
            }), this.hoverManager.markHover(i, !0, this.settings.actionsOnFeatureOver, this.settings.actionsOnFeatureOut);
          }
        }
        markFeatureOut(e, t) {
          const i = this._findFeature(e, t);
          if (i) {
            const r = "cluster" !== i.type ? this._findClusterContainingFeature(e, t) : null;
            oo(this.settings.actionsOnFeatureOut[i.type], i.hashKeys).forEach(e => {
              switch (e) {
                case "dehighlight":
                  this._dehighlightFeature(r || i);
                  break;
                case "dehighlightIfNotSelected":
                  this.isFeatureSelected(r || i) || this._dehighlightFeature(r || i);
                  break;
                case "closePopup":
                  this._closePopup();
              }
            }), this.hoverManager.markHover(i, !1, this.settings.actionsOnFeatureOver, this.settings.actionsOnFeatureOut);
          }
        }
        _highlightMarker(e, t) {
          e && (e.highlighted = t, e.marker && this._newFixMarkerToUse()(e));
        }
        _setHighlightedFeature(e) {
          if (!this._isFeatureHighlighted(e)) {
            const {
              id: t,
              type: i
            } = e;
            this.mapData.highlightedFeatures.push({
              id: t,
              type: i
            }), this._highlightMarker(e, !0);
          }
        }
        _dehighlightFeature(e) {
          const t = this._getFeatureHighlightIndex(e);
          t >= 0 && (this.mapData.highlightedFeatures.splice(t, 1), this._highlightMarker(e, !1));
        }
        _getFeatureHighlightIndex(e) {
          const {
            id: t,
            type: i
          } = e;
          return this.mapData.highlightedFeatures.findIndex(e => {
            let {
              id: r,
              type: n
            } = e;
            return t === r && i === n;
          });
        }
        _isFeatureHighlighted(e) {
          return this._getFeatureHighlightIndex(e) >= 0;
        }
        dehighlightFeatures() {
          const e = [];
          this.mapData.highlightedFeatures.forEach(t => {
            let {
              id: i,
              type: r
            } = t;
            const n = this._findFeature(i, r);
            !n || this.isFeatureSelected(n) && oo(this.settings.actionsOnFeatureOut[n.type], n.hashKeys).includes("dehighlightIfNotSelected") ? e.push({
              id: i,
              type: r
            }) : this._highlightMarker(n, !1);
          }), this.mapData.highlightedFeatures = e;
        }
        isFeaturePreviouslySelected(e) {
          return this.mapData.previouslySelectedFeatures.has(this.asKey(e));
        }
        markFeaturePreviouslySelected(e) {
          tt(e.marker.cssElement, "previously-selected"), this.mapData.previouslySelectedFeatures.add(this.asKey(e)), sessionStorage.setItem("__map_previously_selected_features", JSON.stringify(Array.from(this.mapData.previouslySelectedFeatures)));
        }
        turnFeaturesVisible(e, t, i) {
          let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [],
            n = arguments.length > 4 ? arguments[4] : void 0;
          this.configHelper.overrideMarkerShowConfig(e, t, i, r), n && this._updateViewport();
        }
        _createGenericPopup(e) {
          const t = me(this.uniqId("popup"), e, "popup", "visibility:false"),
            i = me(void 0, t, "popup-close-button close-button");
          me(void 0, i, "leftright"), me(void 0, i, "rightleft"), me(void 0, i, "close");
          const r = this._closePopup.bind(this);
          t.content = me(void 0, t, "popup-content");
          const n = this.updatePopupPositionOnLayer.bind(this);
          return new ResizeObserver(n).observe(t.content), t.clean = [this.addEventListener(i, lo, e => {
            var t;
            e.stopPropagation(), null !== (t = this.popup) && void 0 !== t && t.feature && this.mapData.featuresOver.delete(this.asKey(this.popup.feature)), r();
          })], t.visibleElement = void 0, t.cssElement = void 0, t;
        }
        _allClusters(e) {
          return this.features.allClusters().filter(t => {
            let {
              featureType: i
            } = t;
            return void 0 === e || e === i;
          });
        }
        _clearCluster(e) {
          this.deleteMarker(e), this.features.delete(e.id, e.type);
        }
        _clearClusters(e) {
          this._allClusters(e).forEach(e => this._clearCluster(e));
        }
        _pushClusterData(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          for (let i of e) t ? this.features.upsertUserData(i, this.configHelper) : this.features.upsertTileData(i, this.configHelper);
        }
        _notifyStatusUsageForType(e, t) {
          this.configHelper.loadQualifiersAndHashkeysUsed(e), this.features.repository(e).data.forEach(e => {
            e.refreshHashkeys();
          });
        }
        _updateViewport(e) {
          var t;
          let i = e;
          return i || (i = this.nativeBounds()), null !== (t = this.availabilityCheck) && void 0 !== t && t.isAvailabilityCheckActive() ? this._updateViewportWithAvailabilityCheck(i) : this._updateViewportAux(i);
        }
        _updateViewportAux(e) {
          this.boundsToRefresh = this.asBounds(e);
          const t = this.configHelper.markersShow(),
            i = this.configHelper.markersKeepOutOfViewport(),
            r = kn.map(r => new Promise(n => {
              this._changeMarkersVisibility(e, r, t[r], i[r]), n(void 0);
            }));
          return Promise.all(r).then(() => {
            const t = this.getBounds();
            return t && this.boundsToRefresh && Et(t, this.boundsToRefresh) && (this.keyboardFeatures && this._triggerUpdateKeyboardFeatures(), this.collisionManagement && this._triggerHandleMarkerLabelCollision()), e;
          });
        }
        _updateViewportWithAvailabilityCheck(e) {
          this.boundsToRefresh = this.asBounds(e);
          const t = [],
            i = this.configHelper.markersShow(),
            r = this.configHelper.markersKeepOutOfViewport();
          return t.push(this._updateViewportAux(e)), bn.forEach(n => {
            const s = this.features.allWithCoordinates(n).filter(t => this.isFeatureInRealBound(e, t));
            t.push(this.updateAvailability(s).then(() => {
              const t = this.getBounds();
              if (t && this.boundsToRefresh && Et(t, this.boundsToRefresh)) return this._changeMarkersVisibility(e, n, i[n], r[n]), Promise.resolve();
            }).catch(e => {
              this.logger.error(`Failed to update availabilities: ${e.message}`, e.stack);
            }));
          }), Promise.all(t).then(() => {
            const t = this.getBounds();
            return this.keyboardFeatures && t && this.boundsToRefresh && Et(t, this.boundsToRefresh) && this.keyboardFeatures.updateKeyboardFeatures(), e;
          });
        }
        _changeClusterMarkerVisibility(e, t, i, r) {
          const n = this.getBounds(),
            s = this._allClusters(e);
          let o = {
            clusters: [],
            remainingFeatures: t
          };
          this.clusterers && this.clusterers[e].forEach(t => {
            const {
              clusterer: r,
              qualifier: s
            } = t;
            if (r) try {
              var a, l, u, h;
              const t = {
                clientWidth: null !== (a = null === (l = this.node) || void 0 === l ? void 0 : l.clientWidth) && void 0 !== a ? a : 0,
                clientHeight: null !== (u = null === (h = this.node) || void 0 === h ? void 0 : h.clientHeight) && void 0 !== u ? u : 0
              };
              o = r.getClustersAndFeatures(o, e, s, n, i, t, this.getTileDim());
            } catch (e) {
              this.logger.warn(`Failed to compute cluster: ${e.message}`, e.stack);
            }
          }), this._pushClusterData(o.clusters, !1);
          const a = o.clusters.map(e => e.id);
          s.filter(e => {
            let {
              id: t
            } = e;
            return !a.includes(t);
          }).forEach(e => this._clearCluster(e));
          this._allClusters(e).filter(e => !e.marker).forEach(e => this._createMarker(e));
          const l = o.remainingFeatures.map(e => e.id);
          for (let e of t) l.includes(e.id) && (r.push(e.id), e.marker ? e.visible = !0 : this._makeMarkerVisible(e, !0));
        }
        _haveSomeClustersByFeatureType(e) {
          return void 0 !== this.clusterers && void 0 !== this.clusterers[e] && this.clusterers[e].length > 0;
        }
        _changeMarkersVisibility(e, t, i, r) {
          const n = this.getZoom(),
            {
              withMarkers: s
            } = this.mapData[t],
            {
              inBounds: o,
              outBounds: a
            } = this._identifyFeatureWithMarkerAddedToMap(e, n, t, i, r),
            l = [];
          this._haveSomeClustersByFeatureType(t) ? this._changeClusterMarkerVisibility(t, o, n, l) : o.forEach(e => {
            l.push(e.id), e.marker ? e.visible = !0 : this._makeMarkerVisible(e, !0);
          }), a.forEach(e => {
            l.push(e.id), e.marker || (this._makeMarkerVisible(e, !0), e.marker.labels.hideTextLabel(!0));
          }), s.filter(e => !l.includes(e.id)).forEach(e => this._makeMarkerVisible(e, !1));
        }
        _featureShouldHaveMarker(e, t, i, r) {
          var n;
          const s = null === (n = e.tileData) || void 0 === n ? void 0 : n.tile,
            o = s && s.length >= 3 ? s[2] : void 0,
            a = oo(i, e.hashKeys);
          return !!((void 0 === o || e.hasUserData() || o <= r) && oo(this.settings.minZoomForDisplay[e.type], e.hashKeys) <= r && a) && (!this.isFeatureInRealBound(t, e) || "inViewport");
        }
        _retrieveCandidates(e, t, i, r, n, s) {
          const o = e.length;
          let a = 0;
          for (; a < o;) {
            const o = e[a];
            a++;
            const l = this._featureShouldHaveMarker(o, t, i, n);
            if (o.inBounds = "inViewport" === l, !1 !== l) {
              !1 !== (oo(r, o.hashKeys) || "inViewport" === l) && s(o, o.inBounds);
            }
          }
        }
        _identifyFeatureWithMarkerAddedToMap(e, t, i, r, n) {
          let s = [];
          const o = {
            selected: {
              threshold: -1,
              maxZoomForCount: 1,
              inB: [],
              outB: []
            }
          };
          for (const e in this.settings.threshold[i]) {
            const t = this.settings.threshold[i][e],
              r = oo(this.settings.maxZoomForCount[i], [e]);
            o[e] = {
              threshold: t,
              maxZoomForCount: r,
              inB: [],
              outB: []
            };
          }
          this._retrieveCandidates(this.features.allWithCoordinates(i), e, r, n, t, (e, t) => oo(o, e.hashKeys)[t ? "inB" : "outB"].push(e));
          let a = [];
          for (const e in o) {
            const {
              threshold: i,
              maxZoomForCount: r,
              inB: n,
              outB: l
            } = o[e];
            n.length > 0 && (t >= r || i < 0 || n.length <= i) && (a = a.concat(n)), l.length > 0 && (t >= r || i < 0 || n.length + l.length <= i) && (s = s.concat(l));
          }
          return this.mapData[i].withMarkers = [...a, ...s], {
            inBounds: a,
            outBounds: s
          };
        }
        updateConfigHelperOnFeatures(e) {
          this.features.all().forEach(t => {
            t.updateConfigHelper(e);
          });
        }
        clearHashkeys() {
          this.features.all().forEach(e => {
            e.clearHashkeys();
          });
        }
        clearMarkers() {
          this.features.all().forEach(e => this.deleteMarker(e));
        }
        listFeatures(e, t, i, r) {
          var n;
          const s = t ? this.asNativeBounds(t.sw, t.ne) : void 0,
            o = this.features.all().filter(e => (!r || void 0 !== e.latLng) && (!s || this.isFeatureInRealBound(s, e))),
            a = i ? null === (n = this.collisionManagement) || void 0 === n ? void 0 : n.identifyMarkerCollisionOrCutOff(o.filter(e => e.marker)) : void 0,
            l = o.map(e => {
              const t = no(no({}, e.toData()), {}, {
                  visible: e.visible,
                  highlighted: e.highlighted
                }),
                i = this.asKey(e);
              if (null != a && a.has(i)) {
                const {
                  collidingFeatures: r,
                  markerCutOff: n,
                  outOfViewport: s
                } = a.get(i);
                t.marker = {
                  markerType: e.marker.markerType,
                  clickable: e.marker.clickable,
                  collidingFeatures: r,
                  markerCutOff: n,
                  outOfViewport: s
                };
              }
              return t;
            });
          return e ? l.filter(e) : l;
        }
        _listRepositoryFeatures(e, t, i) {
          const r = t ? this.asNativeBounds(t.sw, t.ne) : void 0;
          return this.features.all().filter(t => (!i || void 0 !== t.latLng) && (!r || this.isFeatureInRealBound(r, t)) && (!e || e(t)));
        }
        _removeFeatures(e) {
          this._listRepositoryFeatures(e).forEach(e => {
            this.features.delete(e.id, e.type), this.deleteMarker(e);
          });
        }
        pushFeatureData(e, t, i) {
          this.logger.debug("push feature data");
          let r = [],
            n = [],
            s = [],
            o = [];
          this._pushFeatureDataModifyFeatures(e, r, s, n);
          let a = n.concat(r);
          switch (t) {
            case "merge":
              if (s.length === e.length) return;
              break;
            case "replace":
              {
                const t = e.map(this.asKey),
                  i = this.features.allExceptClusters().filter(e => !t.includes(this.asKey(e)));
                o = this._removePushedFeatureDataAux(i, !1);
              }
              break;
            default:
              throw new Error(`action ${t} not supported`);
          }
          if (i && this._pushFeatureDataHandleEvents(a, o), this.mapData.selectedFeature && o.map(this.asKey).includes(this.asKey(this.mapData.selectedFeature)) && this.clearSelectedFeature(), a.length > 0 || o.length > 0) return this._updateViewport(), this._computeStrictBounds(a.concat(s).filter(e => void 0 !== e.latLng).map(e => e.latLng));
        }
        _pushFeatureDataModifyFeatures(e, t, i, r) {
          const n = this._newFixMarkerToUse();
          for (let s of e) {
            const e = this.features.repository(s.type).find(s.id);
            if (e) {
              if (e.isUserDataChanged(s)) {
                const e = this.features.upsertUserData(s, this.configHelper);
                n(e), t.push(e);
              } else i.push(e);
            } else {
              const e = this.features.upsertUserData(s, this.configHelper);
              n(e), r.push(e);
            }
          }
          r.length > 0 && Fi(r.map(e => this.loadFeatureContent(e, !1, !0).then(t => (this._newFixMarkerToUse()(e), t)).catch(e => this.logger.warn("Failed to load feature content", e)))).then(e => {
            e.some(e => {
              let {
                status: t,
                value: i
              } = e;
              return "fulfilled" === t && i;
            }) && this._updateViewport();
          });
        }
        updatePartiallyFeature(e) {
          const t = [],
            i = e.flatMap(e => {
              const {
                  id: i,
                  type: r
                } = e,
                n = function (e, t) {
                  if (null == e) return {};
                  var i,
                    r,
                    n = function (e, t) {
                      if (null == e) return {};
                      var i = {};
                      for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
                        if (-1 !== t.indexOf(r)) continue;
                        i[r] = e[r];
                      }
                      return i;
                    }(e, t);
                  if (Object.getOwnPropertySymbols) {
                    var s = Object.getOwnPropertySymbols(e);
                    for (r = 0; r < s.length; r++) i = s[r], -1 === t.indexOf(i) && {}.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
                  }
                  return n;
                }(e, io),
                s = this.features.repository(e.type).find(e.id);
              if (!s) return t.push(e), [];
              return no(no({}, s.toData()), n);
            });
          return this.pushFeatureData(i, "merge", !1), t;
        }
        _pushFeatureDataHandleEvents(e, t) {
          const i = [];
          if (e.length > 0) {
            const t = this._computeStrictBounds(e.filter(e => void 0 !== e.latLng).map(e => e.latLng));
            i.push({
              type: "addedOrUpdated",
              features: e.map(e => e.toData()),
              bounds: t
            });
          }
          if (t.length > 0) {
            const e = this._computeStrictBounds(t.filter(e => void 0 !== e.lat && void 0 !== e.lng).map(e => [e.lat, e.lng]));
            i.push({
              type: "removed",
              features: t,
              bounds: e
            });
          }
          if (i.length > 0) {
            const e = {
              changes: i
            };
            this.eventsManager.pushEvent(dr.markersChanged, e);
          }
        }
        removePushedFeatureData(e) {
          var t;
          let i,
            r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          if (this.logger.debug("removing pushed feature data"), this.logger.debug(e), void 0 !== e) {
            const t = e.map(e => {
              let {
                id: t,
                type: i
              } = e;
              return this.features.repository(i).find(t);
            }).filter(e => void 0 !== e);
            i = this._removePushedFeatureDataAux(t, r);
          } else {
            const e = this.features.allExceptClusters();
            i = this._removePushedFeatureDataAux(e, r);
          }
          return (null === (t = i) || void 0 === t ? void 0 : t.length) > 0 && this._updateViewport(), i;
        }
        onMarkerIconsChanged(e) {}
        _removePushedFeatureDataAux(e, t) {
          const i = [];
          for (let t of e.filter(e => e.hasUserData())) this.popup && this.popup.feature && this.popup.feature.id === t.id && this._closePopup(), this.isFeatureSelected(t) && this.clearSelectedFeature(), this.deleteMarker(t), i.push(t.toData()), t.removeUserData();
          if (i.length > 0 && t) {
            const e = this._computeStrictBounds(i.filter(e => void 0 !== e.latLng).map(e => e.latLng)),
              t = {
                changes: [{
                  type: "removed",
                  features: i,
                  bounds: e
                }]
              };
            this.eventsManager.pushEvent(dr.markersChanged, t);
          }
          return i;
        }
        createTileFeature(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          const i = this.features.insertTileData(e, this.configHelper);
          return t && this._newFixMarkerToUse()(i), i;
        }
        removeTileFeature(e) {
          return this.features.deleteTileData(e);
        }
        _makeMarkerVisible(e, t) {
          e.visible = t, t ? this._createMarker(e) : this.deleteMarker(e);
        }
        _createMarker(e, t) {
          const i = [];
          this.isFeaturePreviouslySelected(e) && i.push("previously-selected");
          const {
            common: r,
            markerType: n,
            frameIcon: s,
            text: o,
            pin: a,
            minimal: l
          } = Vs(e, this.getMarkerElement(e), this.settings, t, i);
          switch (n) {
            case "price":
              e.marker = this.createTextMarker(r, o, "price");
              break;
            case "text":
              e.marker = this.createTextMarker(r, o, "text");
              break;
            case "pin":
              e.marker = this.createPinMarker(r, a, s);
              break;
            case "obfuscate":
              e.marker = this.createObfuscatedMarker(l);
              break;
            case "pinObfuscate":
              e.marker = this.createPinObfuscatedMarker(r, a, s);
              break;
            case "priceObfuscate":
              e.marker = this.createPriceObfuscatedMarker(r, o);
              break;
            case "clusterMarker":
              e.marker = this.createClusterMarker(e);
              break;
            default:
              throw new Error(`marker type not supported: ${n}`);
          }
          e.marker.clickable = l.clickable, e.marker.markerType = n;
        }
        switchMarkerType(e, t) {
          return this.deleteMarker(e), !!e.visible && (this._createMarker(e, t), !0);
        }
        turnKeyboardFeaturesMode(e) {
          if (!this.keyboardFeatures) throw new Error("You need to enable keyboard features from config in order to use it.");
          this.keyboardFeatures.turnKeyboardFeaturesMode(e);
        }
        isKeyboardFeaturesModeEnabled() {
          var e;
          return !!this.keyboardFeatures && (null === (e = this.keyboardFeatures) || void 0 === e ? void 0 : e.isKeyboardFeaturesModeEnabled());
        }
        _switchAriaLabel(e, t, i) {
          Ls(e, t, i);
        }
        unbindAll() {
          var e;
          null === (e = this.baseMapMarkersClickManagement) || void 0 === e || e.clean();
        }
      }
      const co = {
          marker: "data:image/svg+xml,%3c!-- file: marker.svg --%3e %3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3e%3cpath fill='%23026dc5' d='M16 2.667A9.326 9.326 0 006.667 12C6.667 19 16 29.333 16 29.333S25.333 19 25.333 12A9.326 9.326 0 0016 2.667zm0 12.666a3.334 3.334 0 010-6.666 3.334 3.334 0 010 6.666z'/%3e%3c/svg%3e",
          markerHighlighted: "data:image/svg+xml,%3c!-- file: marker-hl.svg --%3e %3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3e%3cpath fill='%2354a0dd' d='M16 2.667A9.326 9.326 0 006.667 12C6.667 19 16 29.333 16 29.333S25.333 19 25.333 12A9.326 9.326 0 0016 2.667zm0 12.666a3.334 3.334 0 010-6.666 3.334 3.334 0 010 6.666z'/%3e%3c/svg%3e",
          keyboardNavigationIcon: "data:image/svg+xml,%3c!-- file: keyboard.svg --%3e %3csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24'%3e%3cpath d='M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z'/%3e%3c/svg%3e",
          leftArrowIcon: "data:image/svg+xml,%3c!-- file: left-arrow.svg --%3e %3csvg xmlns='http://www.w3.org/2000/svg' height='24' width='14'%3e%3cpath d='M9.87.613Q9.55.96 8.08 2.523 6.612 4.085 4.983 5.82q-1.628 1.736-2.95 3.125L.735 10.335q-.343.322-.54.756-.195.434-.195.88 0 .447.196.881t.539.756l1.298 1.39q1.322 1.388 2.95 3.124l3.098 3.299q1.47 1.562 1.788 1.91.686.669 1.64.669.956 0 1.617-.67t.723-1.537q.06-.868-.723-1.761l-7.518-8.06 7.665-8.06q.784-.794.723-1.712-.062-.917-.723-1.587-.784-.67-1.75-.608-.968.062-1.654.608z'/%3e%3c/svg%3e",
          rightArrowIcon: "data:image/svg+xml,%3c!-- file: right-arrow.svg --%3e %3csvg xmlns='http://www.w3.org/2000/svg' height='24' width='14'%3e%3cpath d='M4.13 23.387q.32-.347 1.789-1.91 1.469-1.562 3.098-3.298 1.628-1.736 2.95-3.125l1.298-1.389q.343-.322.54-.756.195-.434.195-.88 0-.447-.196-.881t-.539-.756l-1.298-1.39q-1.322-1.388-2.95-3.124L5.919 2.579Q4.449 1.017 4.13.67 3.445 0 2.49 0 1.534 0 .873.67T.15 2.207q-.06.868.723 1.761l7.518 8.06-7.665 8.06q-.784.794-.723 1.712.062.917.723 1.587.784.67 1.75.608.968-.062 1.654-.608z'/%3e%3c/svg%3e"
        },
        {
          FROM_BASE_MAP: po,
          FROM_BASE_MAP_NO_MARKER: fo
        } = ar,
        go = () => {
          const e = new Ci();
          return {
            mapProvider: "google-maps",
            map: {
              onMapDrag: ["clearHighlight", "clearSelection", "closePopup", "removeAriaLive"],
              onMapClick: ["clearHighlight", "clearSelection", "closePopup", "removeAriaLive"],
              mapInitWaitForTiles: !0,
              baseMapMarkersClick: {
                enabled: !1,
                createMarkerOnSelection: !1,
                waitForContent: !1
              }
            },
            googleMaps: {
              padding: 32,
              useAdvancedMarkers: !1,
              gmapsAddConfig: {
                zoom: 2,
                minZoom: 2,
                mapId: "57df04e09ffe3110",
                center: {
                  lat: 0,
                  lng: 0
                },
                gestureHandling: "greedy",
                disableDefaultUI: !1,
                zoomControl: !0,
                cameraControl: !1,
                mapTypeControl: !1,
                scaleControl: !1,
                streetViewControl: !1,
                rotateControl: !1,
                fullscreenControl: !1,
                isFractionalZoomEnabled: !0
              },
              urls: {
                api: "https://maps.googleapis.com/maps/api/js?libraries=places,geometry,marker&version=3.59"
              },
              fitBoundsAnimTime: 500,
              debouncingEventsTime: {
                centerChanged: 50,
                zoomChanged: 100
              }
            },
            mapbox: {
              accessToken: void 0,
              rtlTextPlugin: "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js",
              padding: 32,
              scaleControl: {
                ctrlEnabled: !1,
                ctrlOptions: {
                  unit: "metric"
                },
                ctrlPosition: void 0
              },
              navControl: {
                ctrlEnabled: !0,
                ctrlOptions: {},
                ctrlPosition: void 0
              },
              geoLocateControl: {
                ctrlEnabled: !1,
                ctrlOptions: {},
                ctrlPosition: void 0
              },
              fullscreenControl: {
                ctrlEnabled: !1,
                ctrlOptions: {},
                ctrlPosition: void 0
              },
              mapboxAddConf: {
                center: [0, 0],
                zoom: 1,
                fadeDuration: 100,
                style: "mapbox://styles/expedia-geo/ckfgvpedb2neq19pe9u3zg69x"
              },
              urls: {
                api: "https://api.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.js",
                css: "https://api.mapbox.com/mapbox-gl-js/v2.9.2/mapbox-gl.css",
                pluginUrls: ["https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-language/v1.0.0/mapbox-gl-language.js"]
              }
            },
            markers: {
              common: {
                collisionBuffers: {
                  low: 16,
                  medium: 128,
                  high: 192
                }
              },
              product: {
                threshold: {
                  default: 200
                },
                maxZoomForCount: {
                  default: 15
                },
                minZoomForDisplay: {
                  default: 9
                },
                actionOnFeatureSelect: {
                  default: ["bounce", "highlight", "showRoutes", "addAriaLive"]
                },
                actionOnFeatureDeselect: {
                  default: ["dehighlight", "hideRoutes", "removeAriaLive"]
                },
                actionOnFeatureOver: {
                  default: ["highlight"]
                },
                actionOnFeatureOut: {
                  default: ["dehighlightIfNotSelected"]
                },
                actionOnClick: {
                  default: ["select", "highlight", "showRoutes", "addAriaLive"]
                },
                actionOnMouseOver: {
                  default: ["sendEvent"]
                },
                actionOnMouseOut: {
                  default: ["sendEvent"]
                },
                keyNameForKeyPressEvent: {
                  default: ["enter", "space"]
                },
                tagCollidingMarkers: {
                  default: !1
                },
                tagCutOffMarkers: {
                  default: !1
                },
                collisionBufferVariation: {
                  default: "none"
                },
                show: {
                  default: !1,
                  available: !0,
                  filtered: !1,
                  sold_out: !1,
                  unknown: !1
                },
                clickable: {
                  default: !0
                },
                keepOutOfViewport: {
                  default: !0
                },
                clustering: {
                  default: {
                    type: "none",
                    minPoints: 2,
                    minZoom: 0,
                    maxZoom: 15,
                    labelKey: kr.defaultClusterProductLabel,
                    superclusterSettings: {
                      radius: 105
                    },
                    excludedQualifiers: []
                  }
                },
                zIndex: {
                  default: 1,
                  hl: 6,
                  available: 5,
                  filtered: 4,
                  sold_out: 3
                },
                tabIndex: {
                  default: 0,
                  available: 0,
                  filtered: 1,
                  sold_out: 2,
                  unknown: 3
                },
                markerType: {
                  default: "pin",
                  available: "price",
                  filtered: "pin"
                },
                icons: {
                  default: co.marker,
                  hl: co.markerHighlighted
                },
                cornerIcons: {
                  topLeft: {
                    default: "none"
                  },
                  topRight: {
                    default: "none"
                  },
                  bottomLeft: {
                    default: "none"
                  },
                  bottomRight: {
                    default: "none"
                  }
                },
                frameIcons: {
                  default: "none"
                },
                innerIcons: {
                  left: {
                    default: "none"
                  },
                  right: {
                    default: "none"
                  }
                },
                popup: {
                  position: {
                    default: "above"
                  },
                  ensureVisibility: {
                    default: !1
                  },
                  visibilityPadding: {
                    default: {
                      x: 20,
                      y: 20
                    }
                  },
                  actionOnClick: {
                    default: []
                  },
                  actionOnMouseOver: {
                    default: []
                  },
                  actionOnMouseOut: {
                    default: []
                  }
                },
                obfuscateMarkers: {
                  precision: {
                    default: 100
                  },
                  style: {
                    default: {
                      line: {
                        weight: 1,
                        color: "#616161",
                        opacity: 1
                      },
                      fill: {
                        color: "#E6E6E6",
                        opacity: .3
                      }
                    },
                    hl: {
                      line: {
                        weight: 1,
                        color: "#1C598C",
                        opacity: 1
                      },
                      fill: {
                        color: "#0E77CD",
                        opacity: .5
                      }
                    }
                  },
                  radiusInM: {
                    default: 500
                  }
                },
                textLabel: {
                  show: {
                    default: !1
                  },
                  subLabel: {
                    show: {
                      default: !1
                    },
                    minZoom: {
                      default: 0
                    },
                    maxZoom: {
                      default: 22
                    },
                    maxLineLength: {
                      default: -1
                    },
                    maxLines: {
                      default: -1
                    }
                  },
                  zIndex: {
                    default: "sameAsMarker"
                  },
                  minZoom: {
                    default: 0,
                    restaurant: 12
                  },
                  maxZoom: {
                    default: 22
                  },
                  position: {
                    default: "right"
                  },
                  maxLineLength: {
                    default: -1
                  },
                  maxLines: {
                    default: -1
                  },
                  dynamicPlacement: {
                    default: !1
                  }
                }
              },
              property: {
                threshold: {
                  default: 200
                },
                maxZoomForCount: {
                  default: 15
                },
                minZoomForDisplay: {
                  default: 9
                },
                actionOnFeatureSelect: {
                  default: ["bounce", "highlight", "showRoutes", "addAriaLive"]
                },
                actionOnFeatureDeselect: {
                  default: ["dehighlight", "hideRoutes", "removeAriaLive"]
                },
                actionOnFeatureOver: {
                  default: ["highlight"]
                },
                actionOnFeatureOut: {
                  default: ["dehighlightIfNotSelected"]
                },
                actionOnClick: {
                  default: ["select", "highlight", "showRoutes", "addAriaLive"]
                },
                actionOnMouseOver: {
                  default: ["sendEvent"]
                },
                actionOnMouseOut: {
                  default: ["sendEvent"]
                },
                keyNameForKeyPressEvent: {
                  default: ["enter", "space"]
                },
                tagCollidingMarkers: {
                  default: !1
                },
                tagCutOffMarkers: {
                  default: !1
                },
                collisionBufferVariation: {
                  default: "none"
                },
                show: {
                  default: !1,
                  available: !0,
                  filtered: !1,
                  sold_out: !1,
                  unknown: !1
                },
                clickable: {
                  default: !0
                },
                keepOutOfViewport: {
                  default: !0
                },
                clustering: {
                  default: {
                    type: "none",
                    minPoints: 2,
                    minZoom: 0,
                    maxZoom: 15,
                    labelKey: kr.defaultClusterPropertyLabel,
                    superclusterSettings: {
                      radius: 105
                    },
                    excludedQualifiers: []
                  }
                },
                zIndex: {
                  default: 1,
                  hl: 6,
                  available: 5,
                  filtered: 4,
                  sold_out: 3
                },
                tabIndex: {
                  default: 0
                },
                markerType: {
                  default: "pin",
                  available: "price",
                  filtered: "pin"
                },
                icons: {
                  default: co.marker,
                  hl: co.markerHighlighted
                },
                cornerIcons: {
                  topLeft: {
                    default: "none"
                  },
                  topRight: {
                    default: "none"
                  },
                  bottomLeft: {
                    default: "none"
                  },
                  bottomRight: {
                    default: "none"
                  }
                },
                frameIcons: {
                  default: "none"
                },
                innerIcons: {
                  left: {
                    default: "none"
                  },
                  right: {
                    default: "none"
                  }
                },
                popup: {
                  position: {
                    default: "above"
                  },
                  ensureVisibility: {
                    default: !1
                  },
                  visibilityPadding: {
                    default: {
                      x: 20,
                      y: 20
                    }
                  },
                  actionOnClick: {
                    default: []
                  },
                  actionOnMouseOver: {
                    default: []
                  },
                  actionOnMouseOut: {
                    default: []
                  }
                },
                obfuscateMarkers: {
                  precision: {
                    default: 100
                  },
                  style: {
                    default: {
                      line: {
                        weight: 1,
                        color: "#616161",
                        opacity: 1
                      },
                      fill: {
                        color: "#E6E6E6",
                        opacity: .3
                      }
                    },
                    hl: {
                      line: {
                        weight: 1,
                        color: "#1C598C",
                        opacity: 1
                      },
                      fill: {
                        color: "#0E77CD",
                        opacity: .5
                      }
                    }
                  },
                  radiusInM: {
                    default: 500
                  }
                },
                textLabel: {
                  show: {
                    default: !1
                  },
                  subLabel: {
                    show: {
                      default: !1
                    },
                    minZoom: {
                      default: 0
                    },
                    maxZoom: {
                      default: 22
                    },
                    maxLineLength: {
                      default: -1
                    },
                    maxLines: {
                      default: -1
                    }
                  },
                  zIndex: {
                    default: "sameAsMarker"
                  },
                  minZoom: {
                    default: 0
                  },
                  maxZoom: {
                    default: 22
                  },
                  position: {
                    default: "right"
                  },
                  maxLineLength: {
                    default: -1
                  },
                  maxLines: {
                    default: -1
                  },
                  dynamicPlacement: {
                    default: !1
                  }
                }
              },
              place: {
                threshold: {
                  default: 100
                },
                maxZoomForCount: {
                  default: 10
                },
                minZoomForDisplay: {
                  default: 11
                },
                actionOnFeatureSelect: {
                  default: ["bounce", "highlight", "addAriaLive"]
                },
                actionOnFeatureDeselect: {
                  default: ["dehighlight", "removeAriaLive"]
                },
                actionOnFeatureOver: {
                  default: ["highlight"]
                },
                actionOnFeatureOut: {
                  default: ["dehighlightIfNotSelected"]
                },
                actionOnClick: {
                  default: ["select", "highlight", "addAriaLive"],
                  [fo]: ["select"]
                },
                actionOnMouseOver: {
                  default: ["sendEvent"]
                },
                actionOnMouseOut: {
                  default: ["sendEvent"]
                },
                keyNameForKeyPressEvent: {
                  default: ["enter", "space"]
                },
                tagCollidingMarkers: {
                  default: !1
                },
                tagCutOffMarkers: {
                  default: !1
                },
                collisionBufferVariation: {
                  default: "none"
                },
                show: {
                  default: !1,
                  [po]: !1,
                  [`${po}#${fo}`]: !1,
                  [`${po}#${fo}#hl`]: !1,
                  [`${po}#hl`]: !0
                },
                clickable: {
                  default: !0
                },
                keepOutOfViewport: {
                  default: !1
                },
                clustering: {
                  default: {
                    type: "none",
                    minPoints: 2,
                    minZoom: 0,
                    maxZoom: 15,
                    labelKey: kr.defaultClusterPlaceLabel,
                    superclusterSettings: {
                      radius: 105
                    },
                    excludedQualifiers: []
                  }
                },
                zIndex: {
                  default: 1,
                  hl: 6
                },
                tabIndex: {
                  default: 0
                },
                markerType: {
                  default: "pin"
                },
                icons: {
                  default: co.marker,
                  hl: co.markerHighlighted
                },
                cornerIcons: {
                  topLeft: {
                    default: "none"
                  },
                  topRight: {
                    default: "none"
                  },
                  bottomLeft: {
                    default: "none"
                  },
                  bottomRight: {
                    default: "none"
                  }
                },
                frameIcons: {
                  default: "none"
                },
                innerIcons: {
                  left: {
                    default: "none"
                  },
                  right: {
                    default: "none"
                  }
                },
                popup: {
                  position: {
                    default: "above"
                  },
                  ensureVisibility: {
                    default: !1
                  },
                  visibilityPadding: {
                    default: {
                      x: 20,
                      y: 20
                    }
                  },
                  actionOnClick: {
                    default: []
                  },
                  actionOnMouseOver: {
                    default: []
                  },
                  actionOnMouseOut: {
                    default: []
                  }
                },
                textLabel: {
                  show: {
                    default: !1,
                    [`${po}#hl`]: !0
                  },
                  subLabel: {
                    show: {
                      default: !1
                    },
                    minZoom: {
                      default: 0
                    },
                    maxZoom: {
                      default: 22
                    },
                    maxLineLength: {
                      default: -1
                    },
                    maxLines: {
                      default: -1
                    }
                  },
                  zIndex: {
                    default: "sameAsMarker"
                  },
                  minZoom: {
                    default: 0
                  },
                  maxZoom: {
                    default: 22
                  },
                  position: {
                    default: "right",
                    [`${po}#hl`]: "below"
                  },
                  maxLineLength: {
                    default: 20
                  },
                  maxLines: {
                    default: 3
                  },
                  dynamicPlacement: {
                    default: !1
                  }
                }
              },
              cluster: {
                actionOnClick: {
                  default: ["zoomToExtent"]
                },
                actionOnFeatureSelect: {
                  default: ["zoomToExtent"]
                },
                actionOnFeatureOver: {
                  default: ["highlight"]
                },
                actionOnFeatureOut: {
                  default: ["dehighlight"]
                },
                actionOnMouseOver: {
                  default: ["sendEvent"]
                },
                actionOnMouseOut: {
                  default: ["sendEvent"]
                },
                keyNameForKeyPressEvent: {
                  default: ["enter", "space"]
                },
                tagCollidingMarkers: {
                  default: !1
                },
                tagCutOffMarkers: {
                  default: !1
                },
                collisionBufferVariation: {
                  default: "none"
                },
                clusterMarkerCollisionAvoidance: {
                  moveCollidingClusterMarkers: {
                    default: !1
                  },
                  clusterMarkerCollisionBufferInPixels: {
                    default: 5
                  }
                },
                zIndex: {
                  default: 1,
                  hl: 6,
                  unknown: 2
                },
                tabIndex: {
                  default: 0
                },
                textLabel: {
                  show: {
                    default: !1
                  },
                  zIndex: {
                    default: "sameAsMarker"
                  },
                  minZoom: {
                    default: 0
                  },
                  maxZoom: {
                    default: 22
                  },
                  position: {
                    default: "right"
                  }
                }
              }
            },
            polygons: {
              product: {
                style: {
                  default: {
                    fill: {
                      color: "#AA3333",
                      opacity: .15
                    },
                    line: {
                      weight: 1,
                      color: "#000000",
                      opacity: 1
                    }
                  }
                }
              },
              property: {
                style: {
                  default: {
                    fill: {
                      color: "#AA3333",
                      opacity: .15
                    },
                    line: {
                      weight: 1,
                      color: "#000000",
                      opacity: 1
                    }
                  }
                }
              },
              place: {
                style: {
                  default: {
                    fill: {
                      color: "#AA3333",
                      opacity: .15
                    },
                    line: {
                      weight: 1,
                      color: "#000000",
                      opacity: 1
                    }
                  }
                }
              }
            },
            tiles: {
              enabled: {
                product: [],
                property: [],
                place: []
              },
              providers: {
                egPois: {
                  type: "eg",
                  tilesetId: "pois",
                  url: "https://www.expedia.com/eg-tile-server",
                  query: "",
                  timeout: 2e3
                }
              },
              minZoomForTileRequest: 8,
              cache: {
                maxSize: -1,
                maxDistance: 30
              }
            },
            contentProvider: {
              product: {
                default: []
              },
              property: {
                default: []
              },
              place: {
                default: []
              },
              providers: {
                PoiGooglePlacesApi: {
                  type: "GooglePlacesApi",
                  fields: ["displayName"],
                  callType: "rest",
                  restUrl: "https://places.googleapis.com/v1/places/",
                  restPhotoUrl: "https://places.googleapis.com/v1/",
                  restContentTimeout: 2e3,
                  restPhotoTimeout: 2e3,
                  photos: "promise"
                }
              }
            },
            historicalBoundingBoxDataEndpoint: "https://a.travel-assets.com/travel-assets-manager/df4af43c-2db9-4868-8665-96b7042a2c98/historical_bbox_data-min.json",
            availability: {
              availabilityProvider: "none",
              availabilityProviders: {}
            },
            locale: "en-US",
            iso4217CurrencyCode: "USD",
            routes: {
              egDistances: void 0,
              cacheInMs: 18e5,
              style: {
                driving: {
                  lineStyle: "normal",
                  color: "#000000",
                  width: 1.5,
                  opacity: .8
                },
                cycling: {
                  lineStyle: "dash",
                  color: "#000000",
                  width: 1.54,
                  opacity: .8
                },
                walking: {
                  lineStyle: "dot",
                  color: "#000000",
                  width: 1.5,
                  opacity: .8
                },
                flying: {
                  lineStyle: "dash",
                  color: "#000000",
                  width: 1.5,
                  opacity: .8
                }
              }
            },
            a11y: {
              keyboardFeatures: {
                keyboardFeaturesIcon: co.keyboardNavigationIcon
              }
            },
            logging: {
              logger: e
            },
            style: {}
          };
        },
        {
          verifyKeyIsLegal: mo
        } = t;
      class yo {
        constructor(e, t) {
          this.maxSize = e, this.maxDistance = t, this.cache = {}, this.listeners = new Set(), this.size = 0;
        }
        getTile(e, t, i) {
          return this.cache[i] && this.cache[i][e] ? this.cache[i][e][t] : void 0;
        }
        setTile(e, t, i, r) {
          const {
            cache: n
          } = this;
          n[i] || (n[i] = {}), !n[i][e] && mo(i) && mo(e) && (n[i][e] = {}), !n[i][e][t] && r ? this.size = this.size + 1 : n[i][e][t] && !r && (this.size = this.size - 1), mo(i) && mo(e) && mo(t) && (n[i][e][t] = r), this.maxSize > 0 && this.size > this.maxSize && this._expire(e, t, i);
        }
        addTilesListener(e) {
          this.listeners.add(e);
        }
        removeTilesListener(e) {
          this.listeners.delete(e);
        }
        _expire(e, t, i) {
          for (let r in this.cache) for (let n in this.cache[r]) for (let s in this.cache[r][n]) Xi(e, t, i, n, s, r) > this.maxDistance && (this.listeners.forEach(e => e(yo.EVENTS.EXPIRE, Number(n), Number(s), Number(r), this.cache[r][n][s])), delete this.cache[r][n][s], this.size = this.size - 1);
        }
      }
      yo.EVENTS = {
        EXPIRE: "expire"
      };
      class vo {
        loadTile(e, t, i, r, n) {
          return Promise.reject("not implemented");
        }
      }
      var bo = i(125);
      class ko extends vo {
        constructor(e, t) {
          super(), this.codec = new bo.EGTSCodec(), this.logger = t("EgTilesReader"), this.tilesUrlPrefix = e.url, this.query = e.query, this.tilesetId = e.tilesetId, this.queryByZoom = e.queryByZoom, this.timeout = e.timeout || 500;
        }
        loadTile(e, t, i, r, n) {
          const s = this.buildUrl(t, i, r, n);
          return this.fetchTile(s, e, t, i, r).then(e => e.success ? e.data.map(e => this.removeColonFromQualifiers(e)) : (this.logger.error(`Failed to load tile from ${e.url}: ${e.error.message}`, e.error.stack), []));
        }
        removeColonFromQualifiers(e) {
          var t;
          return e.qualifiers = null === (t = e.qualifiers) || void 0 === t ? void 0 : t.map(e => e.replace(":", "__")), e;
        }
        buildUrl(e, t, i, r) {
          const n = `/v1/tilesets/${this.tilesetId}/${i}/${e}/${t}/egmaps.pbf?locale=${r}`;
          let s = n;
          return this.queryByZoom && this.queryByZoom[i] ? s = `${n}&${this.queryByZoom[i]}` : this.query && (s = `${n}&${this.query}`), s;
        }
        fetchTile(e, t, i, r, n) {
          return Li(`${this.tilesUrlPrefix}${e}`, this.timeout, {
            referrerPolicy: "no-referrer",
            credentials: "omit"
          }).then(t => t.ok ? t.arrayBuffer() : 404 === t.status ? void 0 : Promise.reject(new Error(`Server returns error code ${t.status} when calling ${e} for tile {x: ${i}, y: ${r}, zoom: ${n}}: \n              ${t.statusText}`))).then(t => this.handleResponse(t).then(t => ({
            url: e,
            success: !0,
            data: t
          }))).catch(t => ({
            url: e,
            success: !1,
            error: t
          }));
        }
        handleResponse(e) {
          return e ? this.codec.decode(e) : Promise.resolve([]);
        }
      }
      class Mo {
        constructor(e, t, i, r, n, s, o) {
          let {
            delayBeforeRefresh: a = 100,
            delayForceRefresh: l = 2e3
          } = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : {};
          this.logger = e.loggerFactory("TilesLoader"), this.delayBeforeRefresh = a, this.delayForceRefresh = l, this.refreshRequested = Date.now(), this.lastRefresh = this.refreshRequested, this.createFeature = t, this.deleteFeature = i, this.updateViewport = r, this.handleTilesLoaded = n, this.handleTilesContentLoaded = s, this.depth = o, this.tilesInFlight = new Set(), this.instantiateTilesProvider(e);
        }
        instantiateTilesProvider(e) {
          const {
              tilesReaderConfig: t,
              tilesProvidersConfig: i,
              tilesCacheConfig: r,
              minZoomForTileRequest: n
            } = e.tiles,
            {
              locale: s
            } = e;
          this.locale = s, this.tilesProvidersConfig = {}, Object.keys(t).forEach(r => {
            t[r].forEach(t => {
              if (!this.tilesProvidersConfig[t]) {
                this.tilesProvidersConfig[t] = {
                  featureTypes: []
                };
                const r = i[t];
                switch (r && r.type || t) {
                  case "eg":
                    this.tilesProvidersConfig[t].service = new ko(r, e.loggerFactory);
                    break;
                  case "noop":
                    this.tilesProvidersConfig[t].service = new vo();
                    break;
                  default:
                    throw new Error(`Tiles provider ${t} not supported`);
                }
              }
              this.tilesProvidersConfig[t].featureTypes.push(r);
            });
          }), this.minZoomForTileRequest = n, this.tilesCache = new yo(r.maxSize, r.maxDistance), this.tilesCache.addTilesListener(this.handleCacheEvent.bind(this));
        }
        getNormalizedCoord(e, t, i) {
          const r = 1 << i;
          let n = e;
          return t < 0 || t >= r ? null : ((n < 0 || n >= r) && (n = (n % r + r) % r), {
            x: n,
            y: t
          });
        }
        registerRefreshViewport() {
          const e = Date.now();
          this.refreshRequested = e, setTimeout(() => {
            const t = Date.now();
            (this.refreshRequested === e || this.lastRefresh + this.delayForceRefresh < t) && (this.refreshRequested = t, this.lastRefresh = t, this.updateViewport());
          }, this.delayBeforeRefresh);
        }
        _getTileInFlightKey(e, t, i, r) {
          return `${e},${t},${i},${r}`;
        }
        _registerTileInFlight(e, t, i, r) {
          this.tilesInFlight.add(this._getTileInFlightKey(e, t, i, r));
        }
        _removeTileInFlight(e, t, i, r) {
          this.tilesInFlight.delete(this._getTileInFlightKey(e, t, i, r));
        }
        _areInFlightTilesDone() {
          return 0 === this.tilesInFlight.size;
        }
        _loadData(e, t, i, r, n, s, o) {
          const a = Math.pow(2, o),
            l = n + o,
            u = i * a,
            h = r * a,
            d = [];
          for (let i = 0; i < a; i++) for (let r = 0; r < a; r++) d.push(e.loadTile(t, u + i, h + r, l, s));
          return Promise.all(d).then(e => e.flat());
        }
        loadTile(e, t, i) {
          if (this.tilesProvidersConfig && Object.keys(this.tilesProvidersConfig).length > 0 && !isNaN(e) && !isNaN(t) && !isNaN(i)) {
            const r = this.getNormalizedCoord(e, t, i);
            if (null !== r && i >= this.minZoomForTileRequest) {
              if (!this.tilesCache.getTile(r.x, r.y, i)) {
                this.tilesCache.setTile(r.x, r.y, i, []);
                const n = [];
                for (let e in this.tilesProvidersConfig) {
                  const {
                    service: t,
                    featureTypes: s
                  } = this.tilesProvidersConfig[e];
                  this._registerTileInFlight(e, r.x, r.y, i);
                  for (let o of s) n.push(this._loadData(t, o, r.x, r.y, i, this.locale, this.depth).then(t => ({
                    data: t,
                    tilesProvider: e,
                    featureType: o
                  })));
                }
                return Promise.all(n).then(n => {
                  const s = [],
                    o = {};
                  n.forEach(r => {
                    let {
                      data: n,
                      tilesProvider: a,
                      featureType: l
                    } = r;
                    return n.forEach(r => {
                      r.tile = [e, t, i], s.push(this.createFeature(r)), o[a] ? o[a].includes(l) || o[a].push(l) : o[a] = [l];
                    });
                  }), this.tilesCache.setTile(r.x, r.y, i, s);
                  for (let e in this.tilesProvidersConfig) this._removeTileInFlight(e, r.x, r.y, i);
                  this._areInFlightTilesDone() && this.handleTilesContentLoaded(Object.keys(this.tilesProvidersConfig)), s.length > 0 && (this.registerRefreshViewport(), Object.keys(o).forEach(e => this.handleTilesLoaded(e, o[e].join(","), [`(${r.x}, ${r.y}, ${i})`])));
                }).catch(() => this.tilesCache.setTile(r.x, r.y, i, null));
              }
            }
          }
          return Promise.resolve();
        }
        handleCacheEvent(e, t, i, r, n) {
          if (e === yo.EVENTS.EXPIRE) this.logger.infoEnabled() && this.logger.info(`Cache expires. Deleting ${n.length} features`), n.forEach(e => this.deleteFeature(e));
        }
      }
      class Co {
        constructor(e) {
          this.configHelper = new Gs(go(), e, Mr), this.eventsManager = new cr(this.configHelper.logger("EventsManager")), this.dataRepositories = new On(this.configHelper.logger("DataRepositories")), this.mapData = uo(), this.uniqId = Kt();
        }
        _initializeProperties() {
          this.logger = this.configHelper.logger("EGMap"), this.logger.debug("initializing EGMaps");
          if ("mapbox" === this.configHelper.mapProvider()) this.mapImpl = this._createMapBox();else this.mapImpl = this._createGMaps();
        }
        _createMapBox() {
          if (this.logger.debug("creating MapBox"), "undefined" != typeof egmapsMapbox) return new egmapsMapbox.MapBox(this.configHelper, this.eventsManager, this.dataRepositories, this.mapData);
          throw new Error("You need to load '@eg-maps/mapbox' to use this map provider");
        }
        _createGMaps() {
          if (this.logger.debug("creating GMaps"), "undefined" != typeof egmapsGoogleMaps) return new egmapsGoogleMaps.GMaps(this.configHelper, this.eventsManager, this.dataRepositories, this.mapData);
          throw new Error("You need to load '@eg-maps/google-maps' to use this map provider");
        }
        initMap(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            i = arguments.length > 2 ? arguments[2] : void 0,
            r = arguments.length > 3 ? arguments[3] : void 0;
          return this.configHelper.ready().then(() => this._initMap(e, t, i, r)).then(() => {});
        }
        _cleanPreviousMapContainer(e, t) {
          const i = ne(e, ["egmaps"]);
          return i.length > 0 ? (t || this.logger.warn("This container contains some other instance of eg-maps.In order to avoid unexpected behavior the container will be cleaned."), i.forEach(e => pe(e.element)), i[0].index) : -1;
        }
        _createMapContainer(e, t, i) {
          let r = this.uniqId;
          null != e && e.id && (r = `${e.id}-${r}`);
          const n = me(r, void 0, "egmaps", void 0, i);
          t >= 0 ? ut(n, e, t) : e.appendChild(n);
          const s = this.configHelper.readParam("additionalCssClass");
          s && tt(n, s);
          return tt(n, this.configHelper.mapProvider()), n;
        }
        updateConfiguration(e) {
          var t;
          const i = this.configHelper,
            r = i.getConfigurations(),
            n = null === (t = r.parameter) || void 0 === t ? void 0 : t.externalConfigEndpoint,
            s = e.externalConfigEndpoint && e.externalConfigEndpoint === n ? r.external : void 0,
            o = new Gs(go(), e, Mr, s);
          return o.ready().then(() => {
            const e = i.loadMapSettings(),
              t = o.loadMapSettings(),
              r = Xs(e, t);
            if (Object.keys(r).filter(e => r[e]).length > 0) {
              if (this.configHelper = o, this.mapImpl.updateConfigHelperOnFeatures(this.configHelper), r.reinstantiate) {
                const e = this.mapImpl.getBounds(),
                  t = this.mapImpl.listRegisteredRoutes();
                return this.mapImpl.clearHashkeys(), this.mapImpl.clearMarkers(), this._initMap(this.originalNode, !0, e, void 0).then(e => e.refresh()).then(() => (this.mapImpl.syncRegisteredRoutes(t), this.mapImpl.updateRoutesOnViewport())).then(() => r);
              }
              return this.mapImpl.updateConfiguration(this.configHelper, t, r).then(() => r);
            }
            return {};
          });
        }
        _initMap(e, t, i, r) {
          this._initializeProperties();
          const n = this._cleanPreviousMapContainer(e, t),
            s = `style-${this.uniqId}`;
          return this.originalNode = e, this.node = this._createMapContainer(e, n, s), this.clientPadding = r, this.mapImpl.initMap(this.node, s, i, this.clientPadding).then(() => this.mapImpl);
        }
        centerAndZoomMap(e, t, i) {
          var r;
          return !0 === (null === (r = this.mapImpl) || void 0 === r ? void 0 : r.centerAndZoomMap(e, t, i));
        }
        getCenter() {
          if (this.mapImpl) return this.mapImpl.getCenter();
          throw new Error("map is not initialized");
        }
        getZoom() {
          if (this.mapImpl) return this.mapImpl.getZoom();
          throw new Error("map is not initialized");
        }
        getBounds() {
          if (this.mapImpl) return this.mapImpl.getBounds();
          throw new Error("map is not initialized");
        }
        unbindAll() {
          this.mapImpl && this.mapImpl.unbindAll(), pe(this.node);
        }
        fitLatLongs(e) {
          let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            i = arguments.length > 2 ? arguments[2] : void 0;
          return this.mapImpl ? this.mapImpl.fitLatLongs(e, t, i) : Promise.reject(new Error("map is not initialized"));
        }
        fitBounds(e, t) {
          let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
            r = arguments.length > 3 ? arguments[3] : void 0;
          return this.mapImpl ? this.mapImpl.fitBounds(e, t, i, r) : Promise.reject(new Error("map is not initialized"));
        }
        boundsContaining(e, t, i) {
          return this.mapImpl ? this.mapImpl.boundsContaining(e, t, i) : Promise.reject(new Error("map is not initialized"));
        }
        boundsContainingPolygon(e) {
          return this.mapImpl ? this.mapImpl.boundsContainingPolygon(e) : Promise.reject(new Error("map is not initialized"));
        }
        pushFeatureData(e, t) {
          if (this.mapImpl) return this.mapImpl.pushFeatureData(e, t, !1);
          throw new Error("map is not initialized");
        }
        removePushedFeatureData(e) {
          if (this.mapImpl) return this.mapImpl.removePushedFeatureData(e, !1);
          throw new Error("map is not initialized");
        }
        registerRoute(e, t, i) {
          if (this.mapImpl) return this.mapImpl.registerRoute(e, t, i);
          throw new Error("map is not initialized");
        }
        registerRouteDestination() {
          if (this.mapImpl) return this.mapImpl.registerRouteDestination(...arguments);
          throw new Error("map is not initialized");
        }
        listRegisteredRouteDestinations() {
          if (this.mapImpl) return this.mapImpl.listRegisteredRouteDestinations();
          throw new Error("map is not initialized");
        }
        listRegisteredRoutes(e) {
          if (this.mapImpl) return this.mapImpl.listRegisteredRoutes(e);
          throw new Error("map is not initialized");
        }
        deregisterRouteDestination() {
          if (this.mapImpl) return this.mapImpl.deregisterRouteDestination(...arguments);
          throw new Error("map is not initialized");
        }
        deregisterRoute(e, t) {
          if (this.mapImpl) return this.mapImpl.deregisterRoute(e, t);
          throw new Error("map is not initialized");
        }
        showRoutes(e, t) {
          if (this.mapImpl) {
            for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
            return this.mapImpl.showRoutes(e, t, ...r);
          }
          return Promise.reject(new Error("map is not initialized"));
        }
        hideRoutes(e, t) {
          if (this.mapImpl) {
            for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
            return this.mapImpl.hideRoutes(e, t, ...r);
          }
          return Promise.reject(new Error("map is not initialized"));
        }
        listRoutesDisplayed() {
          if (this.mapImpl) return this.mapImpl.listRoutesDisplayed();
          throw new Error("map is not initialized");
        }
        showPolygons() {
          return this.mapImpl ? this.mapImpl.showPolygons(...arguments) : Promise.reject(new Error("map is not initialized"));
        }
        hidePolygons() {
          return this.mapImpl ? this.mapImpl.hidePolygons(...arguments) : Promise.reject(new Error("map is not initialized"));
        }
        listPolygonsDisplayed() {
          if (this.mapImpl) return this.mapImpl.listPolygonsDisplayed();
          throw new Error("map is not initialized");
        }
        listFeatures(e, t) {
          let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
          if (this.mapImpl) return this.mapImpl.listFeatures(e, t, i, r);
          throw new Error("map is not initialized");
        }
        selectFeature(e, t, i) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.selectFeature(e, t, i);
        }
        clearSelectedFeature() {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.clearSelectedFeature();
        }
        dehighlightFeatures() {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.dehighlightFeatures();
        }
        listHighlightedFeatures() {
          if (this.mapImpl) return this.mapImpl.listHighlightedFeatures();
          throw new Error("map is not initialized");
        }
        markFeatureOver(e, t) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.markFeatureOver(e, t);
        }
        markFeatureOut(e, t) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.markFeatureOut(e, t);
        }
        getFeatureSelected() {
          if (this.mapImpl) return this.mapImpl.getFeatureSelected();
          throw new Error("map is not initialized");
        }
        setPopupContent(e, t, i) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.setPopupContent(e, t, i);
        }
        turnProductsVisible(e, t, i) {
          let r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.turnFeaturesVisible("product", e, t, i, r);
        }
        turnPropertiesVisible(e, t, i) {
          let r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.turnFeaturesVisible("property", e, t, i, r);
        }
        turnPlacesVisible(e, t, i) {
          let r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.turnFeaturesVisible("place", e, t, i, r);
        }
        addBoundChangeListener(e, t) {
          return this.eventsManager.addBoundChangeListener(e, t);
        }
        removeBoundChangeListener(e) {
          return this.eventsManager.removeBoundChangeListener(e);
        }
        deregisterBoundChangeListener(e) {
          return this.eventsManager.deregisterBoundChangeListener(e);
        }
        addMarkerChangeListener(e, t) {
          return this.eventsManager.addMarkerChangeListener(e, t);
        }
        removeMarkerChangeListener(e) {
          return this.eventsManager.removeMarkerChangeListener(e);
        }
        deregisterMarkerChangeListener(e) {
          return this.eventsManager.deregisterMarkerChangeListener(e);
        }
        addSelectionChangeListener(e, t) {
          return this.eventsManager.addSelectionChangeListener(e, t);
        }
        removeSelectionChangeListener(e) {
          return this.eventsManager.removeSelectionChangeListener(e);
        }
        deregisterSelectionChangeListener(e) {
          return this.eventsManager.deregisterSelectionChangeListener(e);
        }
        addKeyPressListener(e, t) {
          return this.eventsManager.addKeyPressListener(e, t);
        }
        removeKeyPressListener(e) {
          return this.eventsManager.removeKeyPressListener(e);
        }
        deregisterKeyPressListener(e) {
          return this.eventsManager.deregisterKeyPressListener(e);
        }
        addHoverChangeListener(e, t) {
          return this.eventsManager.addHoverChangeListener(e, t);
        }
        removeHoverChangeListener(e) {
          return this.eventsManager.removeHoverChangeListener(e);
        }
        deregisterHoverChangeListener(e) {
          return this.eventsManager.deregisterHoverChangeListener(e);
        }
        addFeatureContentLoadedListener(e, t) {
          return this.eventsManager.addFeatureContentLoadedListener(e, t);
        }
        removeFeatureContentLoadedListener(e) {
          return this.eventsManager.removeFeatureContentLoadedListener(e);
        }
        deregisterFeatureContentLoadedListener(e) {
          return this.eventsManager.deregisterFeatureContentLoadedListener(e);
        }
        addIdleListener(e, t) {
          return this.eventsManager.addIdleListener(e, t);
        }
        removeIdleListener(e) {
          return this.eventsManager.removeIdleListener(e);
        }
        deregisterIdleListener(e) {
          return this.eventsManager.deregisterIdleListener(e);
        }
        addRouteChangeListener(e, t) {
          return this.eventsManager.addRouteChangeListener(e, t);
        }
        removeRouteChangeListener(e) {
          return this.eventsManager.removeRouteChangeListener(e);
        }
        deregisterRouteChangeListener(e) {
          return this.eventsManager.deregisterRouteChangeListener(e);
        }
        addTilesLoadedListener(e, t) {
          return this.eventsManager.addTilesLoadedListener(e, t);
        }
        removeTilesLoadedListener(e) {
          return this.eventsManager.removeTilesLoadedListener(e);
        }
        deregisterTilesLoadedListener(e) {
          return this.eventsManager.deregisterTilesLoadedListener(e);
        }
        addTilesContentLoadedListener(e, t) {
          return this.eventsManager.addTilesContentLoadedListener(e, t);
        }
        removeTilesContentLoadedListener(e) {
          return this.eventsManager.removeTilesContentLoadedListener(e);
        }
        deregisterTilesContentLoadedListener(e) {
          return this.eventsManager.deregisterTilesContentLoadedListener(e);
        }
        addMapTypeChangedListener(e, t) {
          return this.eventsManager.addMapTypeChangedListener(e, t);
        }
        deregisterMapTypeChangedListener(e) {
          return this.eventsManager.deregisterMapTypeChangedListener(e);
        }
        addMapClickListener(e, t) {
          return this.eventsManager.addMapClickListener(e, t);
        }
        deregisterMapClickListener(e) {
          return this.eventsManager.deregisterMapClickListener(e);
        }
        setStay(e) {
          if (this.mapImpl) return this.mapImpl.setStay(e);
          throw new Error("map is not initialized");
        }
        refresh() {
          return this.mapImpl ? this.mapImpl.refresh() : Promise.resolve();
        }
        turnKeyboardFeaturesMode(e) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.turnKeyboardFeaturesMode(e);
        }
        isKeyboardFeaturesModeEnabled() {
          if (this.mapImpl) return this.mapImpl.isKeyboardFeaturesModeEnabled();
          throw new Error("map is not initialized");
        }
        getActiveTilesets() {
          if (this.mapImpl) return this.configHelper.getActiveTilesets();
          throw new Error("map is not initialized");
        }
        readConfigParam(e) {
          return this.configHelper.readParam(e);
        }
        getSubConfig(e) {
          return this.configHelper.subConfig(e);
        }
        getConfigurations() {
          return this.configHelper.getEGMapConfigurations();
        }
        updatePartiallyFeature(e) {
          if (this.mapImpl) return this.mapImpl.updatePartiallyFeature(e);
          throw new Error("map is not initialized");
        }
        addQualifierToFeature(e, t) {
          if (this.mapImpl) {
            for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
            return this.mapImpl.addQualifierToFeature(e, t, ...r);
          }
          throw new Error("map is not initialized");
        }
        addQualifierToFeatures(e) {
          if (this.mapImpl) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return this.mapImpl.addQualifierToFeatures(e, ...i);
          }
          throw new Error("map is not initialized");
        }
        removeQualifierFromFeature(e, t) {
          if (this.mapImpl) {
            for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++) r[n - 2] = arguments[n];
            return this.mapImpl.removeQualifierFromFeature(e, t, ...r);
          }
          throw new Error("map is not initialized");
        }
        removeQualifierFromFeatures(e) {
          if (this.mapImpl) {
            for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) i[r - 1] = arguments[r];
            return this.mapImpl.removeQualifierFromFeatures(e, ...i);
          }
          throw new Error("map is not initialized");
        }
        bounceMarker(e, t) {
          if (!this.mapImpl) throw new Error("map is not initialized");
          this.mapImpl.bounceMarker(e, t);
        }
        forceMapModeView() {
          this.mapImpl && this.mapImpl.forceMapModeView();
        }
      }
    }(), r;
  }();
});